import type { TranslationKeys } from './types';

export const ru: TranslationKeys = {
  'search.group.text': "Внутри текстов",
  'ai.tabReady': "Открыта вкладка «{name}»",
  'walls.draw': "Рисовать",
  'walls.connect': "Соединить концы",
  'walls.connectHint': "Нажми конец первой стены, затем конец второй. Первый конец переместится ко второму. Esc — отменить выбор.",
  'walls.drawHint': "Начни на свободном месте или на конце стены. Двойной клик — закончить цепочку.",
  'walls.connectChanged': "Конец стены изменился или соединение схлопнет стену. Выбери концы заново.",
  'editor.format': "Форматирование текста",
  'editor.bold': "Жирный",
  'editor.italic': "Курсив",
  'editor.heading': "Заголовок",
  'editor.list': "Список",
  'editor.quote': "Цитата",
  'editor.undo': "Отменить ввод",
  'editor.redo': "Повторить ввод",
  'editor.orderedList': "Нумерованный список",
  'editor.link': "Ссылка",
  'editor.linkTitle': "Ссылка",
  'editor.linkLabel': "Адрес",
  'editor.linkInvalid': "Только адрес http(s):// или mailto:. Пусто — убрать ссылку.",
  'studio.maps.besideLong': 'Открыть рядом',
  'studio.maps.addTitle': 'Добавить в бит',
  'studio.maps.addCampaignMap': '＋ Карта кампании…',
  'studio.note.open': 'Открыть заметку',
  'beat.next.openBeat': 'Открыть бит',
  'aiField.languages': "языки",
  'aiField.backstory': "предыстория",
  'aiField.roleplay_json': "отыгрыш",
  'aiField.playersText': "текст для игроков",
  'aiField.gmText': "заметки мастера",
  'aiField.title': "название",
  'aiField.text': "текст",
  'aiField.completed': "выполнено",
  'ai.results.history': "История правок",
  'ai.results.historyHint': "Результаты этого разговора, включая скрытые. Доступность отмены ограничена журналом кампании.",
  'ai.results.empty': "В этом разговоре ещё нет правок.",
  'ai.results.saved': "Сохранено в кампании",
  'ai.results.noChanges': 'Выполнено без изменений',
  'ai.results.partial': "Часть изменений отменена",
  'ai.results.kept': "Ручные правки сохранены",
  'ai.results.details': "Подробности",
  'ai.results.open': "Открыть результат",
  'ai.results.menu': "Действия с результатом",
  'ai.results.hide': "Скрыть из ленты",
  'ai.results.restore': "Вернуть в ленту",
  'ai.results.hidden': "Скрыто из ленты на этом устройстве",
  'ai.results.undo': "Отменить изменения…",
  'ai.results.undoTitle': "Отменить изменения в кампании?",
  'ai.results.undoBody': "Это изменит данные кампании. Чтобы только убрать карточку, выбери «Скрыть из ленты». Последующие ручные правки будут проверены отдельно.",
  'ai.results.review': "Проверить изменения",
  'ai.results.pending': "Ещё не применено",
  'ai.results.reviewHint': "Выбери действия для применения. Зависимые действия доступны только вместе с необходимыми им шагами.",
  'ai.results.apply': "Применить выбранное",
  'ai.results.decline': "Отклонить",
  'ai.results.declined': "Предложение отклонено",
  'ai.results.declineError': "Не удалось отклонить предложение. Попробуй ещё раз.",
  'ai.results.applying': "Применяю изменения…",
  'ai.results.dismissing': "Отклоняю предложение…",
  'ai.results.selected': "Выбрано действий: {n} из {total}",
  'ai.results.proposed': "Предлагается",
  'ai.results.mode': "Работа с изменениями",
  'ai.results.suggest': "Сначала предложить",
  'ai.results.auto': "Применять сразу",
  'ai.results.modeHint': "Для следующих запросов, в пределах твоих прав. Показ игрокам подтверждается отдельно.",
  'ai.results.dependency': "Зависит от другого действия",
  // === Toolbar ===
  'toolbar.select': 'Выделение',
  'toolbar.draw': 'Рисование',
  'toolbar.erase': 'Ластик',
  'toolbar.shape': 'Фигуры',
  'toolbar.measure': 'Линейка',
  'toolbar.ping': 'Пинг',
  'toolbar.pingHint': 'или просто удерживай на карте 0,5 с',
  'toolbar.fog': 'Туман войны',
  'toolbar.note': 'Заметка',
  'toolbar.portal': 'Портал',
  'toolbar.selectDrawing': 'Выделение рисунков',
  'toolbar.text': 'Текст',
  'toolbar.aoe': 'АоЕ',
  'toolbar.mapObject': 'Объект',
  'toolbar.wall': 'Стены',
  'toolbar.token': 'Токен',
  'toolbar.token.helper': 'Перетащите персонажа из панели персонажей на карту',
  'toolbar.undo': 'Отменить',
  'toolbar.redo': 'Повторить',

  // === Toolbar Groups ===
  'toolbar.group.select': 'Выделение',
  'toolbar.group.drawing': 'Рисование',
  'toolbar.group.fog': 'Туман войны',
  'toolbar.group.measure': 'Линейка и пинг',
  'toolbar.group.pins': 'Маркеры карты',
  'toolbar.group.text': 'Текст',
  'toolbar.group.token': 'Токен',
  'toolbar.group.mapObjects': 'Объекты карты',
  'toolbar.group.note': 'Заметки',
  'toolbar.group.objects': 'Объекты',
  'toolbar.group.aiEdit': 'Правка Тиа',
  'toolbar.inpaintRect': 'Прямоугольное выделение',
  'toolbar.inpaintLasso': 'Лассо-выделение',
  'toolbar.detailRect': 'Детальная карта',
  'toolbar.initiative': 'Инициатива',
  'toolbar.held': 'удерж.',
  'toolbar.snapActive': 'Привязка',
  'toolbar.overflow': 'Ещё...',

  // === Canvas Context Menu ===
  'contextMenu.addToken': 'Добавить токен',
  'contextMenu.addPin': 'Добавить маркер',
  'contextMenu.actAs': 'Действовать за',
  'contextMenu.addText': 'Добавить текст',
  'contextMenu.editToken': 'Редактировать токен',
  'contextMenu.deleteToken': 'Удалить токен',
  'contextMenu.copyToken': 'Копировать токен',
  'contextMenu.moveToFront': 'На передний план',
  'contextMenu.moveToBack': 'На задний план',
  'contextMenu.openEntry': 'Открыть запись',
  'contextMenu.movePin': 'Переместить маркер',
  'contextMenu.deletePin': 'Удалить маркер',
  'contextMenu.deleteDrawing': 'Удалить рисунок',
  'contextMenu.changeColor': 'Изменить цвет',
  'contextMenu.viewToken': 'Просмотр токена',

  // === Drawing Selection ===
  'drawingSelection.stroke': 'рисунок',
  'drawingSelection.strokes': 'рисунков',
  'drawingSelection.toolbar': 'Действия с выделенными рисунками',
  'drawingSelection.delete': 'Удалить',

  // === Sidebar Tabs ===
  'sidebar.map': 'Карты',
  'sidebar.journal': 'Журнал',
  'sidebar.notes': 'Заметки',
  'sidebar.chat': 'Чат',
  'sidebar.srd': 'Справочник',
  'sidebar.initiative': 'Инициатива',
  'sidebar.participants': 'Участники',
  'sidebar.ai': 'Тиа',
  'sidebar.characters': 'Персонажи',

  // === Sidebar Sections (Map tab) ===
  'sidebar.section.pages': 'Карты',
  'sidebar.section.tokens': 'Токены',
  'sidebar.section.pins': 'Маркеры',
  'sidebar.section.mapObjects': 'Объекты карты',

  // === Inspector ===
  'inspector.tokenVision': 'Видимость',
  'inspector.visionRange': 'Дальность',
  'inspector.darkvision': 'Тёмное зрение',
  'inspector.pinOpenEntry': 'Открыть запись',

  // === Common Actions ===
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.delete': 'Удалить',
  'common.create': 'Создать',
  'common.edit': 'Редактировать',
  'common.back': 'Назад',
  'common.close': 'Закрыть',
  'common.loading': 'Загрузка...',
  'common.search': 'Поиск',
  'common.reset': 'Сброс',
  'common.next': 'Далее',
  'common.confirm': 'Подтвердить',
  'common.name': 'Имя',
  'common.none': '— нет —',

  // === Auth ===
  'auth.login': 'Войти',
  'auth.loginTitle': 'Вход',
  'auth.loginBusy': 'Вход...',
  'auth.register': 'Регистрация',
  'auth.registerTitle': 'Регистрация',
  'auth.registerBusy': 'Регистрация...',
  'auth.registerSubmit': 'Зарегистрироваться',
  'auth.inviteCode': 'Код приглашения',
  'auth.inviteCodeHint': 'Код закрытой беты. Запросите у администратора.',
  'auth.inviteCodePlaceholder': 'Введите код приглашения',
  'auth.email': 'Email',
  'auth.password': 'Пароль',
  'auth.passwordHint': 'Пароль (от 8 символов)',
  'auth.displayName': 'Имя',
  'auth.hasAccount': 'Уже есть аккаунт? Войти',
  'auth.noAccount': 'Нет аккаунта? Зарегистрироваться',
  'auth.showPassword': 'Показать пароль',
  'auth.hidePassword': 'Скрыть пароль',
  'auth.profileTitle': 'Настройки профиля',
  'auth.displayNameLabel': 'Отображаемое имя:',
  'auth.saveBusy': 'Сохранение...',

  // === Lobby ===
  'lobby.createSession': 'Создать сессию',
  'lobby.joinSession': 'Присоединиться',
  'lobby.yourName': 'Ваше имя:',
  'lobby.sessionCode': 'Код сессии:',
  'lobby.connecting': 'Подключение...',
  'lobby.enter': 'Войти',

  // === Session List ===
  'sessionList.title': 'Ваши сессии',
  'sessionList.session': 'Сессия',
  'sessionList.player': 'Игрок',
  'sessionList.loading': 'Загрузка сессий...',
  'sessionList.copied': 'Скопировано!',
  'sessionList.copyCode': 'Скопировать код',
  'sessionList.today': 'Сегодня',
  'sessionList.yesterday': 'Вчера',
  'sessionList.daysAgo': 'назад',
  'sessionList.rename': 'Переименовать',
  'sessionList.delete': 'Удалить',
  'sessionList.copyInvite': 'Скопировать ссылку-приглашение',
  'sessionList.deleteConfirm': 'Вы уверены, что хотите удалить эту сессию?',
  'sessionList.deleteConfirmTitle': 'Удаление сессии',
  'sessionList.previewComingSoon': 'Скоро',
  'sessionList.inviteCopied': 'Ссылка-приглашение скопирована',

  // === Chat ===
  'chat.title': 'Чат',
  'chat.placeholder': 'Сообщение или /roll 2d6+3',
  'chat.rolls': ' бросает ',
  'chat.helpUsage': 'Использование: /roll 2d6+3',
  'chat.nameChanged': 'Имя изменено на:',
  'chat.helpRoll': '/roll NdX+M — бросок кубиков',
  'chat.helpName': '/name Имя — изменить имя',
  'chat.helpClear': '/clear — очистить чат',
  'chat.helpGm': '/gm текст — скрытое сообщение',
  'chat.unknownCommand': 'Неизвестная команда. /help для списка команд.',
  'chat.welcome': 'Добро пожаловать в roll1! /help в чате для списка команд.',
  'chat.welcomeShortcuts': 'Ctrl+S — сохранить сессию, Ctrl+L — загрузить',

  // === Initiative ===
  'initiative.title': 'Инициатива',
  'initiative.next': 'Следующий',
  'initiative.otherPage': '(другая карта)',
  'initiative.add': 'Добавить в бой',
  'initiative.addMenu': 'Добавить в бой…',
  'initiative.more': 'Ещё',
  'initiative.closeHint': 'Закрыть окно — бой идёт дальше; открыть снова: «Инициатива» на панели слева (I)',
  'initiative.collapse': 'Свернуть в заголовок',
  'initiative.noFight': 'Боя нет.',
  'initiative.endedRounds': 'Бой закончен · раундов: {n}.',
  'initiative.collect': 'Собрать участников',
  'initiative.sameAgain': 'Те же участники ({n})',
  'initiative.orFromMap': 'Или ПКМ по токенам на карте → «В инициативу».',
  'initiative.whoInFight': 'Кто в бою',
  'initiative.nOfOnMap': '{n} из {m} на карте',
  'initiative.onlySelected': 'Только выделенные на карте ({n})',
  'initiative.party': 'Партия',
  'initiative.foes': 'Противники',
  'initiative.hiddenFromPlayers': 'Скрыты от игроков',
  'initiative.rollsHimself': 'бросит сам',
  'initiative.dexMod': 'Лов {mod}',
  'initiative.noSheet': 'без листа: +0',
  'initiative.playersRoll': 'Игроки бросают сами',
  'initiative.groupSame': 'Одинаковых — одной группой',
  'initiative.groupSameTip': 'Правило Руководства мастера: одинаковые монстры ходят разом, один бросок',
  'initiative.startFight': 'Начать бой',
  'initiative.d20dex': 'd20 + Лов',
  'initiative.d20dexTip': 'Противники: d20 + Ловкость с листа',
  'initiative.cancel': 'Отмена',
  'initiative.assembled': 'Бой собран · раунд 1 ещё не начат',
  'initiative.waitingRolls': 'Ждём бросок: {names}',
  'initiative.beginNow': 'Начать, не дожидаясь',
  'initiative.beginNowTip': 'Не бросили: {names}. Встанут по числу, когда бросят',
  'initiative.roundN': 'Раунд {n}',
  'initiative.waiting': 'ждём',
  'initiative.yourTurn': 'Твой ход',
  'initiative.youNext': 'ты следующий',
  'initiative.youAfter': 'ты после: {name}',
  'initiative.youDelayed': 'ты отложил ход',
  'initiative.nextTip': 'Следующий ход (Пробел)',
  'initiative.nextTurn': 'Следующий ход',
  'initiative.prev': 'Назад — предыдущий ход',
  'initiative.delayMine': 'Отложить',
  'initiative.delayMineTip': 'Отложить свой ход — вступишь, когда скажешь',
  'initiative.endTurn': 'Закончить ход',
  'initiative.rollForPlayer': 'Бросить за игрока',
  'initiative.rollForPlayerName': 'Бросить за игрока «{name}»',
  'initiative.notRolled': 'Ещё не бросил',
  'initiative.roll': 'Бросить',
  'initiative.editValue': 'Изменить число {v}',
  'initiative.valueOf': 'Инициатива «{name}»',
  'initiative.hpOf': 'ХП «{name}»',
  'initiative.hpWord': 'ХП',
  'initiative.hpTip': 'ХП {hp}/{max}',
  'initiative.markOut': 'Выбыл',
  'initiative.zeroHp': '0 ХП',
  'initiative.hiddenTip': 'Скрыт от игроков — в их списке его нет',
  'initiative.hidden': 'Скрыт от игроков',
  'initiative.tieTip': 'Равно {v} с «{other}» — раньше тот, у кого выше Ловкость ({a} против {b}). Порядок можно поменять перетаскиванием.',
  'initiative.tie': 'Ничья',
  'initiative.outTip': 'Выбыл — ход пропускается',
  'initiative.downTip': 'Без сознания — ход остаётся: спасброски от смерти',
  'initiative.unconscious': 'Без сознания',
  'initiative.fromRound': 'с раунда {n}',
  'initiative.fromRoundTip': 'Добавлен посреди раунда, когда его место уже прошло',
  'initiative.owed': 'следующий',
  'initiative.owedTip': 'Число стало выше текущего, а он ещё не ходил в этом раунде',
  'initiative.yourTurnTag': 'твой ход',
  'initiative.actsTag': 'ходит',
  'initiative.showOnMap': 'Показать на карте',
  'initiative.showOnMapName': '{name} — показать на карте',
  'initiative.openSheet': 'Открыть лист',
  'initiative.hpMenu': 'ХП…',
  'initiative.enterValue': 'Ввести число',
  'initiative.enterGroupValue': 'Ввести число группе',
  'initiative.reroll': 'Перебросить',
  'initiative.delayTurn': 'Отложить ход',
  'initiative.split': 'Разделить группу — каждому свой бросок',
  'initiative.showToPlayers': 'Показать игрокам',
  'initiative.hideFromPlayers': 'Скрыть от игроков',
  'initiative.removeFromFight': 'Убрать из боя',
  'initiative.removeGroup': 'Убрать из боя всю группу ({n})',
  'initiative.groupNote': 'Одного из группы — раскрой ▸ и ⋯ у него.',
  'initiative.ownValue': 'Своё число — вынести из группы',
  'initiative.showEach': 'Показать каждого',
  'initiative.collapseGroup': 'Свернуть группу',
  'initiative.moreOf': 'Ещё: {name}',
  'initiative.drag': 'Перетащить — поменять порядок',
  'initiative.delayedHeader': 'Отложили ход',
  'initiative.untilEndOfRound': 'до конца раунда {n}',
  'initiative.untilEndTip': 'Не вступил до конца раунда — ход пропадает, в следующем раунде на своём месте',
  'initiative.join': 'Вступить',
  'initiative.joinTip': 'Ходит сейчас, перед {name}',
  'initiative.joinTipHidden': 'Ходит сейчас, перед текущим',
  'initiative.waitsDelayed': 'ждёт',
  'initiative.endFight': 'Закончить бой…',
  'initiative.endAsk': 'Закончить бой?',
  'initiative.endAskHint': 'Порядок и счёт раундов ({n}) сбросятся. ХП и состояния токенов останутся.',
  'initiative.endConfirm': 'Закончить бой',
  'initiative.menuNote': 'Пробел — следующий ход. Токен в бой — ПКМ по нему на карте → «В инициативу».',
  'initiative.onMap': 'На карте: {names}',
  'initiative.appearedAfter': 'появились после начала боя',
  'initiative.toFight': 'В бой',
  'initiative.dismissNew': 'Не добавлять',
  'initiative.pickAll': 'Все токены карты уже в бою.',
  'initiative.new': 'новый',
  'initiative.joinGroups': 'Одинаковых — к их группе',
  'initiative.rollAndAdd': 'Бросить и добавить ({n})',
  'initiative.turnStays': 'ход не сдвинется',
  'initiative.close': 'Закрыть',
  'initiative.undo': 'Отменить',
  'initiative.n.started': 'Противники брошены (d20 + Ловкость). Раунд 1 начнётся, когда бросят все игроки',
  'initiative.n.startedAll': 'Брошено за всех — раунд 1',
  'initiative.n.begun': 'Раунд 1 начат без бросков: {names} — встанут по числу, когда бросят',
  'initiative.n.addedGroup': '{name} — в группу «{group}» ({v})',
  'initiative.n.addedLater': '{name} — {roll}: место в этом раунде уже прошло, ходит с раунда {n}',
  'initiative.n.addedNow': '{name} — {roll}: ходит в этом раунде',
  'initiative.n.removedOne': 'Из боя: {names}. На карте токен остался',
  'initiative.n.removedMany': 'Из боя: {names}. На карте токены остались',
  'initiative.n.value': 'число {v}',
  'initiative.n.roll': 'бросок {roll}',
  'initiative.n.reroll': 'переброс {roll}',
  'initiative.n.move': 'новое место (число {v} не менялось)',
  'initiative.n.top': 'В раунде 1 ещё никто не ходил — порядок с начала, ходит {cur}',
  'initiative.n.keeps': 'Ход остаётся у него',
  'initiative.n.owed': 'Его место в раунде {r} уже прошло, но он ещё не ходил — ходит следующим; с раунда {r1} — на новом месте',
  'initiative.n.acted': 'В раунде {r} он уже ходил — второй раз не пойдёт; с раунда {r1} — на новом месте',
  'initiative.n.same': 'Ход не сдвинулся',
  'initiative.n.allRolled': 'Бросили все — раунд 1, ходит {cur}',
  'initiative.n.round': 'Раунд {n}',
  'initiative.n.lost': '{names} так и не вступил — ход раунда {r} пропал, теперь на своём месте ({v})',
  'initiative.n.delayed': '{name} отложил ход. Вступит, когда скажет — до конца раунда {r}; не вступит — ход пропадёт, в раунде {r1} будет на своём месте',
  'initiative.n.joined': '{name} вступает сейчас — перед {before}; дальше его место здесь ({v})',
  'initiative.n.split': 'Группа разделена, каждому новый бросок: {rolls}',
  'initiative.n.splitOwed': 'Кто встал выше текущего и ещё не ходил — ходит следующим',
  'initiative.n.ended': 'Бой закончен · раундов: {n}',
  'initiative.n.restored': 'Отменено',
  'initiative.n.firstTurn': 'Это первый ход боя',
  'initiative.n.back': 'Назад: ходит {cur}',
  'initiative.n.turnEnded': '{name} закончил ход',
  'contextMenu.initiativeAdd': 'В инициативу',
  'contextMenu.initiativeAddN': 'В инициативу ({n})',
  'contextMenu.initiativeRemove': 'Убрать из инициативы',
  'contextMenu.initiativeRemoveN': 'Убрать из инициативы ({n})',
  'contextMenu.alreadyInFight': 'Уже в бою: {names}',

  // === Tokens ===
  'tokens.title': 'Токены',
  'tokens.add': 'Добавить токен',
  'tokens.boundToSheet': 'Привязан к чар-листу',
  'tokens.sheetLabel': 'Чар-лист:',
  'tokens.tokenName': 'Имя токена:',
  'tokens.defaultName': 'Токен',
  'tokens.added': 'Токен добавлен:',
  'tokens.created': 'Токен создан:',

  // === Dice ===
  'dice.title': 'Кубики',
  'dice.roll': 'Бросить',

  // === Pages ===
  'pages.deleteConfirmTitle': 'Удалить карту?',
  'pages.deleteConfirmDesc': 'Все токены и рисунки на этой карте будут безвозвратно удалены.',
  'pages.deleteConfirmDescWithChildren': 'Все токены и рисунки будут удалены. Вложенные карты переместятся в корень.',
  'pages.deletePlayersHere': 'Игроки сейчас на этой карте. Куда их перенести?',
  'pages.deleteChooseTarget': '— выберите карту —',

  // === Characters ===
  'characters.title': 'Персонажи',
  'characters.createWizard': 'Создать через визард (D&D 5e)',
  'characters.empty': 'Нет персонажей',
  'characters.create': '+ Создать персонажа',
  'characters.createBlank': 'или пустой лист — заполнить вручную',
  'characters.newCharacter': 'Новый персонаж',
  'characters.nameLabel': 'Имя:',
  'characters.namePlaceholder': 'Имя персонажа',
  'characters.templateLabel': 'Шаблон:',
  'characters.typeLabel': 'Тип:',
  'characters.typePC': 'Персонаж игрока',
  'characters.typeNPC': 'NPC',
  'characters.builtIn': '(встроенный)',
  'characters.foreignSheet': 'Чужой персонаж',
  'characters.performanceWarning': 'персонажей — производительность может снизиться',
  'characters.assignOwner': 'Назначить владельца',
  'characters.assignOwnerDescription': 'Выберите игрока — владельца персонажа:',
  'characters.publicFields': 'Публичные поля (что видно партии)',
  'characters.sheetVisibleTitle': 'Лист виден игрокам — скрыть',
  'characters.sheetHiddenTitle': 'Лист скрыт от игроков — показать',
  'characters.cardVisibilityTitle': 'Карточка на сцене',
  'characters.publicFieldsDescription': 'Поля, которые видят другие игроки:',
  'characters.noOwner': 'Без владельца',
  'characters.createWithoutOwner': 'Без владельца',
  'characters.createAndAssign': 'Назначить',
  'characters.ungrouped': 'Без папки',
  'characters.newGroup': 'Новая папка',
  'characters.groupName': 'Название папки',
  'characters.deleteGroup': 'Удалить папку',
  'characters.deleteConfirmTitle': 'Удалить лист персонажа?',
  'characters.deleteConfirmDesc': '«{name}» будет удалён без возможности восстановления.',
  'characters.renameGroup': 'Переименовать папку',

  // === Participants ===
  'participants.title': 'Участники',

  // === Notes ===
  'notes.title': 'Заметки на карте',
  'notes.empty': 'Нет заметок. Используйте инструмент заметок для создания.',
  'notes.untitled': 'Без названия',
  'notes.gmOnly': 'только мастер',
  'notes.newNote': 'Новая заметка',
  'notes.editNote': 'Редактировать заметку',
  'notes.noteTitle': 'Название',
  'notes.noteContent': 'Содержимое',
  'notes.icon': 'Иконка',
  'notes.color': 'Цвет',
  'notes.selectColor': 'Выбрать цвет',

  // === Note icons ===
  'noteIcon.pin': 'Булавка',
  'noteIcon.scroll': 'Свиток',
  'noteIcon.skull': 'Череп',
  'noteIcon.chest': 'Сундук',
  'noteIcon.star': 'Звезда',
  'noteIcon.question': 'Вопрос',
  'noteIcon.exclamation': 'Внимание',
  'noteIcon.camp': 'Лагерь',
  'noteIcon.sword': 'Бой',
  'noteIcon.key': 'Ключ',

  // === Reconnect ===
  'reconnect.message': 'Переподключение...',

  // === Connection Status ===
  'status.online': '● Онлайн',
  'status.reconnecting': '◌ Переподключение...',

  // === Workspace Presets ===
  'preset.explore': 'Исследование (Alt+1)',
  'preset.combat': 'Бой (Alt+2)',
  'preset.prep': 'Подготовка (Alt+3)',
  'preset.fullscreen': 'Полноэкранный режим',
  'preset.exit': 'Выйти',

  // === Shortcuts ===
  'shortcuts.title': 'Горячие клавиши',
  'shortcuts.hint': 'Горячие клавиши не срабатывают, когда фокус находится в поле ввода.',
  'shortcuts.sectionTools': 'Инструменты',
  'shortcuts.sectionCamera': 'Камера',
  'shortcuts.sectionTokens': 'Токены',
  'shortcuts.sectionChat': 'Чат и инициатива',
  'shortcuts.sectionWorkspace': 'Рабочее пространство',
  'shortcuts.toolSelect': 'Инструмент: Выделение',
  'shortcuts.toolDraw': 'Инструмент: Рисование',
  'shortcuts.toolEraser': 'Инструмент: Ластик',
  'shortcuts.toolRuler': 'Инструмент: Линейка',
  'shortcuts.toolPing': 'Инструмент: Пинг (клик по карте; то же — удержание 0,5 с)',
  'shortcuts.toolFog': 'Инструмент: Туман войны',
  'shortcuts.toolNote': 'Инструмент: Заметка (мастер)',
  'shortcuts.toolPortal': 'Инструмент: Портал (мастер)',
  'shortcuts.snapToggle': 'Привязка к сетке (вкл/выкл)',
  'shortcuts.zoomIn': 'Увеличить масштаб',
  'shortcuts.zoomOut': 'Уменьшить масштаб',
  'shortcuts.fitToScreen': 'По размеру экрана',
  'shortcuts.exitFullscreen': 'Выход из полноэкранного режима',
  'shortcuts.deleteTokens': 'Удалить выделенные токены',
  'shortcuts.quickSelectToken': 'Быстро выделить токен по номеру',
  'shortcuts.nextTurn': 'Следующий ход инициативы',
  'shortcuts.openMapPanel': 'Открыть панель карты',
  'shortcuts.presetExplore': 'Пресет: Исследование (мастер)',
  'shortcuts.presetCombat': 'Пресет: Бой (мастер)',
  'shortcuts.presetPrep': 'Пресет: Подготовка (мастер)',
  'shortcuts.toggleSidebar': 'Свернуть/развернуть боковую панель',
  'shortcuts.showShortcuts': 'Показать/скрыть список горячих клавиш',
  'shortcuts.saveSession': 'Сохранить сессию',
  'shortcuts.loadSession': 'Загрузить сессию',
  'shortcuts.undo': 'Отменить',
  'shortcuts.redo': 'Повторить',
  'shortcuts.toolSelectDrawing': 'Инструмент: Выделение рисунков (мастер)',
  'shortcuts.toolText': 'Инструмент: Текст (мастер)',
  'shortcuts.toolAoe': 'Инструмент: АоЕ (мастер)',
  'shortcuts.toolMapObject': 'Инструмент: Объект (мастер)',
  'shortcuts.fogBrushDec': 'Кисть тумана: уменьшить',
  'shortcuts.fogBrushInc': 'Кисть тумана: увеличить',
  'shortcuts.copy': 'Копировать токен',
  'shortcuts.paste': 'Вставить токен',
  'shortcuts.toggleInitiative': 'Переключить инициативу (I)',

  // === Tool Options ===
  'toolOptions.snapToGrid': 'Привязка к сетке',
  'toolOptions.color': 'Цвет:',
  'toolOptions.width': 'Толщина:',
  'toolOptions.mode': 'Режим:',
  'toolOptions.modeSimple': 'Простой',
  'toolOptions.modeAlternating': 'Чередующийся (D&D)',
  'toolOptions.modeEuclidean': 'Евклидов',
  'toolOptions.modeHex': 'Гекс',
  'toolOptions.gridSizeFt': 'Клетка (фт):',
  'toolOptions.shape': 'Форма:',
  'toolOptions.shapeRect': 'Прямоугольник',
  'toolOptions.shapePolygon': 'Полигон',
  'toolOptions.shapeCircle': 'Круг',
  'toolOptions.navigation': 'Навигация:',
  'toolOptions.navFree': 'Свободный',
  'toolOptions.navConfirm': 'Подтверждение',
  'toolOptions.navGmOnly': 'Только мастер',
  'toolOptions.reFog': 'Закрыть туман',
  'toolOptions.dynamicFogHint': 'Динамический туман: закрытие управляется зрением токенов',
  'toolOptions.clearAllFog': 'Убрать всё',
  'toolOptions.coverAllFog': 'Покрыть всё',
  'toolOptions.shapeLine': 'Линия',
  'toolOptions.fogMode': 'Режим:',
  'toolOptions.brushSize': 'Кисть:',
  'toolOptions.mapSettings': 'Настройки карты',
  'toolOptions.gridSize': 'Размер сетки:',
  'toolOptions.mapScale': 'Масштаб карты:',
  'toolOptions.bgColor': 'Фон:',
  'toolOptions.deleteMap': 'Удалить карту',
  'toolOptions.confirmDeleteMap': 'Удалить карту?',
  'toolOptions.fogSystem': 'Система:',
  'toolOptions.fogManual': 'Ручной',
  'toolOptions.fogDynamic': 'Динамический',
  'toolOptions.wallType': 'Тип:',
  'toolOptions.wallTypeWall': 'Стена',
  'toolOptions.wallTypeDoor': 'Дверь',
  'toolOptions.wallTypeWindow': 'Окно',
  'toolOptions.wallTypeTerrain': 'Рельеф',
  'toolOptions.wallTypeSecret': 'Тайная',
  'toolOptions.wallTypeEthereal': 'Эфирная',
  'toolOptions.aiEditMode': 'Режим',
  'toolOptions.sketchToMap': 'Карта из скетча',

  // === Token Edit Dialog ===
  'tokenEdit.title': 'Редактирование токена',
  'tokenEdit.name': 'Имя:',
  'tokenEdit.size': 'Размер:',
  'tokenEdit.sizeTiny': 'Крошечный (½)',
  'tokenEdit.sizeMedium': 'Средний (1)',
  'tokenEdit.sizeLarge': 'Большой (2)',
  'tokenEdit.sizeHuge': 'Огромный (3)',
  'tokenEdit.sizeGargantuan': 'Гигантский (4)',
  'tokenEdit.color': 'Цвет:',
  'tokenEdit.notes': 'Заметки:',
  'tokenEdit.visible': 'Виден игрокам',
  'tokenEdit.light': 'Свет',
  'tokenEdit.lightEnabled': 'Излучает свет',
  'tokenEdit.lightBright': 'Радиус яркого света',
  'tokenEdit.lightDim': 'Радиус тусклого света',
  'tokenEdit.lightColor': 'Цвет света',
  'tokenEdit.visionType': 'Тип зрения',
  'tokenEdit.visionTypeNormal': 'Обычное',
  'tokenEdit.visionTypeDarkvision': 'Тёмное зрение',

  // === Global Illumination ===
  'page.globalIllumination': 'Освещение',
  'page.illuminationBright': 'Яркий свет',
  'page.illuminationDim': 'Тусклый свет',
  'page.illuminationDark': 'Полная тьма',
  'page.illuminationColor': 'Цвет освещения',

  // === Conditions Dialog ===
  'conditions.title': 'Состояния',

  // === Context Menu ===
  'contextMenu.inspect': 'Описание',
  'contextMenu.edit': 'Редактировать',
  'contextMenu.conditions': 'Состояния',
  'contextMenu.hp': 'ХП',
  'contextMenu.resize': 'Размер',
  'contextMenu.addAura': 'Добавить ауру',
  'contextMenu.layerUp': 'Наверх',
  'contextMenu.layerDown': 'Вниз',
  'contextMenu.copy': 'Копировать',
  'contextMenu.delete': 'Удалить',
  'contextMenu.auras': 'Ауры:',
  'contextMenu.fogReset': 'Сбросить туман войны',
  'contextMenu.hideToken': 'Скрыть от игроков',
  'contextMenu.showToken': 'Показать игрокам',
  'contextMenu.enableVision': 'Включить видимость',
  'contextMenu.disableVision': 'Выключить видимость',
  'contextMenu.openSheet': 'Открыть лист',

  // === Link Context Menu ===
  'linkMenu.edit': 'Редактировать',
  'linkMenu.navigate': 'Перейти к целевой',
  'linkMenu.toggleVisibility': 'Скрыть/Показать',
  'linkMenu.delete': 'Удалить',
  'linkMenu.zone': 'Зона',

  // === Aura Editor ===
  'aura.editTitle': 'Редактировать ауру',
  'aura.addTitle': 'Добавить ауру',
  'aura.radiusFt': 'Радиус (фт):',
  'aura.color': 'Цвет:',
  'aura.opacity': 'Прозрачность:',
  'aura.label': 'Название:',
  'aura.style': 'Стиль:',
  'aura.styleSolid': 'Сплошной',
  'aura.styleDashed': 'Пунктир',
  'aura.stylePulse': 'Пульсация',
  'aura.gmOnly': 'Только для мастера',

  // === Location Link Dialog ===
  'locationLink.editTitle': 'Редактировать зону',
  'locationLink.createTitle': 'Создать переход',
  'locationLink.targetPage': 'Куда ведёт',
  'locationLink.selectPage': 'Выберите карту…',
  'locationLink.label': 'Название',
  'locationLink.labelPlaceholder': 'Название зоны…',
  'locationLink.style': 'Стиль',
  'locationLink.stylePortal': 'Портал',
  'locationLink.styleDoor': 'Дверь',
  'locationLink.styleStairs': 'Лестница',
  'locationLink.styleArea': 'Область',

  // === Template Editor ===
  'templates.title': 'Шаблоны',
  'templates.builtIn': '(встр.)',
  'templates.createTemplate': '+ Создать шаблон',
  'templates.editTemplate': 'Редактирование шаблона',
  'templates.newTemplate': 'Новый шаблон',
  'templates.nameLabel': 'Название:',
  'templates.newSection': 'Новая секция',
  'templates.newField': 'Новое поле',
  'templates.addField': '+ Поле',
  'templates.addSection': '+ Секция',
  'templates.deleteSection': 'Удалить секцию',

  // === AI Chat ===
  'ai.title': 'Тиа',
  'aiCard.was': 'Было',
  'aiCard.now': 'Стало',
  'ai.historyLoadError': 'Не удалось загрузить историю. Попробуйте ещё раз.',
  'ai.historyRenameError': 'Не удалось сохранить название. Попробуйте ещё раз.',
  'ai.historyBusy': 'Чтобы переключить чат, дождитесь ответа или остановите генерацию.',
  'ai.historyRetention': 'Разговоры хранятся 30 дней после последней активности.',
  'ai.historyTitle': 'Название чата',
  'ai.historySave': 'Сохранить название',
  'ai.historyCancel': 'Отмена',
  'ai.historyCurrent': 'Текущий',
  'ai.historyRename': 'Переименовать «{title}»',
  'ai.historyMore': 'Показать ещё',
  'ai.historyRetry': 'Повторить',
  'ai.newChat': 'Новый чат',
  'ai.emptyHint': 'Тиа собирает истории. Расскажите ей свою.',
  'ai.thinking': 'Тиа думает...',
  'ai.historySummarized': 'Начало разговора я сжала в сводку — о чём договорились, помню.',
  'ai.placeholder': 'Спроси Тиа…',
  'ai.textModel': 'Текстовая модель',
  'ai.models': 'Модели',
  'ai.imageModel': 'Модель картинок',
  'aiModel.mapModel': 'Модель для карты',
  'settings.aiTextModel': 'Текстовая модель ассистента по умолчанию',
  'settings.aiTextModelServer': 'По умолчанию сервера',
  'aiCard.changes': 'Изменения ({count})',
  'aiChange.beatMoved': 'Бит «{name}» переставлен в плане',
  'ai.plan.step.move': 'Переставлю бит «{name}»',
  'aiGroup.sheet': 'Лист «{name}»',
  'aiGroup.beat': 'Бит «{name}»',
  'aiGroup.journal': 'Запись «{name}»',
  'aiGroup.token': 'Токен «{name}»',
  'aiGroup.page': 'Карта «{name}»',
  'aiGroup.other': '«{name}»',
  'aiGroup.count.one': '{n} изменение',
  'aiGroup.count.few': '{n} изменения',
  'aiGroup.count.many': '{n} изменений',
  'aiGroup.show': 'показать',
  'aiGroup.hide': 'скрыть',
  'aiGroup.empty': 'пусто',
  'aiGroup.yes': 'да',
  'aiGroup.no': 'нет',
  'aiField.item': 'предмет',
  'aiField.equipped': 'надет «{item}»',
  'aiField.beatOrder': 'порядок в плане',
  'aiField.proficiencies': 'владения и языки',
  'aiField.proficiency_cats': 'разделы владений',
  'aiField.subclass': 'подкласс',
  'aiField.subrace': 'подраса',
  'aiField.sessionLabel': 'название',
  'aiField.status': 'статус',
  'aiField.name': 'название',
  'aiCard.undone': 'Отменено',
  'aiCard.undoAll': 'Отменить всё',
  'aiCard.undo': 'Отменить',
  'aiCard.undoRelated': 'Отменить (+{count} связанных)',
  'aiCard.kept': '— оставлена твоя правка',
  'aiCard.toastUndone': 'Отменено. Твои правки, сделанные после, остались.',
  'aiCard.undoRefused': 'Не удалось отменить: этого ответа уже нет в журнале, либо отменять может только мастер.',
  'aiChange.beatCreated': 'Создан бит «{name}»',
  'aiChange.reserveCreated': 'Создан запасной бит «{name}»',
  'aiChange.outcomeCreated': 'Развилка «{name}» у «{beat}»',
  'aiChange.noteCreated': 'Заметка «{name}»',
  'aiChange.questCreated': 'Квест «{name}»',
  'aiChange.entryCreated': 'Запись «{name}»',
  'aiChange.entryChanged': 'Запись «{name}» изменена',
  'aiChange.prepExtended': 'Подготовка «{name}» дополнена',
  'aiChange.objectiveDone': '«{quest}»: цель «{name}» выполнена',
  'aiChange.objectiveUndone': '«{quest}»: у цели «{name}» снята отметка',
  'aiChange.beatStatus': 'Бит «{name}»: {status}',
  'aiChange.beatRenamed': 'Бит переименован: «{before}» → «{name}»',
  'aiChange.beatChanged': 'Бит «{name}» изменён',
  'aiChange.currentBeat': 'Сейчас играем «{name}»',
  'aiChange.timelineDraft': 'Черновик летописи «{name}»',
  'aiChange.pageCreated': 'Создана карта «{name}»',
  'aiChange.pinCreated': 'Маркер «{name}»',
  'aiChange.tokenCreated': 'Токен «{name}»',
  'aiChange.sheetCreated': 'Лист «{name}»',
  'aiChange.deleted': 'Удалено: «{name}»',
  'aiUndo.conflictTitle': 'Ты уже правил это после Тиа',
  'aiUndo.conflictBodyOne': 'Вернуть как было до Тиа? Твои правки в этом месте пропадут.',
  'aiUndo.conflictBodyMany': 'Вернуть как было до Тиа? Твои правки в этих местах пропадут.',
  'aiUndo.restore': 'Вернуть как было',
  'aiUndo.keepRest': 'Оставить мои правки, остальное отменить',
  'aiUndo.keepOnly': 'Оставить мои правки',
  'aiUndo.cancel': 'Отмена',
  'aiMark.added': 'Тиа добавила',
  'aiMark.changed': 'Тиа изменила',
  'pinPopup.confirmBodyWhole': 'Игроки увидят маркер и запись целиком, кроме скрытых полей мастера.',
  'aiCard.irreversible': 'без отмены',
  'aiCard.field.description': 'описание',
  'aiCard.field.content': 'текст',
  'aiCard.field.gmNotes': 'для мастера',
  'aiCard.field.rewards': 'награды',
  'aiChange.tokenChanged': 'Токен «{name}»: {field}',
  'aiChange.tokenMoved': 'Токен «{name}» передвинут',
  'aiChange.sheetEdited': 'Лист «{name}» изменён',
  'aiChange.pageRenamed': 'Карта переименована: «{before}» → «{name}»',
  'aiChange.fogChanged': 'Туман на «{name}» изменён',
  'aiChange.timeMoved': 'Время в мире сдвинуто: {name}',
  'aiChange.linkAdded': 'Связь у записи «{name}»',
  'aiChange.tagsChanged': 'Теги записи «{name}» изменены',
  'ai.thinkingLabel': 'Размышления',
  'ai.stop': 'Остановить генерацию',
  'ai.conversationHistory': 'История чатов',
  'ai.noConversations': 'Нет предыдущих бесед',
  'ai.loadingHistory': 'Загрузка истории...',
  'ai.toolErrorFriendly': 'Не удалось выполнить операцию',
  'ai.stoppedByGM': 'Генерация остановлена мастером.',
  'ai.openThinkingModal': 'Открыть полный ход мыслей',
  'ai.emptyTiaGreeting': 'Привет! Я Тиа. Чем могу помочь с вашим приключением?',
  'ai.emptyPersonaGreeting': 'Привет! Я {name}. Задайте мне вопрос.',
  'ai.personaMemory': 'Память персоны',
  'ai.chronicle': 'Пересказ',
  'ai.generating': 'Генерация...',
  'ai.saveAsJournal': 'Сохранить как запись журнала',
  'ai.noPersonaMemory': 'Пока нет воспоминаний. Тиа сформирует впечатления после разговоров.',
  'ai.requestChronicle': 'Запросить пересказ',
  'ai.requestEpilogue': 'Эпилог',

  // === AI Tool Labels ===
  'aiTool.getSessionInfo': 'Получение информации о сессии',
  'aiTool.getCurrentPage': 'Просмотр текущей карты',
  'aiTool.listSheets': 'Список листов персонажей',
  'aiTool.getSheet': 'Просмотр листа персонажа',
  'aiTool.createNote': 'Создание заметки',
  'aiTool.searchMonsters': 'Поиск монстров в справочнике',
  'aiTool.getMonster': 'Получение стат-блока монстра',
  'aiTool.searchClasses': 'Поиск классов в справочнике',
  'aiTool.searchSpells': 'Поиск заклинаний в справочнике',
  'aiTool.createSheet': 'Создание листа персонажа',
  'aiTool.updateSheet': 'Обновление листа персонажа',
  'aiTool.createToken': 'Создание токена',
  'aiTool.bindSheet': 'Привязка листа к токену',
  'aiTool.createNpc': 'Создание NPC (лист + токен)',
  'aiTool.initiativeUpdate': 'Инициатива: правка порядка',
  'aiTool.initiativeNext': 'Следующий ход',
  'aiTool.initiativeReset': 'Конец боя',
  'aiTool.applyDamage': 'Нанесение урона',
  'aiTool.applyHealing': 'Лечение',
  'aiTool.spellSlotSpend': 'Трата ячейки заклинания',
  'aiTool.concentrationSet': 'Установка концентрации',
  'aiTool.effectAdd': 'Добавление эффекта',
  'aiTool.effectUpdate': 'Обновление эффекта',
  'aiTool.effectRemove': 'Удаление эффекта',
  'aiTool.repeatingRowAdd': 'Добавление строки',
  'aiTool.repeatingRowUpdate': 'Обновление строки',
  'aiTool.repeatingRowRemove': 'Удаление строки',
  'aiTool.pageActivate': 'Переключение карты',
  'aiTool.pageTransfer': 'Перенос токенов',
  'aiTool.pageCreate': 'Создание карты',
  'aiTool.pageRename': 'Переименование карты',
  'aiTool.locationLinkCreate': 'Создание перехода',
  'aiTool.fogReveal': 'Раскрытие тумана войны',
  'aiTool.fogReset': 'Сброс тумана войны',
  'aiTool.fogToggle': 'Переключение тумана войны',
  'aiTool.sheetRest': 'Отдых',
  'aiTool.abilityAdd': 'Добавление умения',
  'aiTool.abilityRemove': 'Удаление умения',
  'aiTool.spellbookAdd': 'Добавление заклинания',
  'aiTool.spellbookRemove': 'Удаление заклинания',
  'aiTool.tokenMove': 'Перемещение токена',
  'aiTool.tokenUpdate': 'Обновление токена',
  'aiTool.tokenDelete': 'Удаление токена',
  'aiTool.chatMessage': 'Отправка сообщения',
  'aiTool.chatRoll': 'Бросок кубиков',
  'aiTool.rulerShow': 'Показ линейки',
  'aiTool.searchJournal': 'Поиск в журнале',
  'aiTool.getJournalEntry': 'Чтение записи журнала',
  'aiTool.getRelatedEntries': 'Поиск связанных записей',
  'aiTool.createJournalEntry': 'Создание записи журнала',
  'aiTool.updateJournalEntry': 'Обновление записи журнала',
  'aiTool.revealJournalEntry': 'Раскрытие записи журнала',
  'aiTool.journalLink': 'Связывание записей журнала',
  'aiTool.getSpell': 'Просмотр заклинания',
  'aiTool.searchEquipment': 'Поиск снаряжения',
  'aiTool.searchMagicItems': 'Поиск магических предметов',
  'aiTool.searchRaces': 'Поиск рас',
  'aiTool.searchConditions': 'Поиск состояний',
  'aiTool.createTimelineEvents': 'Генерация событий летописи',
  'aiTool.generateCalendar': 'Генерация календаря',

  // === Timeline Batch Preview (054) ===
  'timelineBatch.title': 'Просмотр событий от Тиа',
  'timelineBatch.selectAll': 'Выбрать все',
  'timelineBatch.deselectAll': 'Снять все',
  'timelineBatch.selected': 'Выбрано',
  'timelineBatch.confirm': 'Подтвердить',
  'timelineBatch.cancel': 'Отмена',
  'timelineBatch.titlePlaceholder': 'Заголовок события',

  // === Calendar AI Tab (054) ===
  'calendarAi.unavailable': 'Шаблон календаря недоступен',
  'calendarAi.worldDescription': 'Описание мира',
  'calendarAi.worldPlaceholder': 'Опишите мир: сеттинг, сезоны, особенности...',
  'calendarAi.minChars': 'Мин. 10 символов',
  'calendarAi.generating': 'Генерация...',
  'calendarAi.generate': 'Сгенерировать календарь',
  'calendarAi.preview': 'Предпросмотр календаря',
  'calendarAi.calendarName': 'Название',
  'calendarAi.yearLabel': 'Лейбл года',
  'calendarAi.epoch': 'Эпоха',
  'calendarAi.months': 'Месяцы',
  'calendarAi.accept': 'Принять',
  'calendarAi.regenerate': 'Перегенерировать',
  'calendarAi.replaceTitle': 'Заменить календарь?',
  'calendarAi.replaceWarning': 'Текущий календарь будет заменён. Это действие нельзя отменить.',
  'calendarAi.replaceConfirm': 'Заменить',

  // === Timeline Link Picker (054) ===
  'linkPicker.add': 'Добавить ссылку',
  'linkPicker.search': 'Поиск...',
  'linkPicker.remove': 'Удалить',
  'linkPicker.limitReached': 'Достигнут лимит ссылок',
  'linkPicker.journal': 'Журнал',
  'linkPicker.characters': 'Персонажи',
  'linkPicker.pins': 'Маркеры карты',
  'linkPicker.noResults': 'Ничего не найдено',

  // === AI Map Dialog ===
  'aiMap.title': 'Карта от Тиа',
  'aiMap.description': 'Введите промпт для генерации карты. Можно нарисовать скетч для более точного результата.',
  'aiMap.promptLabel': 'Промпт',
  'aiMap.placeholder': 'Опишите карту: \'Подземелье с длинными коридорами и тремя комнатами\'',
  'aiMap.noStrokesHint': 'Без скетча карта будет сгенерирована только по тексту.',
  'aiMap.errorGeneration': 'Ошибка генерации',
  'aiMap.errorNetwork': 'Ошибка сети. Попробуйте снова.',
  'aiMap.generating': 'Генерация карты... Это может занять до 2 минут.',
  'aiMap.preview': 'Превью',
  'aiMap.regenerate': 'Перегенерировать',
  'aiMap.accept': 'Принять',
  'aiMap.generate': 'Сгенерировать карту',
  'aiMap.altText': 'Сгенерированная карта',

  // === AI Inpainting ===
  'inpaint.promptPlaceholder': 'Опишите что должно появиться в выделенной области...',
  'inpaint.generate': 'Сгенерировать',
  'inpaint.accept': 'Принять',
  'inpaint.regenerate': 'Перегенерировать',
  'inpaint.cancel': 'Отмена',
  'inpaint.generating': 'Генерация...',
  'inpaint.tooSmall': 'Область слишком маленькая для перерисовки',
  'inpaint.tooLarge': 'Для замены всей карты используйте генерацию',
  'inpaint.errorGeneration': 'Ошибка перерисовки области',
  'inpaint.errorNetwork': 'Ошибка сети',

  // === AI Outpainting ===
  'outpaint.title': 'Расширить карту',
  'outpaint.directionTop': 'Вверх',
  'outpaint.directionRight': 'Вправо',
  'outpaint.directionBottom': 'Вниз',
  'outpaint.directionLeft': 'Влево',
  'outpaint.expandSize': 'Размер расширения',
  'outpaint.overlap': 'Перекрытие',
  'outpaint.prompt': 'Что нарисовать в расширенной области',
  'outpaint.generate': 'Генерировать',
  'outpaint.regenerate': 'Перегенерировать',
  'outpaint.accept': 'Принять',
  'outpaint.cancel': 'Отмена',
  'outpaint.generating': 'Генерация...',
  'outpaint.sizeWarning': 'Результат превысит 4096px',
  'outpaint.errorGeneration': 'Ошибка генерации',
  'outpaint.errorNetwork': 'Ошибка сети',
  'outpaint.noMap': 'Загрузите карту перед расширением',
  'outpaint.expandMap': 'Расширить карту',

  // === AI Detail Pass ===
  'detail.dialogTitle': 'Генерация детальной карты',
  'detail.cropLabel': 'Фрагмент карты',
  'detail.semanticLabel': 'Описание фрагмента (авто)',
  'detail.promptPlaceholder': 'Опишите, что должно быть на детальной карте...',
  'detail.generate': 'Сгенерировать',
  'detail.accept': 'Принять',
  'detail.regenerate': 'Перегенерировать',
  'detail.cancel': 'Отмена',
  'detail.existingLink': 'Для этой области уже есть карта: {name}',
  'detail.createNew': 'Создать новую',
  'detail.regenerateExisting': 'Перегенерировать существующую',
  'detail.errorSmallRegion': 'Область слишком маленькая (минимум 64×64)',
  'detail.errorNoMap': 'У карты нет изображения',
  'detail.generating': 'Генерация...',
  'detail.accepting': 'Создание карты...',

  // === SRD Panel ===
  'srd.title': 'Справочник',
  'srd.monsters': 'Монстры',
  'srd.spells': 'Заклинания',
  'srd.classes': 'Классы',
  'srd.races': 'Расы',
  'srd.equipment': 'Снаряжение',
  'srd.magicItems': 'Маг. предметы',
  'srd.conditions': 'Состояния',
  'srd.searchPlaceholder': 'Поиск...',
  'srd.loading': 'Загрузка...',
  'srd.results': 'результатов',
  'srd.noResults': 'Ничего не найдено',
  'srd.loadMore': 'Загрузить ещё',
  'srd.back': 'Назад',
  'srd.allCR': 'Любая опасность',
  'srd.allTypes': 'Все типы',
  'srd.allLevels': 'Все уровни',
  'srd.cantrip': 'Заговор',
  'srd.level': 'Ур.',
  'srd.concentrationAbbr': 'К',
  'srd.allSchools': 'Все школы',
  'srd.allClasses': 'Все классы',
  'srd.allCategories': 'Все категории',
  'srd.allRarities': 'Все редкости',
  'srd.noFeaturesAtLevel': 'Нет новых фич на этом уровне',
  'srd.token': 'Токен',
  'srd.plusSheet': '+ Лист',

  // === Journal ===
  'journal.empty': 'Нет персонажей. Создайте во вкладке «Карта».',
  'journal.pcGroup': 'Персонажи игроков',
  'journal.npcGroup': 'NPC',
  // Journal panel
  'journal.panel.title': 'Журнал',
  'journal.panel.createEntry': 'Создать запись',
  'journal.panel.allTypes': 'Все типы',
  'journal.panel.searchPlaceholder': 'Поиск…',
  'journal.panel.noEntries': 'Записей нет',
  'journal.panel.noEntriesHint': 'Нажмите «+» чтобы создать первую запись',
  'journal.panel.noResults': 'Ничего не найдено',
  // Journal types
  'journal.type.npc': 'NPC',
  'journal.type.location': 'Локация',
  'journal.type.quest': 'Квест',
  'journal.type.faction': 'Фракция',
  'journal.type.handout': 'Документ',
  'journal.type.lore': 'Мир',
  // Journal sections (player view)
  'journal.section.quests': 'Квесты',
  'journal.section.myNotes': 'Мои заметки',
  'journal.section.knowledge': 'Знания',
  'journal.section.onThisMap': 'На этой карте',
  // Journal groups
  'journal.group.ungrouped': 'Без раздела',
  'journal.group.new': 'Новый раздел',
  'journal.group.namePlaceholder': 'Название раздела',
  'journal.group.delete': 'Удалить раздел',
  'journal.group.rename': 'Переименовать раздел',
  // Journal visibility
  'journal.visibility.gm': 'только мастер',
  'journal.visibility.personal': 'Личное',
  'journal.visibility.all': 'Все',
  // Journal context menu
  'journal.menu.edit': 'Редактировать',
  'journal.menu.reveal': 'Показать игрокам',
  'journal.menu.hide': 'Скрыть от игроков',
  'chat.system.conditionEnded': '{name}: состояние закончилось — {labels}',
  'chat.system.entryRevealed': '📖 Запись «{name}» теперь видна всем',
  'chat.system.hitDie': '{name} — кость хитов {die}: {roll} → +{healed}, ХП {hp}',
  'chat.system.deathSave.success': '{name} — спасбросок от смерти: {roll}, успех {tally}',
  'chat.system.deathSave.failure': '{name} — спасбросок от смерти: {roll}, провал {tally}',
  'chat.system.deathSave.nat20': '{name} — спасбросок от смерти: натуральная 20, приходит в себя с 1 хитом',
  'chat.system.deathSave.nat1': '{name} — спасбросок от смерти: натуральная 1, два провала {tally}',
  'chat.system.deathSave.stabilized': '{name} — спасбросок от смерти: {roll}, третий успех — стабилизирован',
  'chat.system.deathSave.died': '{name} — спасбросок от смерти: {roll}, третий провал — погибает',
  'error.character_dead': 'Персонаж мёртв: отдых, кости хитов, лечение и новый уровень не помогут — нужно воскрешение: мастер нажимает «Воскресить» в карточке спасбросков от смерти',
  'error.exhausted': 'Заряды или ячейки этого круга закончились — они вернутся после отдыха',
  'error.rest_at_zero_hp': 'Длинный отдых начинают хотя бы с 1 хитом: сначала стабилизируйте и вылечите персонажа',
  'journal.menu.pin': 'Закрепить',
  'journal.menu.unpin': 'Открепить',
  'journal.menu.delete': 'Удалить',
  // Journal delete dialog
  'journal.delete.title': 'Удалить запись?',
  'journal.delete.description': 'Это действие нельзя отменить. Запись будет удалена навсегда.',
  'journal.delete.cancel': 'Отмена',
  'journal.delete.confirm': 'Удалить',
  // Journal create dialog
  'journal.create.title': 'Новая запись',
  'journal.create.namePlaceholder': 'Название записи…',
  'journal.create.submit': 'Создать',
  // Journal preview fields
  'journal.preview.race': 'Раса',
  'journal.preview.occupation': 'Занятие',
  'journal.preview.disposition': 'Отношение',
  'journal.preview.description': 'Описание',
  'journal.preview.secrets': 'Секреты',
  'journal.preview.personality': 'Характер',
  'journal.preview.questHooks': 'Зацепки',
  'journal.preview.alive': 'Жив',
  'journal.preview.dead': 'Мёртв',
  'journal.preview.objectives': 'Цели',
  'journal.preview.gmNotes': 'Заметки мастера',
  'journal.preview.rewards': 'Награды',
  'journal.preview.attitude': 'Отношение',
  'journal.preview.content': 'Содержание',
  'journal.preview.category': 'Категория',
  // Journal disposition
  'journal.disposition.friendly': 'Дружелюбный',
  'journal.disposition.neutral': 'Нейтральный',
  'journal.disposition.hostile': 'Враждебный',
  'journal.disposition.unknown': 'Неизвестно',

  // Journal editor
  'journal.editor.namePlaceholder': 'Название записи',
  'journal.editor.gmOnly': 'Только для мастера',
  'journal.editor.reveal': 'Показать игрокам',
  'journal.editor.hide': 'Скрыть от игроков',
  'journal.editor.revealedFields': 'Видимость полей',
  'journal.editor.revealedFieldsHint': 'Отметьте поля, видимые игрокам',
  'journal.editor.revealConfirm': 'Показать "{name}" игрокам? Игроки получат уведомление.',
  'journal.editor.revealConfirmAction': 'Показать',
  'journal.editor.pin': 'Закрепить',
  'journal.editor.unpin': 'Открепить',
  'journal.editor.openEditor': 'Открыть в редакторе',
  'journal.editor.visibilityGm': 'только мастер',
  'journal.editor.visibilityAll': 'Все игроки',
  'journal.editor.tags': 'Теги',
  'journal.editor.tagsPlaceholder': 'Добавить тег...',
  'journal.editor.addItem': 'Добавить',
  'journal.editor.removeItem': 'Удалить',
  'journal.editor.edit': 'Редактировать',
  'journal.editor.done': 'Готово',
  'journal.editor.more': 'Ещё',
  'journal.editor.bindToPin': 'Привязать к маркеру',
  'journal.editor.bindToSheet': 'Привязать чарлист',
  'journal.editor.bindToPage': 'Привязать к карте',
  'journal.editor.configureFields': 'Настроить видимые поля',
  'journal.editor.noContent': 'Нет содержания',

  // Journal form: NPC
  'journal.form.npc.portrait': 'Портрет (URL)',
  'journal.form.npc.race': 'Раса',
  'journal.form.npc.occupation': 'Род занятий',
  'journal.form.npc.disposition': 'Отношение',
  'journal.form.npc.description': 'Описание',
  'journal.form.npc.personality': 'Характер',
  'journal.form.npc.secrets': 'Секреты',
  'journal.form.npc.questHooks': 'Зацепки квестов',
  'journal.form.npc.alive': 'Жив',

  // Journal form: Location
  'journal.form.location.image': 'Изображение (URL)',
  'journal.form.location.parent': 'Родительская локация',
  'journal.form.location.description': 'Описание',
  'journal.form.location.secrets': 'Секреты',
  'journal.form.location.page': 'Карта',

  // Journal form: Quest
  'journal.form.quest.status': 'Статус',
  'journal.form.quest.questGiver': 'Квестодатель',
  'journal.form.quest.description': 'Описание',
  'journal.form.quest.gmNotes': 'Заметки мастера',
  'journal.form.quest.objectives': 'Цели',
  'journal.form.quest.objectiveText': 'Текст цели',
  'journal.form.quest.objectiveCompleted': 'Выполнена',
  'journal.form.quest.objectiveHidden': 'Скрыта',
  'journal.form.quest.objectiveDescription': 'Описание цели',
  'journal.objective.saving': 'Сохраняется…',
  'journal.form.quest.rewards': 'Награды',

  // Journal form: Faction
  'journal.form.faction.description': 'Описание',
  'journal.form.faction.attitude': 'Отношение',
  'journal.form.faction.secrets': 'Секреты',

  // Journal form: Handout
  'journal.form.handout.content': 'Содержание',
  'journal.form.handout.image': 'Изображение (URL)',
  'journal.form.handout.gmNotes': 'Заметки мастера',

  // Journal form: Lore
  'journal.form.lore.category': 'Категория',
  'journal.form.lore.content': 'Видят игроки',
  'journal.form.lore.gmNotes': 'Для мастера',

  // Journal form: Disposition options
  'journal.form.disposition.friendly': 'Дружелюбный',
  'journal.form.disposition.neutral': 'Нейтральный',
  'journal.form.disposition.hostile': 'Враждебный',
  'journal.form.disposition.unknown': 'Неизвестно',

  // Journal form: Quest status options
  'journal.form.questStatus.active': 'Активный',
  'journal.form.questStatus.completed': 'Завершён',
  'journal.form.questStatus.failed': 'Провален',
  'journal.form.questStatus.hidden': 'Скрытый',

  // Journal: Links
  'journal.links.title': 'Связи',
  'journal.links.add': 'Добавить',
  'journal.links.empty': 'Нет связей. Нажмите + чтобы добавить.',
  'journal.links.relation': 'Отношение',
  'journal.links.target': 'Целевая запись',
  'journal.links.customRelation': 'Произвольное',
  'journal.links.remove': 'Удалить связь',
  'journal.links.incoming': 'Ссылаются',

  // Journal field labels (for revealedFields checkboxes)
  'journal.field.description': 'Описание',
  'journal.field.race': 'Раса',
  'journal.field.occupation': 'Род занятий',
  'journal.field.personality': 'Характер',
  'journal.field.secrets': 'Секреты',
  'journal.field.questHooks': 'Зацепки квестов',
  'journal.field.alive': 'Жив',
  'journal.field.attitude': 'Отношение',
  'journal.field.content': 'Содержание',
  'journal.field.gmNotes': 'Заметки мастера',
  'journal.field.objectives': 'Цели',
  'journal.field.rewards': 'Награды',
  'journal.field.status': 'Статус',
  'journal.field.category': 'Категория',
  'journal.field.image': 'Изображение',
  'journal.field.disposition': 'Отношение',

  // Journal: Map integration
  'journal.map.bindNote': 'Привязка к маркеру на карте',
  'journal.map.noteNotFound': 'Маркер не найден',
  'journal.map.goToMap': 'На карту',
  'journal.map.pageNotFound': 'Карта не найдена',

  // Journal: NPC CharacterSheet
  'journal.npc.bindSheet': 'Привязать лист',
  'journal.npc.linkedSheet': 'Привязанный лист',
  'journal.npc.sheetDeleted': 'Лист удалён',
  'journal.npc.openSheet': 'Открыть',
  'journal.npc.unbindSheet': 'Отвязать',

  // Journal: Relation labels
  'journal.relation.lives_in': 'Живёт в',
  'journal.relation.quest_giver': 'Квестодатель',
  'journal.relation.member_of': 'Член',
  'journal.relation.enemy_of': 'Враг',

  // === Sheet View ===
  'sheet.speed': 'Скорость',
  'sheet.initiativeMod': 'Инициатива',
  'sheet.tokenDescription': 'Описание токена',
  'sheet.tokenDescriptionPlaceholder': 'Опишите, как ваш персонаж выглядит для других',
  'sheet.tokenDescriptionHint': 'Поддерживается Markdown. Видно всем участникам.',
  'sheet.fullForm': 'Полная форма',
  'sheet.statBlock': 'Стат-блок',
  'sheet.tokenActions': 'Действия токена',
  'sheet.actionName': 'Название',
  'sheet.actionExpression': 'Выражение (1d20+5)',
  'sheet.addAction': '+ Добавить',
  'sheet.hitDice': 'Кость хитов',
  'sheet.spendHitDie': 'Потратить кость хитов',
  'sheet.featuresTraits': 'Умения и черты',
  'sheet.uses': 'использований',
  'sheet.rest': 'отдых',
  'sheet.shortRest': 'Короткий отдых',
  'sheet.longRest': 'Длинный отдых',
  'sheet.levelUp': 'Повысить уровень',
  'sheet.encumbered': 'Перегруз!',
  'sheet.rollTooltip': 'Бросить',
  'sheet.proficiency': 'мастерство',

  // === Character Wizard ===
  'wizard.createTitle': 'Создание персонажа',
  'wizard.step': 'Шаг',
  'wizard.createCharacter': 'Создать персонажа',
  'wizard.stepRace': 'Раса',
  'wizard.stepClass': 'Класс',
  'wizard.stepAbilities': 'Характеристики',
  'wizard.stepSkills': 'Навыки',
  'wizard.stepEquipment': 'Снаряжение',
  'wizard.stepSpells': 'Заклинания',
  'wizard.stepReview': 'Обзор',
  'wizard.stepBackground': 'Предыстория',
  'wizard.createDescription': 'Все выборы 1 уровня по правилам 5e: раса, класс, характеристики, предыстория, навыки, снаряжение, заклинания, внешность и характер.',
  'wizard.rebuildSheet': 'Пересоздать этот лист',
  'wizard.seededSaved': 'Выборы, с которыми создан этот персонаж: поменяйте нужное и пересоздайте лист',
  'wizard.seededRead': 'Выборы прочитаны с листа: раса, класс, предыстория, характеристики, заклинания. Навыки, языки и снаряжение выберите заново',
  'wizard.stepIncomplete': 'На этом шаге не всё выбрано',
  'wizard.abilityPlus': '+1 к {n} характеристикам на выбор',
  'wizard.ac': 'КД',
  'wizard.age': 'Возраст',
  'wizard.alignment': 'Мировоззрение',
  'wizard.alsoGet': 'Также',
  'wizard.alwaysPrepared': 'всегда подготовлено',
  'wizard.ancestry': 'Драконий предок',
  'wizard.appearance': 'Внешность',
  'wizard.attacks': 'Атаки',
  'wizard.backstory': 'История персонажа',
  'wizard.bonds': 'Привязанности',
  'wizard.cantrips': 'Заговоры',
  'wizard.classSkills': 'Навыки класса ({class})',
  'wizard.concentration': 'концентрация',
  'wizard.cost': 'цена',
  'wizard.darkvision': 'Тёмное зрение',
  'wizard.domainSpells': 'Заклинания домена',
  'wizard.equipment': 'Снаряжение',
  'wizard.expertise': 'Компетентность: {n} навыка (бонус мастерства ×2)',
  'wizard.eyes': 'Глаза',
  'wizard.favoredEnemy': 'Избранный враг',
  'wizard.favoredTerrain': 'Избранная местность',
  'wizard.features': 'Умения',
  'wizard.fixedSkills': 'Уже есть (предыстория, раса)',
  'wizard.flaws': 'Слабости',
  'wizard.fromBackground': 'От предыстории',
  'wizard.ft': 'фт',
  'wizard.gender': 'Пол',
  'wizard.gp': 'зм',
  'wizard.grantedSkills': 'Навыки',
  'wizard.hair': 'Волосы',
  'wizard.height': 'Рост',
  'wizard.hitDice': 'Кости хитов',
  'wizard.hp': 'ХП',
  'wizard.ideals': 'Идеалы',
  'wizard.initiative': 'Инициатива',
  'wizard.languages': 'Языки',
  'wizard.level1Features': 'Умения 1 уровня',
  'wizard.manualRange': 'Значения характеристик — от 3 до 18',
  'wizard.missingTitle': 'Чтобы создать персонажа, осталось выбрать:',
  'wizard.ofChoice': 'на выбор',
  'wizard.passivePerception': 'Пассивная внимательность',
  'wizard.personalityTraits': 'Черты характера',
  'wizard.pickLanguages': 'Языки на выбор',
  'wizard.pickTools': 'Инструменты на выбор',
  'wizard.pointsLeft': 'Осталось очков',
  'wizard.prepareFromBook': 'Подготовить из книги: {n}',
  'wizard.profBonus': 'Бонус мастерства',
  'wizard.proficiencies': 'Владения',
  'wizard.raceCantrip': 'Заговор высшего эльфа (из списка волшебника)',
  'wizard.raceSkills': 'Навыки расы на выбор: {n}',
  'wizard.raceTraits': 'Черты расы',
  'wizard.reroll': 'Перебросить всё (один раз)',
  'wizard.resistances': 'Сопротивления',
  'wizard.roll': 'Бросить 4к6 шесть раз',
  'wizard.rolled': 'Выпало',
  'wizard.saves': 'Спасброски',
  'wizard.skills': 'Навыки',
  'wizard.skillsCount': 'навыков: {n}',
  'wizard.slots': 'ячейки {n} круга',
  'wizard.spellAttack': 'Атака заклинанием',
  'wizard.spellDc': 'СЛ заклинаний',
  'wizard.spellInfo': 'Описание заклинания',
  'wizard.spellcasting': 'заклинания',
  'wizard.subrace': 'Подраса',
  'wizard.summary': 'Итог — как будет на листе',
  'wizard.tools': 'Инструменты',
  'wizard.weight': 'Вес',
  'wizard.shortRest': 'короткий отдых',
  'wizard.longRest': 'длинный отдых',
  'wizard.spellsHintWizard': 'В книге волшебника 6 заклинаний 1 круга; подготовить из них можно {n} (ИНТ + уровень).',
  'wizard.spellsHintKnown': 'Известные заклинания всегда готовы к применению.',
  'wizard.spellsHintPrepared': 'Жрец и друид готовят {n} заклинаний (модификатор + уровень) из всего списка класса; заменить можно после длинного отдыха.',
  'wizard.spellbook': 'Книга заклинаний (1 круг)',
  'wizard.spellsKnown': 'Известные заклинания 1 круга',
  'wizard.spellsPrepared': 'Подготовленные заклинания 1 круга',
  'wizard.any.simple': 'Простое оружие на выбор',
  'wizard.any.simple-melee': 'Простое рукопашное оружие на выбор',
  'wizard.any.martial': 'Воинское оружие на выбор',
  'wizard.any.martial-melee': 'Воинское рукопашное оружие на выбор',
  'wizard.any.instrument': 'Музыкальный инструмент на выбор',
  'wizard.any.arcane-focus': 'Магическая фокусировка',
  'wizard.any.druidic-focus': 'Фокусировка друида',
  'wizard.any.holy-symbol': 'Священный символ',
  'wizard.dragon.Black': 'Чёрный',
  'wizard.dragon.Blue': 'Синий',
  'wizard.dragon.Brass': 'Латунный',
  'wizard.dragon.Bronze': 'Бронзовый',
  'wizard.dragon.Copper': 'Медный',
  'wizard.dragon.Gold': 'Золотой',
  'wizard.dragon.Green': 'Зелёный',
  'wizard.dragon.Red': 'Красный',
  'wizard.dragon.Silver': 'Серебряный',
  'wizard.dragon.White': 'Белый',
  'wizard.method.standard-array': 'Стандартный набор',
  'wizard.method.point-buy': 'Покупка очков',
  'wizard.method.roll': 'Бросок 4к6',
  'wizard.method.manual': 'Вручную',
  'wizard.methodHint.standard-array': 'Раздайте 15, 14, 13, 12, 10, 8 — каждое число один раз.',
  'wizard.methodHint.point-buy': '27 очков; каждая характеристика от 8 до 15 до расовых бонусов.',
  'wizard.methodHint.roll': 'Шесть бросков 4к6, меньшая кость отбрасывается; раздайте результаты.',
  'wizard.methodHint.manual': 'Свои значения от 3 до 18 (например, по договорённости с мастером).',
  'wizard.missing.race': 'раса',
  'wizard.missing.race.subrace': 'подраса',
  'wizard.missing.race.ancestry': 'драконий предок',
  'wizard.missing.race.abilityPlus': '+1 к двум характеристикам (раса)',
  'wizard.missing.race.skills': 'навыки расы',
  'wizard.missing.race.cantrip': 'заговор расы',
  'wizard.missing.class': 'класс',
  'wizard.missing.class.subclass': 'подкласс (домен, происхождение, покровитель)',
  'wizard.missing.class.option': 'выбор умения',
  'wizard.missing.class.favoredEnemy': 'избранный враг',
  'wizard.missing.class.favoredTerrain': 'избранная местность',
  'wizard.missing.class.expertise': 'компетентность',
  'wizard.missing.skills': 'навыки класса',
  'wizard.missing.background': 'предыстория',
  'wizard.missing.languages': 'языки',
  'wizard.missing.tools': 'инструменты',
  'wizard.missing.abilities': 'характеристики (3–18, все шесть)',
  'wizard.missing.abilities.pointBuy': 'покупка очков: не больше 27, от 8 до 15',
  'wizard.missing.spells.cantrips': 'заговоры',
  'wizard.missing.spells.level1': 'заклинания 1 круга',
  'wizard.missing.spells.prepared': 'подготовленные заклинания',
  'wizard.missing.name': 'имя',
  'wizard.subclass.cleric': 'Божественный домен',
  'wizard.subclass.sorcerer': 'Происхождение чародея',
  'wizard.subclass.warlock': 'Потусторонний покровитель',
  'wizard.enemy.aberrations': 'Аберрации',
  'wizard.enemy.beasts': 'Звери',
  'wizard.enemy.celestials': 'Небожители',
  'wizard.enemy.constructs': 'Конструкты',
  'wizard.enemy.dragons': 'Драконы',
  'wizard.enemy.elementals': 'Элементали',
  'wizard.enemy.fey': 'Феи',
  'wizard.enemy.fiends': 'Исчадия',
  'wizard.enemy.giants': 'Великаны',
  'wizard.enemy.monstrosities': 'Чудовища',
  'wizard.enemy.oozes': 'Слизи',
  'wizard.enemy.plants': 'Растения',
  'wizard.enemy.undead': 'Нежить',
  'wizard.enemy.humanoids-two-races': 'Гуманоиды (две расы)',
  'wizard.terrain.arctic': 'Полярная тундра',
  'wizard.terrain.coast': 'Побережье',
  'wizard.terrain.desert': 'Пустыня',
  'wizard.terrain.forest': 'Лес',
  'wizard.terrain.grassland': 'Луга',
  'wizard.terrain.mountain': 'Горы',
  'wizard.terrain.swamp': 'Болото',
  'wizard.terrain.underdark': 'Подземье',

  // === Conditions (D&D) ===
  'condition.blinded': 'Ослеплён',
  'condition.charmed': 'Очарован',
  'condition.deafened': 'Оглушён',
  'condition.frightened': 'Испуган',
  'condition.grappled': 'Схвачен',
  'condition.incapacitated': 'Недееспособен',
  'condition.invisible': 'Невидим',
  'condition.paralyzed': 'Парализован',
  'condition.petrified': 'Окаменён',
  'condition.poisoned': 'Отравлен',
  'condition.prone': 'Распластан',
  'condition.restrained': 'Сдержан',
  'condition.stunned': 'Ошеломлён',
  'condition.unconscious': 'Без сознания',
  'condition.exhaustion': 'Истощён',
  'condition.concentration': 'Концентрация',

  // === Toast messages ===
  'toast.mapUploaded': 'Карта загружена:',
  'toast.mapUploadError': 'Ошибка загрузки карты',
  'toast.tokenAdded': 'Токен добавлен:',
  'toast.tokenCreated': 'Токен создан:',
  'toast.sessionSaved': 'Сессия сохранена',
  'toast.sessionLoaded': 'Сессия загружена',

  // === Server Error Codes ===
  'error.INVALID_TOKEN': 'Невалидный токен',
  'error.USER_NOT_FOUND': 'Пользователь не найден',
  'error.sessionError': 'Ошибка сессии',
  'error.SESSION_NOT_FOUND': 'Сессия не найдена',
  'error.NOT_AUTHORIZED': 'Нет доступа',
  'error.UNAUTHORIZED': 'Нет доступа',
  'error.NO_SKETCH': 'Скетч не загружен',
  'error.INVALID_PROMPT': 'Промпт обязателен (1-1000 символов)',
  'error.PAGE_NOT_FOUND': 'Карта не найдена',
  'error.AI_UNAVAILABLE': 'Модель недоступна',
  'error.TIMEOUT': 'Генерация заняла слишком долго. Попробуйте снова',
  'error.AI_ERROR': 'Ошибка генерации. Попробуйте снова',
  'error.AUTH_REQUIRED': 'Требуется вход в аккаунт',
  'error.BAD_REQUEST': 'Неверный запрос',
  'error.NOT_FOUND': 'Не найдено',
  'error.FORBIDDEN': 'Нет прав на это действие',

  // === Pluralization ===
  'plural.participant_one': 'участник',
  'plural.participant_few': 'участника',
  'plural.participant_many': 'участников',
  'plural.day_one': 'день',
  'plural.day_few': 'дня',
  'plural.day_many': 'дней',

  // === AppShell session bar ===
  'session.label': 'Сессия:',
  'session.participantsLabel': 'Участники:',
  'session.disconnect': 'Выйти',
  'session.expandSidebar': 'Развернуть боковую панель',
  'session.collapseSidebar': 'Свернуть боковую панель',
  'session.detachPanel': 'Открепить панель',
  'session.panelDetached': 'Панель открыта в отдельном окне',
  'session.roleGM': 'Мастер',
  'session.rolePlayer': 'Игрок',
  'session.connectionLost': 'Соединение потеряно. Переподключение...',
  'session.connectionRestored': 'Соединение восстановлено',
  'session.sessionCreated': 'Сессия создана',
  'session.sessionJoined': 'Вы присоединились к сессии',
  'session.participantJoined': 'присоединился к сессии',
  'session.participantLeft': 'покинул сессию',
  'session.pageCreated': 'создана',
  'session.sheetCreated': 'создан',

  // === Input Dialog ===
  'inputDialog.cancel': 'Отмена',
  'inputDialog.confirm': 'Подтвердить',
  'inputDialog.tooLong': 'Не длиннее {max} знаков — сервер такое не примет.',

  // === Confirm Dialog ===
  'confirmDialog.replaceBinding': 'Заменить привязку',
  'confirmDialog.replaceBindingDesc': 'уже привязан к листу. Заменить привязку на',
  'confirmDialog.replace': 'Заменить',

  // === AppDialogs ===
  'appDialogs.loading': 'Загрузка...',

  // === File upload ===
  'upload.mapLoaded': 'Карта загружена:',
  'upload.mapError': 'Ошибка загрузки карты',
  'upload.tokenAdded': 'Токен добавлен:',

  // === Misc ===
  'misc.drawingsCleared': 'Рисунки очищены',
  'misc.sessionSaved': 'Сессия сохранена',
  'misc.sessionLoaded': 'Сессия загружена',
  'misc.loadError': 'Ошибка загрузки файла',
  'misc.hpDialogTitle': 'ХП для',
  'misc.hpDialogHint': 'Число — новые ХП. «-4» или «+3» — урон или лечение от текущих.',
  'misc.resizeDialogTitle': 'Размер (клетки): 0.5, 1, 2, 3, 4:',
  'misc.newTokenDialogTitle': 'Имя нового токена:',

  // === AI Confirm Card ===
  'aiConfirm.details': 'Подробнее',
  'aiConfirm.cancel': 'Отмена',
  'aiConfirm.create': 'Создать',

  // === Chat Roll ===
  'chatRoll.crit': 'Крит!',
  'chatRoll.fumble': 'Провал!',
  'chatRoll.damage': 'Урон',

  // === Condition Tooltip ===
  'conditionTooltip.noDescription': 'Описание не задано',

  // === Confirm Dialog defaults ===
  'confirmDialog.confirm': 'Подтвердить',
  'confirmDialog.cancel': 'Отмена',

  // === Effects Panel ===
  'effects.title': 'Активные эффекты',
  'effects.empty': 'Нет активных эффектов',
  'effects.enable': 'Включить',
  'effects.disable': 'Отключить',
  'effects.remove': 'Удалить',
  'effects.addEffect': '+ Добавить эффект',
  'effects.source': 'Источник',
  'effects.target': 'Цель',
  'effects.mode': 'Режим',
  'effects.value': 'Значение',
  'effects.add': 'Добавить',

  // === AI Map generation count ===
  'aiMap.generationCount': 'генерация',

  // === Note Editor placeholders ===
  'notes.titlePlaceholder': 'Название заметки...',
  'notes.contentPlaceholder': 'Текст заметки (markdown)...',
  'notes.noContent': 'Нет содержимого',
  'notes.quickCreate': 'Быстрое создание',
  'notes.setParent': 'Переместить в...',
  'notes.moveToRoot': 'Переместить в корень',

  // === Map Pins ===
  'pins.title': 'Маркеры на карте',
  'pins.empty': 'Нет маркеров. Нажмите на карту, чтобы создать.',
  'pins.newPin': 'Новый маркер',
  'pins.editPin': 'Редактировать маркер',
  'pins.icon': 'Иконка',
  'pins.color': 'Цвет',
  'pins.selectColor': 'Выбрать цвет',
  'pins.gmOnly': 'Только для мастера',
  'pins.ownerOnly': 'Только для автора',
  'pins.visibility': 'Видимость',
  'pins.linkedEntry': 'Связанная запись журнала',
  'pins.orphan': 'Нет связанной записи',
  'pins.unlinkEntry': 'Отвязать запись',
  'pins.linkEntry': 'Привязать запись...',
  'pins.delete': 'Удалить маркер',
  'pins.deleteConfirm': 'Удалить этот маркер?',
  'pins.deleteConfirmDesc': 'Маркер исчезнет с карты у всех. Связанная запись журнала останется.',
  'pins.created': 'Маркер создан',
  'pins.deleted': 'Маркер удалён',
  'pins.limitReached': 'Достигнут лимит маркеров (максимум 100 на карте)',
  'pins.quickCreate': 'Быстрое создание',
  'pins.noEntry': 'Нет записи',
  'pins.journalEntry': 'Запись журнала',
  'pins.selectEntry': 'Выбрать запись...',
  'pins.visibilityAll': 'Видно всем',
  'pins.showAskTitle': 'Показать игрокам?',
  'pins.showAskBody': 'Игроки увидят этот маркер и его текст. Передумать можно в любой момент — выбрав «Только для мастера».',

  // === Fullscreen Mini Panel ===
  'fullscreen.round': 'Раунд:',
  'fullscreen.nextTurn': 'Следующий ход',
  'fullscreen.exitFullscreen': 'Выйти из полноэкранного режима',

  // === Location Breadcrumb ===
  'breadcrumb.back': '← Назад',

  // === Navigate Request Toast ===
  'navigate.wantsToGoTo': 'хочет перейти в',
  'navigate.deny': 'Отклонить',
  'navigate.approve': 'Одобрить',

  // === NPC Stat Block ===
  'npc.conditions': 'Состояния:',
  'npc.attacks': 'Атаки',
  'npc.rollAbility': 'Бросить',
  'npc.checkAbility': 'Проверка',
  'npc.rollAttack': 'Бросить атаку',
  'npc.abilityStr': 'СИЛ',
  'npc.abilityDex': 'ЛОВ',
  'npc.abilityCon': 'ТЕЛ',
  'npc.abilityInt': 'ИНТ',
  'npc.abilityWis': 'МДР',
  'npc.abilityCha': 'ХАР',

  // === PopoutWindow ===
  'popout.close': 'Закрыть',

  // === Portrait Upload ===
  'portrait.fileTooLarge': 'Файл слишком большой (макс. 10 МБ)',
  'portrait.networkError': 'Ошибка сети',
  'portrait.alt': 'Портрет',

  // === Repeating Section ===
  'repeating.add': '+ Добавить',
  'repeating.empty': 'Нет записей',
  'repeating.remove': 'Удалить',
  'repeating.showAll': 'Показать все',
  'repeating.hidden': 'скрыто',

  // === Selection Bar ===
  'selectionBar.inspect': 'Описание',
  'selectionBar.edit': 'Редактировать',
  'selectionBar.conditions': 'Состояния',
  'selectionBar.delete': 'Удалить',

  // === Sheet Modal ===
  'sheetModal.popout': 'Открыть в отдельном окне',
  'sheetModal.templateNotFound': 'Шаблон не найден',

  // === Spell Slots Widget ===
  'spells.slotsTitle': 'Ячейки заклинаний',
  'spells.noSlots': 'Нет ячеек заклинаний',
  'spells.level': 'Уровень',
  'spells.spendSlot': 'Потратить ячейку',
  'spells.spent': 'Потрачена',

  // === Token Inspect Popup ===
  'tokenInspect.gmNotes': 'Заметки мастера (скрыты от игроков)',
  'tokenInspect.openSheet': 'Открыть лист персонажа',
  'tokenInspect.ac': 'КД:',

  // === Sidebar detached tab ===
  'sidebar.detached': 'открепл.',
  'sidebar.notification': 'Новое уведомление',

  // === SrdPanel filter placeholders ===
  'srd.filterType': 'Тип',
  'srd.filterLevel': 'Уровень',
  'srd.filterSchool': 'Школа',
  'srd.filterClass': 'Класс',
  'srd.filterCategory': 'Категория',
  'srd.filterRarity': 'Редкость',

  // === Dialog close ===
  'dialog.close': 'Закрыть',

  // === Token Panel preset ===
  'tokens.presetToken': 'Токен',

  // === Session Page Tabs ===
  'sessionPage.sessionsTab': 'Сессии',
  'sessionPage.profileTab': 'Профиль',

  // === App (lobby) ===
  'app.profile': 'Профиль',
  'app.logout': 'Выйти',
  'app.joinByCode': 'Присоединиться по коду',

  // === AI Error Messages ===
  'aiError.serviceUnavailable': 'Тиа временно недоступна',
  'aiError.noModelKey': 'Нет ключа модели: Тиа не может ответить. Задайте ключ на сервере.',
  'aiError.noModelPlayer': 'Тиа сейчас не отвечает: у мастера не подключена модель.',
  'aiError.rateLimit': 'Слишком много запросов. Подождите минуту.',
  'aiError.networkError': 'Ошибка сети. Проверьте подключение.',
  'aiError.timeout': 'Таймаут: Тиа не отвечает',
  'aiError.sendError': 'Ошибка отправки сообщения',
  'aiError.gmOnly': 'Тиа доступна только мастеру',
  'aiError.voicePermissionDenied': 'Доступ к микрофону запрещён. Разрешите в настройках браузера.',
  'aiError.voiceNotAvailable': 'Голосовой ввод недоступен.',
  'aiError.tokenBudget': 'Лимит токенов исчерпан. Попробуйте позже.',
  'aiError.playerAiDisabled': 'Тиа для игроков отключена мастером.',

  // === Player AI ===
  'playerAi.title': 'Тиа',
  'playerAi.send': 'Отправить',
  'playerAi.newChat': 'Новый чат',

  // === Game System ===
  'gameSystem.label': 'Игровая система',
  'gameSystem.dnd5e': 'D&D 5e',
  'gameSystem.pf2e': 'Pathfinder 2e',
  'gameSystem.generic': 'Универсальная',
  'srd.unavailable': 'Справочник доступен только для D&D 5e',

  // === Auth Errors ===
  'authError.loginError': 'Ошибка входа',
  'authError.registerError': 'Ошибка регистрации',
  'authError.updateError': 'Ошибка обновления профиля',
  'authError.networkError': 'Ошибка сети',

  // === Chat ===
  'chat.defaultName': 'Мастер',

  // === Chat Sound Settings ===
  'chat.sound.settings': 'Настройки звука чата',
  'chat.sound.volume': 'Громкость',
  'chat.sound.mute': 'Выключить звук',
  'chat.sound.chatEnabled': 'Звук сообщений',
  'chat.sound.diceEnabled': 'Звук бросков',

  // === Ruler / Measurement ===
  'ruler.ft': 'фт',
  'ruler.total': 'Итого:',

  // === Token copy ===
  'tokens.copySuffix': '(копия)',

  // === Sidebar: Alerts ===
  'sidebar.alerts': 'Эффекты',

  // === Sidebar: Timeline ===
  'sidebar.timeline': 'Летопись',
  'sidebar.plan': 'План',

  // === Alerts ===
  'alerts.title': 'Эффекты',
  'alerts.create': 'Создать эффект',
  'alerts.edit': 'Редактировать эффект',
  'alerts.delete': 'Удалить',
  'alerts.trigger': 'Запустить',
  'alerts.emptyTitle': 'Нет эффектов',
  'alerts.emptyHint': 'Создайте первый эффект для усиления атмосферы',
  'alerts.presets': 'Пресеты',
  'alerts.triggerActive': 'Авто-триггер активен',
  'alerts.nameLabel': 'Название',
  'alerts.visualLabel': 'Визуал (GIF/WebM/PNG/JPEG/WebP)',
  'alerts.soundLabel': 'Звук (MP3/OGG)',
  'alerts.layoutLabel': 'Расположение',
  'alerts.durationLabel': 'Длительность',
  'alerts.volume': 'Громкость',
  'alerts.triggerLabel': 'Триггер',
  'alerts.customEventPlaceholder': 'Название события',
  'alerts.triggerEnabledLabel': 'Включить авто-триггер',
  'alerts.deleteConfirmTitle': 'Удалить эффект?',
  'alerts.deleteConfirmDesc': 'Эффект и связанные медиа-файлы будут удалены навсегда.',
  'alerts.preset.critical-hit': 'Критический удар',
  'alerts.preset.character-death': 'Смерть персонажа',
  'alerts.preset.combat-start': 'Начало боя',
  'alerts.preset.new-location': 'Новая локация',
  'alerts.layout.fullscreen': 'Полный экран',
  'alerts.layout.banner-top': 'Баннер сверху',
  'alerts.layout.banner-bottom': 'Баннер снизу',
  'alerts.duration.auto': 'Авто',
  'alerts.duration.manual': 'Вручную',
  'alerts.trigger.manual': 'Вручную',
  'alerts.trigger.initiative:start': 'Начало инициативы',
  'alerts.trigger.initiative:round': 'Новый раунд',
  'alerts.trigger.token:death': 'Смерть токена',
  'alerts.trigger.roll:critical': 'Критический удар',
  'alerts.trigger.roll:fumble': 'Критический промах',
  'alerts.trigger.page:activate': 'Смена карты',
  'trigger.askShow': 'Сработал триггер — показать игрокам: {what}?',
  'trigger.show': 'Показать',
  'trigger.notNow': 'Не сейчас',
  'alerts.trigger.custom': 'Произвольный',
  'alerts.mediaSection': 'Медиа',
  'alerts.settingsSection': 'Настройки',
  'alerts.triggerSection': 'Триггер',
  'alerts.limitCounter': 'Эффектов: {count}/{max}',
  'alerts.limitWarning': 'Приближается лимит эффектов',
  'alerts.limitReached': 'Достигнут лимит эффектов (50)',
  'alerts.triggerLimitReached': 'Достигнут лимит авто-триггеров (20)',
  'alerts.sound.settings': 'Настройки звука эффектов',
  'alerts.sound.volume': 'Громкость',
  'alerts.sound.mute': 'Выключить звук',
  'alerts.error.nameRequired': 'Введите название (1-100 символов)',
  'alerts.error.durationRange': 'Длительность от 1 до 30 секунд',
  'alerts.error.customEventRequired': 'Укажите название события',
  'alerts.error.fileTooLarge': 'Максимальный размер файла — 10 МБ',
  'alerts.error.uploadFailed': 'Ошибка загрузки файла',

  // === Stickers ===
  'sticker.title': 'Стикеры',
  'sticker.cooldown': 'Подождите:',
  'sticker.cooldownUnit': 'с',
  'sticker.createPack': 'Создать пак',
  'sticker.connectPack': 'Подключить',
  'sticker.editPack': 'Редактировать',
  'sticker.deletePack': 'Удалить пак',
  'sticker.disconnectPack': 'Отключить',
  'sticker.emptyTitle': 'Нет подключённых стикер-паков',
  'sticker.emptyHint': 'Создайте пак или подключите существующий',
  'sticker.noStickers': 'Пока нет стикеров',
  'sticker.packName': 'Имя пака',
  'sticker.packNamePlaceholder': 'Мемы группы',
  'sticker.stickerCount': 'стикеров',
  'sticker.uploadHint': 'PNG, WebP · до 2 МБ',
  'sticker.uploadDragHint': 'Перетащите файлы сюда',
  'sticker.uploadBrowse': 'Выбрать файлы',
  'sticker.limitReached': 'Достигнут лимит стикеров',
  'sticker.connectTitle': 'Подключить стикер-пак',
  'sticker.connectButton': 'Подключить',
  'sticker.allConnected': 'Все ваши стикер-паки уже подключены к этой сессии',
  'sticker.noPacks': 'У вас нет стикер-паков',
  'sticker.createFirst': 'Создайте первый!',
  'sticker.deleteConfirmTitle': 'Удалить стикер-пак?',
  'sticker.deleteConfirmMessage': 'Пак и все стикеры будут удалены безвозвратно',
  'sticker.disconnectConfirmTitle': 'Отключить стикер-пак?',
  'sticker.disconnectConfirmMessage': 'Стикеры из этого пака станут недоступны в сессии',
  'sticker.builtIn': 'Встроенные',
  'sticker.custom': 'Кастомные',
  'sticker.done': 'Готово',
  'sticker.cancel': 'Отмена',
  'sticker.close': 'Закрыть',
  'sticker.unavailable': 'Стикер недоступен',
  'sticker.emptyPack': 'Пустой пак',
  'sticker.error.formatInvalid': 'Поддерживаются только PNG и WebP',
  'sticker.error.fileTooLarge': 'Файл слишком большой (макс. 2 МБ)',
  'sticker.error.tooManyUploads': 'Слишком много загрузок, подождите',
  'sticker.error.packNotFound': 'Стикер-пак не найден',
  'sticker.error.uploadFailed': 'Ошибка загрузки стикера',
  'sticker.error.limitExceeded': 'Достигнут лимит стикеров в паке',
  'sticker.mediaTab.alerts': 'Эффекты',
  'sticker.mediaTab.stickers': 'Стикеры',

  // === Release Notes ===
  'releaseNotes.badgeNew': 'Новая функция',
  'releaseNotes.title': 'Что нового',
  'releaseNotes.menuItem': 'Что нового',
  'releaseNotes.sectionNew': 'Новое',
  'releaseNotes.sectionFix': 'Исправления',
  'releaseNotes.sectionImprovement': 'Улучшения',
  'releaseNotes.currentVersion': 'Текущая версия',
  'releaseNotes.learnMore': 'Подробнее',
  'releaseNotes.version': 'Версия',
  'releaseNotes.empty': 'Нет записей о релизах',

  // === Mobile ===
  'mobile.overflowMenu': 'Ещё',
  'mobile.aiChat': 'Тиа',
  'mobile.chat': 'Чат',
  'mobile.sheet': 'Лист',
  'mobile.initiative': 'Иниц.',
  'mobile.dice': 'Кубики',
  'mobile.voiceInput': 'Голосовой ввод',
  'mobile.voiceListening': 'Слушаю...',
  'mobile.voiceError': 'Ошибка распознавания',
  'mobile.voiceNotSupported': 'Голосовой ввод не поддерживается',

  'mobile.tokenPlaced': 'Токен размещён',

  // === Mobile Canvas (024-2) ===
  'mobile.tokenPopup.hp': 'ХП',
  'mobile.tokenPopup.close': 'Закрыть',
  'mobile.tokenPopup.conditions': 'Состояния',

  // === Mobile Touch Interactions (024-3) ===
  'mobile.characterSheet.aiHint': 'Попробуйте: скажите Тиа, что изменить',
  'mobile.characterSheet.aiHintDismiss': 'Понятно',

  // === PWA (024-4) ===
  'pwa.offlineBanner': 'Нет подключения к серверу',
  'pwa.installPrompt': 'Установите roll1 на домашний экран',
  'pwa.installButton': 'Установить',
  'pwa.installDismiss': 'Не сейчас',

  // === Push Notifications (024-5) ===
  'push.promptTitle': 'Получать уведомления о ходах?',
  'push.promptAllow': 'Разрешить',
  'push.promptDismiss': 'Не сейчас',

  // === Bug Report ===
  'bugReport.title': 'Сообщить о баге',
  'bugReport.description': 'Опишите проблему — контекст элемента и сессии добавится автоматически.',
  'bugReport.titleLabel': 'Заголовок',
  'bugReport.titlePlaceholder': 'Кратко опишите проблему...',
  'bugReport.descriptionLabel': 'Подробности',
  'bugReport.descriptionPlaceholder': 'Шаги для воспроизведения, ожидаемое/фактическое поведение...',
  'bugReport.cancel': 'Отмена',
  'bugReport.submit': 'Сообщить об ошибке',
  'bugReport.submitted': 'Открыта страница создания issue на GitHub',
  'bugReport.menuItem': 'Сообщить о баге',
  'bugReport.rateLimited': 'Слишком много отчётов. Подождите.',
  'bugReport.retryIn': 'Повтор через {{seconds}}с',

  // === Undo/Redo (032-A) ===
  'undo.tokenMove': 'Переместить токен',

  // === AoE Templates (037) ===
  'aoe.cone': 'Конус',
  'aoe.sphere': 'Сфера',
  'aoe.cube': 'Куб',
  'aoe.line': 'Линия',
  'aoe.cylinder': 'Цилиндр',
  'aoe.size': 'Размер (фт)',
  'aoe.color': 'Цвет',
  'aoe.label': 'Заклинание',
  'aoe.clearAll': 'Убрать все',
  'aoe.autoRemove': 'Авто-удаление',
  'aoe.durationNone': 'Нет',
  'aoe.duration1Round': '1 раунд (6с)',
  'aoe.duration1Min': '1 мин',
  'aoe.duration10Min': '10 мин',
  'spellAoe.aim': 'Примерить зону от своего токена',
  'spellAoe.noToken': 'Поставьте токен персонажа на карту',
  'spellAoe.noTokenGm': 'Выберите токен на карте',
  'spellAoe.keep': 'Оставить на карте',
  'spellAoe.cancel': 'Отмена',
  'spellAoe.title': '{spell} · {shape} {size} фт',
  'spellAoe.hintAim': 'Ведите курсор (палец) по карте. Esc — отмена',
  'spellAoe.hintCone': 'Начало у токена, направление — куда указываете. Esc — отмена',
  'spellAoe.outOfRange': 'Дальше дистанции заклинания ({range} фт)',
  'spellAoe.offer': 'Зона заклинания: {spell}',
  'spellAoe.offerAction': 'Примерить',
  'spellAoe.hintOriginTurn': 'Нажмите — точка начала в пределах дистанции, ведите — поворот. Esc — отмена',

  // === Roll Card (037) ===
  'rollCard.hit': 'Попадание!',
  'rollCard.miss': 'Промах',
  'rollCard.damage': 'Урон',
  'rollCard.crit': 'Крит!',
  'rollCard.fumble': 'Провал!',
  'rollCard.breakdown': 'Детали',
  'rollCard.audit': 'Полный лог',

  // === Action HUD (037) ===
  'actionHud.attack': 'Атаки',
  'actionHud.spell': 'Заклинания',
  'actionHud.ability': 'Умения',
  'actionHud.other': 'Прочее',
  'actionHud.compact': 'Компактный',
  'actionHud.expanded': 'Подробный',
  'actionHud.icon': 'Иконка',
  'actionHud.color': 'Цвет',

  // === Death Save (037) ===
  'deathSave.dying': 'Умирает',
  'deathSave.stable': 'Стабилизирован',
  'deathSave.dead': 'Мёртв',
  'deathSave.alive': 'Жив',
  'deathSave.roll': 'Бросить спасбросок',
  'deathSave.success': 'Успех',
  'deathSave.failure': 'Провал',
  'deathSave.nat20': 'Чудо! Персонаж приходит в сознание.',
  'deathSave.nat1': 'Критический провал! Два провала.',
  'deathSave.stabilized': 'Персонаж стабилизирован.',
  'deathSave.died': 'Персонаж мёртв.',

  // === Concentration (037) ===
  'concentration.broken': 'Концентрация сорвана!',
  'concentration.maintained': 'Концентрация удержана',
  'concentration.dc': 'СЛ {dc}',

  // === Condition: Dead (037) ===
  'condition.dead': 'Мёртв',

  // === Mobile Content Access (034-phase-4) ===
  'mobile.switchLanguage': 'Язык',
  'mobile.notes': 'Заметки',
  'mobile.journal': 'Журнал',
  'mobile.map': 'Карты',
  'mobile.timeline': 'Летопись',
  'mobile.srd': 'Справочник',
  'sheetModal.clickToEditName': 'Нажмите для редактирования',

  // === Map Objects ===
  'mapObject.empty': 'Нет объектов на этой карте.',
  'mapObject.createObject': 'Создать объект',
  'mapObject.title': 'Объекты карты',
  'mapObject.deleteConfirmTitle': 'Удалить объект карты?',
  'mapObject.deleteConfirmDesc': '«{name}» исчезнет с карты у всех.',
  'mapObject.visibleAll': 'Видно всем',
  'mapObject.gmOnly': 'Только мастер',
  'mapObject.noun': 'Объект карты',
  'mapObject.label': 'Название',
  'mapObject.description': 'Описание',
  'mapObject.category': 'Категория',
  'mapObject.properties': 'Свойства',
  'mapObject.cover': 'Укрытие',
  'mapObject.coverNone': 'Нет',
  'mapObject.coverHalf': 'Половинное',
  'mapObject.coverThreeQuarter': '3/4',
  'mapObject.coverFull': 'Полное',
  'mapObject.state': 'Состояние',
  'mapObject.stateNone': 'Нет',
  'mapObject.stateClosed': 'Закрыто',
  'mapObject.stateOpen': 'Открыто',
  'mapObject.stateBroken': 'Сломано',
  'mapObject.stateLit': 'Зажжено',
  'mapObject.stateExtinguished': 'Погашено',
  'mapObject.traversable': 'Проходимость',
  'mapObject.difficultTerrain': 'Труднопроходимая местность',
  'mapObject.hp': 'ХП',
  'mapObject.maxHp': 'Макс. ХП',
  'mapObject.locked': 'Заперто',
  'mapObject.damage': 'Урон',
  'mapObject.light': 'Свет',
  'mapObject.lightRadius': 'Радиус (фт)',
  'mapObject.lightColor': 'Цвет',
  'mapObject.display': 'Отображение',
  'mapObject.displayColor': 'Цвет',
  'mapObject.icon': 'Иконка',
  'mapObject.opacity': 'Прозрачность',
  'mapObject.visibility': 'Видимость',
  'mapObject.visibilityGm': 'Мастер',
  'mapObject.visibilityAll': 'Все',
  'mapObject.interactable': 'Взаимодействие',
  'mapObject.catFurniture': 'Мебель',
  'mapObject.catTerrain': 'Рельеф',
  'mapObject.catHazard': 'Опасность',
  'mapObject.catDoor': 'Дверь',
  'mapObject.catContainer': 'Контейнер',
  'mapObject.catLight': 'Освещение',
  'mapObject.catCustom': 'Другое',
  'mapObject.coverHalfBadge': 'Половинное укрытие',
  'mapObject.coverThreeQuarterBadge': 'Укрытие 3/4',
  'mapObject.coverFullBadge': 'Полное укрытие',

  // === Fog Confirm Dialogs ===
  'fog.confirmCoverAll.title': 'Покрыть всё туманом?',
  'fog.confirmCoverAll.description': 'Вся карта будет покрыта туманом войны. Это действие нельзя отменить.',
  'fog.confirmClearAll.title': 'Убрать весь туман?',
  'fog.confirmClearAll.description': 'Весь туман войны будет убран с карты. Это действие нельзя отменить.',
  'fog.confirm.confirm': 'Подтвердить',
  'fog.confirm.cancel': 'Отмена',

  // === Quick Access Panel ===
  'quickAccess.title': 'Быстрый доступ',
  'quickAccess.empty': 'Закрепите инструменты, броски или макросы',
  'quickAccess.add': 'Добавить',
  'quickAccess.remove': 'Удалить',
  'quickAccess.collapse': 'Свернуть',
  'quickAccess.expand': 'Развернуть',
  'quickAccess.close': 'Закрыть',
  'quickAccess.categoryTool': 'Инструмент',
  'quickAccess.categoryRoll': 'Бросок',
  'quickAccess.categoryMacro': 'Макрос',
  'quickAccess.rollLabel': 'Метка',
  'quickAccess.rollFormula': 'Формула',
  'quickAccess.macroLabel': 'Метка',
  'quickAccess.macroCommands': 'Команды (по одной на строку)',
  'quickAccess.invalidFormula': 'Некорректная формула кубиков',
  'quickAccess.limitReached': 'Максимум 20 элементов',
  'quickAccess.duplicateTool': 'Инструмент уже добавлен',
  'quickAccess.macroCommandCount': '{count} команд(ы)',
  'quickAccess.categoryAction': 'Действие',
  'quickAccess.categoryTab': 'Вкладка',
  'quickAccess.sectionPinned': 'Закреплённые',
  'quickAccess.sectionRecent': 'Недавние',
  'quickAccess.noSheetsWithActions': 'Нет листов с действиями',
  'quickAccess.duplicateAction': 'Действие уже добавлено',
  'quickAccess.duplicateTab': 'Вкладка уже добавлена',
  'shortcuts.toggleQuickAccess': 'Панель быстрого доступа',

  // === Settings Dialog ===
  'settings.title': 'Настройки',
  'settings.tab.ai': 'Тиа',
  'settings.tab.campaign': 'Кампания',
  'settings.tab.display': 'Отображение',
  'settings.tab.combat': 'Правила боя',
  'settings.tab.permissions': 'Права',
  'settings.tab.resources': 'Ресурсы',
  'settings.resources.gmOnly': 'Ресурсы кампании видит только мастер.',
  'settings.resources.loadError': 'Не удалось загрузить статистику',
  'settings.resources.tokens30d': 'Токены Тии · 30 дней',
  'settings.resources.money30d': 'Расход Тии за период',
  'settings.resources.moneyText': 'текст',
  'settings.resources.moneyImage': 'картинки',
  'settings.resources.moneyVoice': 'голос',
  'settings.resources.moneyBilled': 'к оплате',
  'settings.resources.players': 'игроки',
  'settings.resources.tokensAllTime': 'Токены Тии · всего',
  'settings.resources.allTimeHint': 'за всю историю кампании',
  'settings.resources.interactions30d': 'Запросов к Тии · 30 дней',
  'settings.resources.chartTitle': 'Расход токенов по дням (30 дней)',
  'settings.resources.tokensUnit': 'токенов',
  'settings.resources.interactionsUnit': 'запросов',
  'settings.resources.tableToggle': 'Показать таблицей',
  'settings.resources.colDay': 'День',
  'settings.resources.colTokens': 'Токены',
  'settings.resources.colInteractions': 'Запросы',

  // AI tab
  'settings.ai.worldDescription': 'Описание мира',
  'settings.ai.worldDescriptionPlaceholder': 'Опишите мир, сеттинг, ключевые локации...',
  'settings.ai.houseRules': 'Домашние правила',
  'settings.ai.houseRulesPlaceholder': 'Кастомные правила или модификации...',
  'settings.ai.tone': 'Тон',
  'settings.ai.gmInstructions': 'Инструкции мастера',
  'settings.ai.gmInstructionsPlaceholder': 'Инструкции для Тии...',
  'settings.ai.excludedEntities': 'Исключённые сущности (спойлер-гард)',
  'settings.ai.searchEntities': 'Поиск персонажей, заметок...',
  'settings.ai.sectionPriority': 'Приоритет секций контекста Тии',
  'settings.ai.briefingFocus': 'Фокус сессии',
  'settings.ai.briefingFocusDesc': 'О чём эта сессия — Тиа ставит это выше общего контекста',
  'settings.ai.briefingFocusPlaceholder': 'напр. Партия проникает на бал-маскарад герцога...',
  'settings.ai.briefingActiveNpcs': 'Активные NPC',
  'settings.ai.briefingActiveNpcsDesc': 'Имена через запятую, которых Тиа держит «на сцене» в этой сессии',
  'settings.ai.briefingActiveNpcsPlaceholder': 'Герцог Алдрик, капитан Вэй, незнакомец в маске',
  'settings.ai.snapshotsLabel': 'Снимки изменений Тии (для отката)',
  'settings.ai.deleteWithoutAsking': 'Тиа удаляет без спроса',
  'settings.ai.deleteWithoutAskingDesc': 'Выключено — каждое удаление записи, листа, бита, события, развилки, связи или маркера ждёт твоей кнопки, на ней видно, что уйдёт вместе. Включено — Тиа удаляет сразу; вернуть можно отменой её ответа.',
  'snapshot.title': 'Снимки для отката',
  'snapshot.refresh': 'Обновить',
  'snapshot.empty': 'Снимков пока нет',
  'snapshot.undo': 'Откатить…',
  'snapshot.restoring': 'Откатываю…',
  'snapshot.age.now': 'только что',
  'snapshot.age.min': '{n} мин назад',
  'snapshot.age.h': '{n} ч назад',
  'snapshot.age.d': '{n} дн назад',
  'snapshot.label.homebrewConnect': 'подключение хоумбрю',
  'snapshot.label.homebrewUpdate': 'обновление хоумбрю',
  'snapshot.label.draftAccept': 'принятие черновиков',
  'snapshot.label.levelUp': 'повышение уровня: {name}',
  'snapshot.label.createCharacter': 'создание персонажа {name}',
  'snapshot.label.encounter': 'столкновение: {name}',
  'snapshot.label.import': 'импорт, шаг {name}',
  'snapshot.kind.sheets': 'листы',
  'snapshot.kind.pages': 'карты',
  'snapshot.kind.tokens': 'токены',
  'snapshot.kind.chat': 'сообщения чата',
  'snapshot.kind.initiative': 'участники боя',
  'snapshot.confirm.title': 'Откатить кампанию к снимку?',
  'snapshot.confirm.what': 'Снимок {age}: {label}. Откат вернёт всю кампанию к этому моменту: пропадёт и то, что после снимка сделали вы и игроки.',
  'snapshot.confirm.counting': 'Считаю, что изменится…',
  'snapshot.confirm.nothing': 'После снимка листы, карты, токены, чат и бой не менялись.',
  'snapshot.confirm.removed': 'Удалится (создано после снимка):',
  'snapshot.confirm.reverted': 'Вернётся к снимку (изменено после):',
  'snapshot.confirm.returned': 'Появится снова (удалено после снимка):',
  'snapshot.confirm.deleteOne': 'Откатить и удалить {n} новое',
  'snapshot.confirm.deleteFew': 'Откатить и удалить {n} новых',
  'snapshot.confirm.deleteMany': 'Откатить и удалить {n} новых',
  'snapshot.confirm.plain': 'Откатить',

  // Campaign tab
  'settings.campaign.measurementMode': 'Режим измерений',
  'settings.campaign.gridSizeFt': 'Размер клетки (фт)',
  'settings.campaign.navigationMode': 'Режим навигации',
  'settings.campaign.navFree': 'Свободный',
  'settings.campaign.navConfirm': 'С подтверждением',
  'settings.campaign.navGmOnly': 'Только мастер',
  'settings.campaign.importCampaign': 'Импорт кампании',

  // Display tab
  'settings.display.gridStyle': 'Стиль сетки',
  'settings.display.gridLines': 'Линии',
  'settings.display.gridDots': 'Точки',
  'settings.display.gridNone': 'Без сетки',
  'settings.display.gridOpacity': 'Прозрачность сетки',
  'settings.display.sizeTiny': 'Крошечный',
  'settings.display.sizeSmall': 'Маленький',
  'settings.display.sizeMedium': 'Средний',
  'settings.display.sizeLarge': 'Большой (2×2)',
  'settings.display.sizeHuge': 'Огромный (3×3)',
  'settings.display.sizeGargantuan': 'Громадный (4×4)',
  'settings.display.ambientOverlay': 'Освещение времени суток',
  'settings.display.hpBarVisibility': 'Отображение ХП-бара',
  'settings.display.hpAlways': 'Всегда',
  'settings.display.hpHover': 'При наведении',
  'settings.display.hpGmOnly': 'Только мастер',
  'settings.display.hpNever': 'Никогда',
  'settings.display.hpBarHint': 'Игроки видят точные ХП только своих токенов. У чужих и монстров — только грубая полоса (шаг 10 %), без чисел: при «Всегда» и «При наведении». При «Только GM» и «Никогда» у чужих токенов нет и полосы.',
  'settings.display.defaultTokenSize': 'Размер токена по умолчанию',

  // Combat tab
  'settings.combat.autoRollInitiative': 'Автобросок инициативы',
  'settings.combat.autoRollInitiativeDesc': 'Автоматически бросить d20 + модификатор ЛОВ при запуске инициативы',
  'settings.combat.confirmDamage': 'Подтверждение урона',
  'settings.combat.confirmDamageDesc': 'Показать диалог подтверждения перед применением урона',
  'settings.combat.critRange': 'Диапазон крита',
  'settings.combat.critRangeDesc': 'Минимальное значение d20 для критического удара (по умолчанию: 20)',
  'settings.combat.deathSavesEnabled': 'Спасброски от смерти',
  'settings.combat.deathSavesEnabledDesc': 'Включить спасброски от смерти D&D 5e',

  // Permissions tab
  'settings.permissions.description': 'Настройте, что могут делать игроки. Мастер всегда имеет полный доступ.',
  'settings.permissions.moveOtherTokens': 'Двигать чужие токены',
  'settings.permissions.moveOtherTokensDesc': 'Разрешить игрокам двигать неназначенные им токены',
  'settings.permissions.drawOnMap': 'Рисовать на карте',
  'settings.permissions.drawOnMapDesc': 'Разрешить игрокам использовать инструменты рисования',
  'settings.permissions.addTokens': 'Добавлять токены',
  'settings.permissions.addTokensDesc': 'Разрешить игрокам создавать токены на карте',
  'settings.permissions.createNotes': 'Создавать заметки',
  'settings.permissions.createNotesDesc': 'Разрешить игрокам создавать маркеры и заметки на карте',
  'settings.permissions.useAi': 'Тиа у игроков',
  'settings.permissions.useAiDesc': 'Разрешить игрокам говорить с Тией',
  'settings.permissions.playerAiRate': 'Лимит запросов к Тии',
  'settings.permissions.playerAiRateDesc': 'Максимум запросов к Тии на игрока в минуту (1–60)',
  'settings.permissions.playerAiBudget': 'Бюджет токенов Тии',
  'settings.permissions.playerAiBudgetDesc': 'Максимум токенов Тии на игрока в час. Пусто — без лимита',
  'settings.permissions.unlimited': 'Без лимита',
  'settings.permissions.allowPlayerStickers': 'Стикеры игрокам',
  'settings.permissions.allowPlayerStickersDesc': 'Разрешить игрокам отправлять стикеры и управлять наборами',
  'settings.permissions.viewOtherSheets': 'Просмотр чужих листов',
  'settings.permissions.viewOtherSheetsDesc': 'Что игроки могут видеть на листах других персонажей',
  'settings.permissions.viewNone': 'Ничего',
  'settings.permissions.viewBasic': 'Базовое (публичные поля)',
  'settings.permissions.viewFull': 'Полное',

  // V003: Tool options all settings link
  'toolOptions.allSettings': 'Все настройки...',

  // V005: Confirm damage prompt
  'combat.confirmDamagePrompt': 'Применить {damage} урона к {name}?',

  // V006: Permission denied tooltips
  'permissions.denied.drawOnMap': 'Рисование отключено мастером',
  'permissions.denied.addTokens': 'Создание токенов отключено мастером',
  'permissions.denied.createNotes': 'Создание заметок отключено мастером',

  // === Server Error Codes (command:error) ===
  'error.not_found': 'Не найдено',
  'error.material_is_prep_source': 'Эта запись — источник текста подготовки бита, отдельным материалом она не добавляется',
  'error.map_not_found': 'Карта не найдена в этой кампании',
  'error.map_not_in_beat': 'Этой карты уже нет в бите',
  'error.unauthorized': 'Нет прав',
  'error.OWNERSHIP_CHECK_FAILED': 'Это не твой лист: изменить его нельзя',
  'error.forbidden': 'Доступ запрещён',
  'error.invalid_input': 'Некорректный ввод',
  'error.invalid_name': 'Некорректное имя',
  'error.invalid_data': 'Некорректные данные',
  'error.invalid_type': 'Некорректный тип',
  'error.invalid_tags': 'Слишком много тегов',
  'error.invalid_visibility': 'Некорректная видимость',
  'error.duplicate': 'Уже существует',
  'error.duplicate_link': 'Связь уже существует',
  'error.self_link': 'Нельзя связать с самим собой',
  'error.self_reference': 'Нельзя ссылаться на себя',
  'error.circular_reference': 'Циклическая ссылка',
  'error.LINK_NOT_FOUND': 'Связь не найдена',
  'error.links_limit': 'Достигнут лимит ссылок',
  'error.PAGE_LIMIT': 'Достигнут лимит: максимум 20 карт',
  'error.CANNOT_DELETE_LAST': 'Нельзя удалить единственную карту',
  'error.PLAYERS_ON_PAGE': 'Игроки на этой карте — выберите, куда их перенести',
  'error.MOVE_TARGET_NOT_FOUND': 'Карта, куда перенести игроков, не найдена',
  'error.PLAYERS_MOVED': 'Игроков уже перевели на другую карту',
  'error.INVALID_PAGE_LIST': 'Некорректный список карт',
  'error.INVALID_NAME': 'Название — от 1 до 50 знаков',
  'error.NAME_TOO_LONG': 'Название — не длиннее 50 знаков',
  'error.SAME_PAGE': 'Исходная и целевая карты совпадают',
  'error.TOKEN_NOT_FOUND': 'Токен не найден',
  'error.SHEET_NOT_FOUND': 'Лист персонажа не найден',
  'error.alert_limit': 'Достигнут лимит эффектов (50)',
  'error.trigger_limit': 'Достигнут лимит авто-триггеров (20)',
  'error.unknown_preset': 'Неизвестный пресет',
  'error.invalid_label': 'Некорректное название',
  'error.invalid_color': 'Некорректный цвет',
  'error.invalid_icon': 'Некорректная иконка',
  'error.invalid_content': 'Некорректное содержимое',
  'error.invalid_title': 'Некорректный заголовок',
  'error.note_limit': 'Достигнут лимит заметок',
  'error.parent_not_found': 'Родительская заметка не найдена',
  'error.invalid_area': 'Некорректная область',
  'error.invalid_description': 'Некорректное описание',
  'error.invalid_terrain': 'Некорректный тип местности',
  'error.invalid_cover': 'Некорректный тип укрытия',
  'error.TARGET_PAGE_NOT_FOUND': 'Целевая карта не найдена',
  'error.NAVIGATE_REQUEST_NOT_FOUND': 'Запрос перехода не найден',
  'error.GM_ONLY_NAVIGATION': 'Только мастер может переключать карты в этом режиме',
  'error.builtin_template': 'Нельзя редактировать встроенный шаблон',
  'error.in_use': 'Шаблон используется листами персонажей',
  'error.validation_error': 'Ошибка валидации',
  'error.invalid_state': 'Некорректное состояние',
  'error.death_saves_disabled': 'Спасброски от смерти отключены',
  'error.system_not_supported': 'Недоступно для этой игровой системы',
  'error.hit_dice_exhausted': 'Кости хитов закончились',
  'error.no_hit_dice': 'Нет доступных костей хитов',
  'error.no_spell_slots': 'Нет доступных ячеек заклинаний',
  'error.no_pact': 'Магия договора не настроена',
  'error.not_repeating': 'Секция не является повторяемой',
  'error.invalid_action': 'Некорректное действие',
  'error.invalid_expression': 'Некорректное выражение',
  'error.invalid_level': 'Некорректный уровень',
  'error.invalid_mode': 'Некорректный режим',
  'error.not_draft': 'Не является черновиком',
  'error.session_limit': 'Достигнут лимит сессий',
  'error.session_full': 'Сессия заполнена',
  'error.active_limit': 'Может быть только одна активная сессия',
  'error.timeline_limit': 'Достигнут лимит событий летописи',
  'error.tags_limit': 'Достигнут лимит тегов',
  'error.PIN_LIMIT': 'Достигнут лимит маркеров',
  'error.PIN_NOT_FOUND': 'Маркер не найден',
  'error.WALL_NOT_FOUND': 'Стена не найдена',
  'error.WALL_INVALID': 'Некорректная стена',
  'error.WALL_LIMIT': 'Достигнут лимит стен',
  'error.WALL_NOT_DOOR': 'Стена не является дверью',
  'error.WALL_CHAIN_MIN_POINTS': 'Стена должна иметь минимум 2 точки',
  'error.INVALID_ILLUMINATION': 'Некорректное значение освещения',
  'error.invalid_condition': 'Некорректное состояние',
  'error.invalid_transition': 'Некорректный переход',
  'error.restore_failed': 'Ошибка восстановления',
  'error.max_level': 'Достигнут максимальный уровень',
  'error.trigger_disabled': 'Триггер отключён',
  'error.internal_error': 'Внутренняя ошибка',

  // === Timeline ===
  'timeline.eventType.sessionStart': 'Начало сессии',
  'timeline.eventType.sessionRecap': 'Итоги сессии',
  'timeline.eventType.encounter': 'Столкновение',
  'timeline.eventType.discovery': 'Открытие',
  'timeline.eventType.plot': 'Сюжет',
  'timeline.eventType.travel': 'Путешествие',
  'timeline.eventType.rest': 'Отдых',
  'timeline.eventType.downtime': 'Свободное время',
  'timeline.eventType.character': 'Персонаж',
  'timeline.eventType.custom': 'Другое',
  'timeline.eventType.chapter': 'Глава',
  'timeline.timeOfDay.dawn': 'Рассвет',
  'timeline.timeOfDay.morning': 'Утро',
  'timeline.timeOfDay.midday': 'Полдень',
  'timeline.timeOfDay.afternoon': 'День',
  'timeline.timeOfDay.dusk': 'Закат',
  'timeline.timeOfDay.evening': 'Вечер',
  'timeline.timeOfDay.night': 'Ночь',
  'timeline.timeOfDay.midnight': 'Полночь',
  'timeline.form.editTitle': 'Редактировать событие',
  'timeline.form.newTitle': 'Новое событие',
  'timeline.form.titleLabel': 'Текст',
  'timeline.form.titlePlaceholder': 'Что произошло?',
  'timeline.form.typeLabel': 'Тип события',
  'timeline.form.descriptionLabel': 'Описание',
  'timeline.form.descriptionPlaceholder': 'Подробности...',
  'timeline.form.yearLabel': 'Год',
  'timeline.form.monthLabel': 'Месяц',
  'timeline.form.dayLabel': 'День',
  'timeline.form.timeOfDayLabel': 'Время суток',
  'timeline.form.manualTimeOverride': 'Ручной ввод текста времени',
  'timeline.form.customTimePlaceholder': 'Своё описание времени',
  'timeline.form.timeTextLabel': 'Время (текст)',
  'timeline.form.timeLabelPlaceholder': 'День 3, Утро',
  'timeline.form.visibilityLabel': 'Видимость',
  'timeline.form.visibilityAll': 'Все',
  'timeline.form.visibilityGmOnly': 'только мастер',
  'timeline.form.visibilityPlayers': 'Игроки',
  'timeline.form.tagsLabel': 'Теги (через запятую)',
  'timeline.form.tagsPlaceholder': 'бой, дракон, Уотердип',
  'timeline.form.linksLabel': 'Ссылки',
  'timeline.form.sessionLabel': 'Сессия',
  'timeline.form.noSession': 'Без сессии',
  'timeline.form.cancelButton': 'Отмена',
  'timeline.form.saveButton': 'Сохранить',
  'timeline.form.createButton': 'Создать',
  'timeline.form.suggestButton': 'Предложить',
  'timeline.form.suggestTitle': 'Предложить событие',
  'timeline.form.linkTitle': 'Связи события',
  'timeline.form.whatHappenedLabel': 'Что случилось',
  'timeline.form.whatSuggestLabel': 'Что предлагаешь',
  'timeline.form.addButton': 'Добавить в летопись',
  'timeline.form.suggestToGmButton': 'Предложить мастеру',
  'timeline.form.details': 'Подробнее',
  'timeline.form.atTime': 'На {time}',
  'timeline.form.staysDraft': 'останется черновиком',
  'timeline.form.customTimeHint': 'Пусто — по дате',
  'timeline.form.visibleToAll': 'видят все',
  'timeline.form.selectedPlayers': 'выбранные игроки',
  'timeline.form.noPlayers': 'В кампании пока нет игроков',
  'timeline.form.linkWith': 'Связать с:',
  'timeline.form.findLink': 'Найти, с чем связать',
  'timeline.form.findLinkPlaceholder': 'Найти запись, карту, бит…',
  'timeline.form.linkName': '{kind} «{name}»',
  'timeline.form.linkKind.beat': 'бит',
  'timeline.form.linkKind.map': 'карта',
  'timeline.form.linkKind.record': 'запись',
  'timeline.form.linkKind.quest': 'квест',
  'timeline.form.linkKind.character': 'персонаж',
  'timeline.form.linkKind.pin': 'маркер',
  'timeline.form.linkWhy.inProgress': 'идёт',
  'timeline.form.linkWhy.players': 'у игроков',
  'timeline.form.linkWhy.quest': 'квест бита',
  'timeline.form.linkWhy.selected': 'выделен на карте',
  'timeline.form.unlink': 'Убрать связь с {name}',
  'timeline.filters.title': 'Фильтры',
  'timeline.filters.resetAriaLabel': 'Сбросить все фильтры',
  'timeline.filters.reset': 'Сбросить',
  'timeline.filters.searchPlaceholder': 'Поиск по заголовку и описанию...',
  'timeline.filters.searchAriaLabel': 'Поиск по событиям',
  'timeline.filters.typeGroupLabel': 'Фильтр по типу',
  'timeline.filters.tagsGroupLabel': 'Фильтр по тегам',
  'timeline.filters.allSessions': 'Все сессии',
  'timeline.filters.typeLabel': 'Тип',
  'timeline.filters.tagLabel': 'Тег',
  'timeline.filters.myEventsOnly': 'Мои события',
  'timeline.cursor.dayFormat': 'День',
  'timeline.cursor.editDateTooltip': 'Изменить дату',
  'timeline.cursor.addDate': '+ дата',
  'timeline.cursor.partsGroup': 'Время суток',
  'timeline.cursor.prevPart': 'Предыдущая часть суток',
  'timeline.cursor.nextPart': 'Следующая часть суток',
  'rest.shiftOffer': 'Длинный отдых. Сдвинуть время мира на ночь?',
  'rest.shiftAction': 'Сдвинуть время',
  'timeline.cursor.partNextDay': '{part}, следующий день',
  'timeline.cursor.undo': 'Отменить',
  'timeline.cursor.prevDay': 'Предыдущий день',
  'timeline.cursor.nextDay': 'Следующий день',
  'timeline.cursor.month': 'Месяц',
  'timeline.cursor.year': 'Год',
  'timeline.cursor.day': 'День',
  'timeline.cursor.datePicker': 'Дата',
  'timeline.cursor.closePicker': 'Закрыть',
  'timeline.cursor.inTheWorld': 'В мире: {time}',
  'timeline.list.noDate': 'Без даты',
  'timeline.list.addEventToDay': 'Добавить событие в этот день',
  'timeline.list.now': 'сейчас',
  'timeline.list.deleteConfirm': 'Точно удалить?',
  'timeline.list.draftBadge': 'черновик',
  'timeline.list.editTooltip': 'Править',
  'timeline.list.more': 'полностью',
  'timeline.list.less': 'свернуть',
  'timeline.list.deleteTooltip': 'Удалить…',
  'timeline.drafts.regionLabel': 'Ждут публикации',
  'timeline.drafts.title': 'Ждут публикации',
  'timeline.drafts.approveAriaLabel': 'Опубликовать',
  'timeline.drafts.rejectAriaLabel': 'Отклонить',
  'timeline.panel.emptyTitle': 'Летопись пуста',
  'timeline.panel.emptySubtext': 'Пока нет событий кампании',
  'timeline.panel.regionLabel': 'Летопись кампании',
  'timeline.panel.noTime': 'Время не задано',
  'timeline.panel.createEventAriaLabel': 'Создать событие',
  'timeline.panel.noFilterResults': 'Нет событий по заданным фильтрам',
  'timeline.panel.emptySubtextGM': 'Создайте первое событие кампании',
  'timeline.panel.createEventButton': 'Создать событие',
  'timeline.autoTransitions.removeAll': 'Убрать все переходы',
  'timeline.autoTransitions.removeAllTitle': 'Убрать все переходы?',
  'timeline.autoTransitions.removeAllDesc': 'Будет убрано событий «Переход»: {count} — опубликованные пропадут и у игроков. Остальные события летописи не меняются.',
  'timeline.autoTransitions.removeAllConfirm': 'Убрать',
  'timeline.panel.title': 'Летопись',
  'timeline.panel.addEvent': 'Добавить в летопись',
  'timeline.panel.suggestEvent': 'Предложить событие',
  'timeline.panel.more': 'Ещё',
  'timeline.panel.calendarLine': 'Календарь: {name}',
  'timeline.panel.noCalendar': 'нет',
  'timeline.panel.changeCalendar': 'сменить…',
  'timeline.panel.published': 'Опубликовано',
  'timeline.calendar.title': 'Календарь кампании',
  'timeline.calendar.current': 'Текущий календарь',
  'timeline.calendar.monthsInfo': '{months} месяцев, {days} дней в неделе',
  'timeline.calendar.remove': 'Удалить',
  'timeline.calendar.edit': 'Править',
  'timeline.calendar.choosePreset': 'Выберите пресет или создайте свой',
  'timeline.calendar.presetInfo': '{months} мес, {days} дн/нед',
  'timeline.calendar.createOwn': 'Создать свой',
  'timeline.calendar.customName': 'Мой календарь',
  'timeline.calendar.customMonth': 'Месяц 1',
  'timeline.calendar.aiGenerate': 'Шаблон календаря',
  'timeline.calendar.name': 'Название',
  'timeline.calendar.yearLabel': 'Обозначение года',
  'timeline.calendar.epoch': 'Эпоха',
  'timeline.calendar.months': 'Месяцы',
  'timeline.calendar.addMonth': 'Добавить месяц',
  'timeline.calendar.removeMonth': 'Убрать месяц',
  'timeline.calendar.intercalary': 'Вставной',
  'timeline.calendar.newMonth': 'Новый месяц',
  'timeline.calendar.save': 'Сохранить',
  'timeline.calendar.cancel': 'Отмена',
  'timeline.calendar.yearLabelPlaceholder': 'DR, н. э.…',
  'timeline.calendar.epochPlaceholder': 'Летоисчисление долин…',
  'timeline.calendar.intercalaryShort': 'вст.',
  'timeline.session.line': 'Сессия {number} · {status} · {date}',
  'timeline.session.statusActive': 'идёт',
  'timeline.session.statusPlanned': 'запланирована',
  'timeline.session.statusCompleted': 'завершена',
  'timeline.session.none': 'Сессий пока нет',
  'timeline.session.start': 'Начать сессию',
  'timeline.session.startEvent': 'Начало сессии {number}',
  'timeline.session.startEventTitled': 'Начало сессии {number}: {title}',
  'plan.session.none': 'Сессия не идёт',
  'timeline.summary.button': 'Итог сессии',
  'timeline.summary.title': 'Итог сессии {number}',
  'timeline.summary.hint': 'Что опубликовать игрокам:',
  'timeline.summary.played': 'Сыграно: {beats}.',
  'timeline.summary.playedNone': 'Сыграно: ничего.',
  'timeline.summary.empty': 'Черновиков нет.',
  'timeline.summary.uncheckedStays': 'Неотмеченное остаётся черновиком.',
  'timeline.summary.publishAndFinish': 'Опубликовать отмеченное и завершить',
  'timeline.summary.sureCount': 'Точно? Игроки увидят записей: {count}.',
  'timeline.summary.sureNone': 'Точно? Ничего не публикуется, сессия завершится.',
  'timeline.summary.sureYes': 'Да, опубликовать и завершить',
  'timeline.summary.sureBack': 'Назад',
  'timeline.drafts.hint': 'игроки пока не видят',
  'timeline.drafts.sourceAuto': 'авто',
  'timeline.drafts.sourceGm': 'мастер',
  'timeline.drafts.sourcePlayer': 'игрок',
  'timeline.drafts.accept': 'Принять',
  'timeline.drafts.edit': 'Править',
  'timeline.drafts.reject': 'Отклонить',
  'timeline.drafts.publish': 'Опубликовать',
  'timeline.drafts.remove': 'Убрать',
  'timeline.drafts.publishAllAuto': 'Опубликовать все авто',
  'timeline.drafts.publishTitle': 'Опубликовать «{title}»?',
  'timeline.drafts.acceptTitle': 'Принять «{title}»?',
  'timeline.drafts.publishDesc': 'Игроки увидят событие в летописи.',
  'timeline.drafts.publishAllTitle': 'Опубликовать все авто-черновики?',
  'timeline.drafts.publishAllDesc': 'Игроки увидят: {titles}.',
  'timeline.drafts.rejectTitle': 'Отклонить «{title}»?',
  'timeline.drafts.rejectReason': 'Причина (необязательно)',
  'timeline.drafts.rejectHint': 'Автор увидит причину.',
  'timeline.drafts.rejected': 'Мастер отклонил «{title}»',
  'timeline.drafts.rejectedWithReason': 'Мастер отклонил «{title}»: {reason}',
  'timeline.mine.title': 'Мои предложения',
  'timeline.mine.waiting': 'ждёт мастера',
  'timeline.filters.myEventsHint': 'написанные или предложенные мной',
  'timeline.visibility.all': 'видят все',
  'timeline.visibility.gm': 'только мастер',
  'timeline.visibility.players': 'выбранные игроки',
  'timeline.visibility.menuLabel': 'Кто видит',
  'timeline.visibility.choosePlayers': 'Кто видит «{title}»',
  'timeline.visibility.noPlayers': 'В кампании пока нет игроков.',
  'timeline.visibility.apply': 'Применить',
  'timeline.visibility.confirmAllTitle': 'Показать «{title}» всем игрокам?',
  'timeline.visibility.confirmPlayersTitle': 'Показать «{title}» выбранным игрокам?',
  'timeline.visibility.confirmAllDesc': 'Все игроки увидят событие в летописи.',
  'timeline.visibility.confirmPlayersDesc': 'Событие увидят в летописи: {names}.',
  'timeline.visibility.confirm': 'Показать',
  'timeline.links.add': '+ связать',
  'timeline.links.record': 'Запись',
  'timeline.links.recordGone': 'Этой записи больше нет.',
  'timeline.create.confirmTitle': 'Показать «{title}» игрокам?',
  'timeline.create.confirmDesc': 'Событие сохранено в «Ждут публикации», игроки его пока не видят. Опубликовать сейчас или оставить там?',
  'timeline.create.keepDraft': 'Оставить черновиком',

  // === Campaign Sessions ===
  'campaignSessions.ariaLabel': 'Управление игровыми сессиями',
  'campaignSessions.title': 'Сессии',
  'campaignSessions.newSession': 'Новая сессия',
  'campaignSessions.titleLabel': 'Название (необязательно)',
  'campaignSessions.namePlaceholder': 'Подземелье дракона',
  'campaignSessions.dateLabel': 'Дата',
  'campaignSessions.active': 'Активна',
  'campaignSessions.complete': 'Завершить',
  'campaignSessions.planned': 'Планируется',
  'campaignSessions.start': 'Начать',
  'campaignSessions.completed': 'Завершённые',
  'campaignSessions.noSessions': 'Пока нет сессий',
  'campaignSessions.endTitle': 'Завершить сессию #{number}?',
  'campaignSessions.endUnpublished': 'Неопубликованных переходов: {count}. Игроки их не видят, сами они не опубликуются.',
  'campaignSessions.endPublish': 'Опубликовать',
  'campaignSessions.endRemove': 'Убрать',
  'campaignSessions.endKeepDrafts': 'Оставить черновиками',

  // === Import Wizard ===
  'importWizard.title': 'Импорт кампании',
  'importWizard.sourceText': 'Текст / заметки',
  'importWizard.selectSource': 'Выберите источник',
  'importWizard.sourceDndBeyondSoon': 'D&D Beyond (скоро)',
  'importWizard.sourcePdfSoon': 'PDF (скоро)',
  'importWizard.sourceImageSoon': 'Изображение (скоро)',
  'importWizard.extractingRelations': 'Извлечение связей...',
  'importWizard.analyzingRelations': 'Анализ связей между сущностями',
  'importWizard.wave1': 'Контейнеры (карты, листы)',
  'importWizard.wave2': 'Контент (журнал, заметки)',
  'importWizard.wave3': 'Связи (ссылки, маркеры)',
  'importWizard.importError': 'Ошибка импорта',
  'importWizard.source': 'Источник',
  'importWizard.dragDropHint': 'Перетащите файл сюда или нажмите для выбора',
  'importWizard.analyzing': 'Анализ...',
  'importWizard.analyze': 'Анализировать',
  'importWizard.conflictsFound': 'Обнаружены конфликты',
  'importWizard.tableType': 'Тип',
  'importWizard.tableName': 'Имя',
  'importWizard.tableAction': 'Действие',
  'importWizard.tableNewName': 'Новое имя',
  'importWizard.strategySkip': 'Пропустить',
  'importWizard.strategyMerge': 'Объединить',
  'importWizard.strategyRename': 'Переименовать',
  'importWizard.newNamePlaceholder': 'Новое имя',
  'importWizard.applying': 'Применение...',
  'importWizard.apply': 'Применить',
  'importWizard.importPreview': 'Предпросмотр импорта',
  'importWizard.importComplete': 'Импорт завершён',
  'importWizard.stepSource': 'Источник',
  'importWizard.stepUpload': 'Загрузка',
  'importWizard.stepConflicts': 'Конфликты',
  'importWizard.stepResult': 'Результат',
  'importWizard.strategyOverwrite': 'Перезаписать',
  'importWizard.previewSheets': 'Персонажи',
  'importWizard.previewTokens': 'Токены',
  'importWizard.previewPages': 'Карты',
  'importWizard.previewNotes': 'Заметки',
  'importWizard.resultAdded': 'Добавлено',
  'importWizard.resultOverwritten': 'Перезаписано',
  'importWizard.resultSkipped': 'Пропущено',

  // === Bug Report additions ===
  'bugReport.sectionDescription': '## Описание',
  'bugReport.sectionElement': '## Элемент',
  'bugReport.sectionContext': '## Контекст',
  'bugReport.noDescription': '_Нет описания_',
  'bugReport.roleGM': 'Мастер',
  'bugReport.rolePlayer': 'Игрок',

  // === SRD labels ===
  'srd.traits': 'Особенности',
  'srd.actions': 'Действия',
  'srd.reactions': 'Реакции',
  'srd.legendaryActions': 'Легендарные действия',
  'srd.castingTime': 'Время каста',
  'srd.range': 'Дальность',
  'srd.components': 'Компоненты',
  'srd.duration': 'Длительность',
  'srd.resistances': 'Сопротивления',
  'srd.immunities': 'Иммунитеты',
  'srd.senses': 'Чувства',
  'srd.languages': 'Языки',
  'srd.cr': 'КО',

  // === Spellbook ===
  'spellbook.title': 'Книга заклинаний',
  'spellbook.empty': 'Нет заклинаний в книге',
  'spellbook.cantrips': 'Заговоры',
  'spellbook.concentration': 'Концентрация',

  // === Compendium Browser ===
  'compendium.equipment': 'Снаряжение',
  'compendium.spells': 'Заклинания',
  'compendium.searchEquipment': 'Поиск снаряжения...',
  'compendium.searchSpells': 'Поиск заклинаний...',
  'compendium.noEquipment': 'Снаряжение не найдено.',
  'compendium.noSpells': 'Заклинания не найдены.',
  'compendium.addToInventory': 'Добавить в инвентарь',
  'compendium.addToSpellbook': 'Добавить в книгу заклинаний',
  'compendium.cost': 'Стоимость',
  'compendium.weight': 'Вес',
  'compendium.ac': 'КД',
  'compendium.homebrew': 'Хоумбрю',
  'compendium.concentration': 'Концентрация',
  'compendium.properties': 'Свойства',

  // === Chat additions ===
  'chat.search': 'Поиск',
  'chat.searchPlaceholder': 'Поиск...',
  'chat.unpinMessage': 'Открепить сообщение',
  'chat.pinMessage': 'Закрепить сообщение',
  'chat.gmPrefix': '[мастер] ',
  'chat.exportTitle': '# Экспорт чата',

  // === Character Wizard additions ===
  'wizard.characterNameLabel': 'Имя персонажа',
  'wizard.characterNamePlaceholder': 'Введите имя персонажа...',
  'wizard.backgroundLabel': 'Предыстория',
  'wizard.backgroundPlaceholder': 'Предыстория персонажа...',
  'wizard.raceLabel': 'Раса',
  'wizard.speed': 'Скорость',
  'wizard.classLabel': 'Класс',
  'wizard.hitDie': 'Кость хитов',
  'wizard.selectClassFirst': 'Сначала выберите класс.',
  'wizard.noEquipmentPack': 'Нет стартового набора для этого класса.',
  'wizard.equipped': '(экипировано)',

  // === Campaign Import ===
  'campaignImport.textInputHint': 'Вставьте текст кампании или загрузите файл (.txt, .md)',
  'campaignImport.placeholder': 'Вставьте текст описания кампании, NPC, локаций, квестов...',
  'campaignImport.uploadFile': 'Загрузить файл',
  'campaignImport.limitExceeded': 'Текст превышает лимит. Сократите или разбейте на части.',
  'campaignImport.analyzing': 'Анализ...',
  'campaignImport.analyze': 'Анализировать',

  // === Homebrew Import ===
  'homebrewImport.title': 'Импорт хоумбрю-контента',
  'homebrewImport.inputLabel': 'Вставьте текст или загрузите PDF',
  'homebrewImport.placeholder': 'Вставьте хоумбрю-контент...',
  'homebrewImport.or': 'или',
  'homebrewImport.uploadPdf': 'Загрузить PDF',
  'homebrewImport.extract': 'Извлечь сущности',
  'homebrewImport.uploading': 'Загрузка PDF...',
  'homebrewImport.backgroundNote': 'Можно закрыть диалог — извлечение продолжится в фоне.',
  'homebrewImport.extracting': 'Извлечение сущностей...',
  'homebrewImport.preparingChunks': 'Подготовка чанков...',
  'homebrewImport.packageNameLabel': 'Название пакета',
  'homebrewImport.save': 'Сохранить',
  'homebrewImport.saving': 'Сохранение пакета...',
  'homebrewImport.complete': 'Импорт завершён!',
  'homebrewImport.back': 'Назад',
  'homebrewImport.clear': 'Очистить',
  'homebrewImport.chunk': 'Чанк',
  'homebrewImport.entities': 'сущностей',

  // === Entity Review ===
  'entityReview.selectAll': 'Выбрать все',
  'entityReview.deselectAll': 'Снять выбор',
  'entityReview.addManual': '+ Добавить вручную',
  'entityReview.selectedCount': 'выбрано',
  'entityReview.retryBelow': 'Повторить ниже',
  'entityReview.retry': 'Повторить',

  // === Character Portraits ===
  'characterPortraits.changeColor': 'Сменить цвет',
  'characterPortraits.online': 'онлайн',
  'characterPortraits.ac': 'КД',
  'characterPortraits.publicOnly': 'Лист этого персонажа виден только его игроку и мастеру — здесь его открытая часть',
  'characterPortraits.offline': 'офлайн',
  'characterPortraits.chip': 'Персонажи ({count})',
  'characterPortraits.chipFold': 'Свернуть',
  // Visibility menu items
  'characterPortraits.visibility.always': 'Виден всем',
  'characterPortraits.visibility.gmOnly': 'Скрыт от игроков',
  'characterPortraits.visibility.hidden': 'Архив (скрыт от всех)',
  'characterPortraits.visibilityLabel': 'Карточка на сцене',
  'characterPortraits.sheetLabel': 'Лист персонажа',
  'characterPortraits.sheetVisibleToPlayers': 'Виден игрокам',
  'characterPortraits.sheetHiddenBadge': 'Лист скрыт от игроков (переключатель в списке персонажей)',
  'characterPortraits.sizeLabel': 'Размер аватарок',
  'characterPortraits.size.small': 'Маленькие',
  'characterPortraits.size.medium': 'Средние',
  'characterPortraits.size.large': 'Большие',
  'characterPortraits.actingAs': 'Вы действуете за этого персонажа',
  'characterPortraits.hiddenFromPlayers': 'Скрыт от игроков',
  // Tooltips
  'characterPortraits.tooltip.actorFrame': 'Рамка активного актора',
  'characterPortraits.tooltip.translucency': 'Полупрозрачность',

  // === Text Input Overlay ===
  'textInput.ariaLabel': 'Ввод текста',
  'textInput.placeholder': 'Введите текст...',

  // === Dice Panel ===
  'dice.formulaPlaceholder': '2d6+3, 1d20+5...',

  // === Lobby ===
  'lobby.sessionCodePlaceholder': 'ABC123',

  // === Hook Errors ===
  'hookError.catalogFailed': 'Ошибка каталогизации',
  'hookError.noEntitiesFound': 'Не удалось найти сущности кампании. Попробуйте уточнить текст.',
  'hookError.detailFailed': 'Ошибка детализации',
  'hookError.noResponseBody': 'Нет тела ответа',
  'hookError.relationFailed': 'Ошибка извлечения связей',
  'hookError.applyFailed': 'Ошибка применения',
  'hookError.fileTooLarge': 'Файл слишком большой',
  'hookError.serverError': 'Ошибка сервера',
  'hookError.networkError': 'Ошибка сети',
  'hookError.extractionFailed': 'Ошибка извлечения',
  'hookError.streamEnded': 'Поток завершился без результата',
  'hookError.retryFailed': 'Ошибка повтора',
  'hookError.saveFailed': 'Ошибка сохранения',
  'hookError.loadFailed': 'Ошибка загрузки',
  'hookError.createFailed': 'Ошибка создания',
  'hookError.uploadFailed': 'Ошибка загрузки файла',
  'hookError.generationFailed': 'Ошибка генерации',
  'hookError.canvasContext': 'Браузер не дал нарисовать карту',
  'hookError.mapLoadFailed': 'Не удалось загрузить изображение карты',
  'hookError.pageCreateTimeout': 'Таймаут создания карты',
  'hookError.lassoMinPoints': 'Лассо требует минимум 3 точки',
  'hookError.exportFailed': 'Ошибка экспорта маски',
  'homebrew.defaultPackageName': 'Импортированный хоумбрю',

  // === Homebrew Library / Import Flow (P2) ===
  'homebrew.libraryTitle': 'Библиотека хоумбрю',
  'homebrew.import': '+ Импорт',
  'homebrew.importJson': 'Импорт JSON',
  'homebrew.libraryEmpty': 'Пакетов пока нет. Импортируй контент, чтобы начать.',
  'homebrew.loading': 'Загрузка...',
  'homebrew.export': 'Экспорт',
  'homebrew.delete': 'Удалить',
  'homebrew.confirm': 'Подтвердить',
  'homebrew.cancel': 'Отмена',
  'homebrew.entities': 'сущностей',
  'homebrew.connectTitle': 'Пакеты хоумбрю',
  'homebrew.connectLoading': 'Загрузка пакетов...',
  'homebrew.connectEmpty': 'В библиотеке нет пакетов. Сначала импортируй контент.',
  'homebrew.checkUpdates': 'Проверить обновления',
  'homebrew.extracting': 'Извлечение...',
  'homebrew.reviewReady': 'Извлечение завершено — нажми, чтобы проверить {{count}} сущностей',
  'homebrew.type.class': 'Класс',
  'homebrew.type.subclass': 'Сабкласс',
  'homebrew.type.spell': 'Заклинание',
  'homebrew.type.feat': 'Черта',
  'homebrew.type.race': 'Раса',
  'homebrew.type.item': 'Предмет',
  'homebrew.connectFailed': 'Не удалось подключить пакет',
  'homebrew.updateFailed': 'Не удалось проверить обновления',

  // === Lazy chunk loading ===
  'error.chunkLoadFailed': 'Не удалось загрузить компонент. Проверьте соединение с интернетом.',

  // === Common additions ===
  'common.retry': 'Попробовать снова',

  // === Character HUD (066) ===
  'characterHud.pillHp': 'ХП',
  'characterHud.expand': 'Развернуть',
  'characterHud.collapse': 'Свернуть',
  'characterHud.openFullSheet': 'Полный лист',
  'characterHud.startCombat': '⚔ начать бой',
  'characterHud.expandDocked': 'Закрепить панель',
  'characterHud.showCharacter': 'Персонаж: статы, навыки, фичи',
  'characterHud.combatBanner': '⚔ твой ход',
  'characterHud.combatBannerTurnOf': '⚔ ход: {name}',
  'characterHud.combatBannerIdle': '⚔ бой',
  'characterHud.round': 'раунд',
  'characterHud.tileHp': 'ХП',
  'wizard.rerollUsed': 'Переброс уже использован',
  'wizard.notProficient': 'Нет владения — этот вариант недоступен',
  'wizard.missing.equipment': 'снаряжение без владения (например, боевой молот у жреца без воинского оружия)',
  'characterHud.castAsRitual': '«{spell}»: ячеек нет — сотворяется как ритуал (+10 минут)',
  'characterHud.resurrect': 'Воскресить',
  'characterHud.resurrectHp': 'ХП после воскрешения',
  'error.dying_no_hit_dice': 'При смерти кости хитов не тратятся — сначала стабилизируйте персонажа',
  'levelUp.aria': 'Повышение уровня',
  'levelUp.title': 'Новый уровень: {class} {from} → {to}',
  'levelUp.hp': 'ХП',
  'levelUp.hitDieCon': 'Кость хитов: к{die} · модификатор ТЕЛ: {con}',
  'levelUp.average': 'Среднее ({n} ХП)',
  'levelUp.roll': 'Бросок (1к{die} {con})',
  'levelUp.subclass': 'Подкласс',
  'levelUp.newFeatures': 'Новые умения',
  'levelUp.spellSlots': 'Ячейки заклинаний',
  'levelUp.slotLine': '{lvl} круг: {n}',
  'levelUp.cantrips': '+{n} заговор(а)',
  'levelUp.asi': 'Увеличение характеристик',
  'levelUp.asiTwo': '+2 к одной характеристике',
  'levelUp.asiOneOne': '+1 к двум характеристикам',
  'levelUp.confirm': 'Получить {n} уровень',
  'characterHud.rollDamage': 'урон',
  'characterHud.noSlotForSpell': '«{spell}»: нет свободной ячейки {n} круга или выше — восстановите отдыхом',
  'characterHud.concentrationReplaced': 'Концентрация на «{prev}» прервана — теперь «{spell}»',
  'characterHud.concentrationOn': 'Концентрация: {spell}',
  'characterHud.concentrationEnd': 'Снять',
  'characterHud.spellTapHint': 'тап — применить',
  'characterHud.deadNoRoll': 'Персонаж мёртв — броски недоступны',
  'characterHud.hpInputLabel': 'Урон или лечение',
  'characterHud.hpInputPlaceholder': '−7 / +5',
  'characterHud.hpInputHint': 'Напишите «−7» (урон), «+5» (лечение) или «=12» (точно), либо число и кнопку',
  'characterHud.unconsciousNoAct': 'Без сознания (0 ХП): атаковать и колдовать нельзя — спасброски от смерти или лечение',
  'characterHud.rollMode': 'Следующий к20',
  'characterHud.rollModeNormal': 'обычный',
  'characterHud.rollModeAdv': 'преимущество',
  'characterHud.rollModeDis': 'помеха',
  'characterHud.rollModeHint': 'Для одного броска: атака, проверка, навык, спасбросок, инициатива. Состояния персонажа учитываются сами',
  'rollCard.advantage': 'преимущество',
  'rollCard.disadvantage': 'помеха',
  'rollCard.modeManual': 'вручную',
  'rollCard.keptHint': 'в счёт идёт',
  'characterHud.hpDamage': 'Урон',
  'characterHud.hpHeal': 'Лечение',
  'characterHud.hpCritAtZero': 'критический удар (два провала)',
  'characterHud.hpDeadHint': 'Персонаж мёртв — вернуть его может только мастер: «Воскресить» в карточке спасбросков от смерти',
  'characterHud.hpMax': 'Максимум ХП',
  'characterHud.hpMaxShort': 'Макс',
  'characterHud.hpTempShort': 'Врем',
  'characterHud.saveRollTitle': 'Спасбросок: {stat}',
  'characterHud.tileAc': 'КД',
  'characterHud.tileInit': 'Иниц',
  'characterHud.tileConc': 'Конц',
  'characterHud.tileSpeed': 'Скор',
  'characterHud.actionAction': 'Действие',
  'characterHud.actionBonus': 'Бонус',
  'characterHud.actionReaction': 'Реакция',
  'characterHud.available': 'доступно',
  'characterHud.spent': 'потрачено',
  'characterHud.attacks': 'Атаки',
  'characterHud.spellSlots': 'Ячейки заклинаний',
  'characterHud.effects': 'Эффекты',
  'characterHud.noConcentration': '—',
  'characterHud.mockRoll': 'Бросок (демо)',
  'characterHud.mockRollDesc': 'Демонстрационный бросок, не отправлен на сервер.',
  'characterHud.tabCombat': 'Бой',
  'characterHud.tabCharacter': 'Персонаж',
  'characterHud.tabCharShort': 'Перс',
  'characterHud.tabRoleplay': 'Отыгрыш',
  'characterHud.tabBuilder': 'Создание',
  'characterHud.backToHud': '← к панели персонажа',
  'characterHud.inDevelopment': 'В разработке',
  'characterHud.stats': 'Характеристики',
  'characterHud.topSkills': 'Топ навыков',
  'characterHud.saves': 'Спасброски',
  'characterHud.skills': 'Навыки',
  'characterHud.searchSkills': 'поиск навыка…',
  'characterHud.pinSkill': 'Закрепить навык',
  'characterHud.unpinSkill': 'Открепить навык',
  'characterHud.spells': 'Заклинания',
  'characterHud.detailCantrip': 'заговор',
  'characterHud.detailCircle': 'круг',
  'characterHud.detailConcentration': 'концентрация',
  'characterHud.detailRitual': 'ритуал',
  'characterHud.detailCastingTime': 'время',
  'characterHud.detailRange': 'дистанция',
  'characterHud.detailDuration': 'длительность',
  'characterHud.detailComponents': 'компоненты',
  'characterHud.detailUses': 'использования',
  'characterHud.detailHigherLevels': 'На более высоких кругах',
  'characterHud.conditionAdd': 'состояние',
  'characterHud.conditionRemove': 'Снять состояние',
  'characterHud.conditionRounds': 'раундов (пусто = бессрочно)',
  'characterHud.conditionApply': 'Наложить',
  'characterHud.collapseList': 'свернуть',
  'characterHud.movement': 'Движение',
  'characterHud.movementHint': 'Клик — потратить 5 фт; на нуле — сбросить',
  'characterHud.resetTurn': 'Вернуть ресурсы хода (действия + движение)',
  'characterHud.features': 'Умения',
  'characterHud.moreFeatures': 'ещё',
  'characterHud.spellsKnown': 'Подготовленные заклинания',
  'characterHud.demoTitle': 'HUD Demo',
  'characterHud.demoPill': 'Pill',
  'characterHud.demoMini': 'Mini',
  'characterHud.demoCombat': 'Combat',
  'characterHud.demoDocked': 'Docked',
  'characterHud.demoToggle': 'Видимость',
  'characterHud.demoFullSheet': 'Полный лист',
  'characterHud.demoNpc': 'NPC-карта',
  'characterHud.demoReset': 'Сброс',
  'characterHud.npcAlly': 'союзник',
  'characterHud.npcWarm': 'дружелюбный',
  'characterHud.npcNeutral': 'нейтральный',
  'characterHud.npcFoe': 'враг',
  'characterHud.npcEnemy': 'враг',
  'characterHud.close': 'Закрыть',
  'characterHud.hpTemp': 'врем',
  'characterHud.level': 'Ур.',
  'characterHud.storeCorrupted': 'Данные персонажа повреждены. Загружен персонаж по умолчанию.',

  // === Builder Mode (066 phase-4) ===
  'characterHud.builder.stepIdentity': 'Персонаж',
  'characterHud.builder.stepRace': 'Раса',
  'characterHud.builder.stepClass': 'Класс',
  'characterHud.builder.stepStats': 'Характеристики',
  'characterHud.builder.stepBackground': 'Предыстория',
  'characterHud.builder.stepSkills': 'Навыки',
  'characterHud.builder.stepReview': 'Обзор',
  'characterHud.builder.alignLG': 'Законно-добрый',
  'characterHud.builder.alignNG': 'Нейтрально-добрый',
  'characterHud.builder.alignCG': 'Хаотично-добрый',
  'characterHud.builder.alignLN': 'Законно-нейтральный',
  'characterHud.builder.alignN': 'Нейтральный',
  'characterHud.builder.alignCN': 'Хаотично-нейтральный',
  'characterHud.builder.alignLE': 'Законно-злой',
  'characterHud.builder.alignNE': 'Нейтрально-злой',
  'characterHud.builder.alignCE': 'Хаотично-злой',
  'characterHud.builder.methodPointBuy': 'Покупка очков',
  'characterHud.builder.methodStandardArray': 'Стандартный массив',
  'characterHud.builder.methodManual': 'Ручной ввод',
  'characterHud.builder.identityTitle': 'Персонаж',
  'characterHud.builder.identitySubtitle': 'Основная информация о персонаже',
  'characterHud.builder.labelName': 'Имя персонажа',
  'characterHud.builder.labelGender': 'Пол',
  'characterHud.builder.labelAlignment': 'Мировоззрение',
  'characterHud.builder.placeholderName': 'Введите имя…',
  'characterHud.builder.raceTitle': 'Раса',
  'characterHud.builder.raceSubtitle': 'Выберите расу персонажа',
  'characterHud.builder.subraceLabel': 'Подраса',
  'characterHud.builder.raceSpeed': 'Скорость',
  'characterHud.builder.raceSize': 'Размер',
  'characterHud.builder.raceLanguages': 'Языки',
  'characterHud.builder.raceTraits': 'Особенности',
  'characterHud.builder.classTitle': 'Класс',
  'characterHud.builder.classSubtitle': 'Выберите класс персонажа',
  'characterHud.builder.classSaves': 'Спасброски',
  'characterHud.builder.classProficiencies': 'Владения',
  'characterHud.builder.classSkillChoices': 'Навыки: выбрать',
  'characterHud.builder.classHitDie': 'Кость хитов',
  'characterHud.builder.statsTitle': 'Характеристики',
  'characterHud.builder.statsSubtitle': 'Распределите значения характеристик',
  'characterHud.builder.budgetRemaining': 'Оставшиеся очки',
  'characterHud.builder.budgetDone': 'Все очки распределены ✓',
  'characterHud.builder.bgTitle': 'Предыстория',
  'characterHud.builder.bgSubtitle': 'Выберите предысторию персонажа',
  'characterHud.builder.bgSkills': 'Навыки',
  'characterHud.builder.bgFeature': 'Особенность',
  'characterHud.builder.skillsTitle': 'Навыки',
  'characterHud.builder.skillsSubtitle': 'Выберите навыки класса',
  'characterHud.builder.skillsCounter': 'Выбрано',
  'characterHud.builder.skillFromBg': '— предыстория',
  'characterHud.builder.skillFromRace': '— раса',
  'characterHud.builder.reviewTitle': 'Обзор',
  'characterHud.builder.reviewSubtitle': 'Проверьте данные персонажа',
  'characterHud.builder.reviewIdentity': 'Персонаж',
  'characterHud.builder.reviewStats': 'Характеристики',
  'characterHud.builder.reviewCombat': 'Боевые параметры',
  'characterHud.builder.reviewSkills': 'Навыки',
  'characterHud.builder.reviewProficiencies': 'Владения',
  'characterHud.builder.reviewSaves': 'Спасброски',
  'characterHud.builder.reviewErrors': 'Исправьте перед сохранением',
  'characterHud.builder.next': 'Далее',
  'characterHud.builder.prev': 'Назад',
  'characterHud.builder.save': '✓ Сохранить',
  'characterHud.builder.intro': 'Мастер создания персонажа: все выборы 1 уровня по правилам 5e. «Пересоздать» заменит правила этого листа (характеристики, навыки, заклинания; снаряжение — если выберете); портрет, владелец, токены и доска отыгрыша останутся.',
  'characterHud.builder.readOnly': 'Создавать и пересоздавать персонажа может владелец листа или мастер.',
  'characterHud.builder.rebuildTitle': 'Пересоздать персонажа?',
  'characterHud.builder.rebuildDesc': 'Характеристики, навыки, умения и заклинания этого листа заменятся созданными в мастере. Портрет, владелец, токены и доска отыгрыша останутся.',
  'characterHud.builder.rebuildLevel': 'Сейчас персонаж {N} уровня. Мастер создания собирает 1 уровень: после пересоздания лист станет 1 уровня, повысьте его снова ({M} раз) кнопкой «Получить уровень». Не хотите терять уровень — нажмите «Отмена»',
  'characterHud.builder.keepEquipment': 'Оставить нынешнее снаряжение (иначе — стартовое из мастера)',
  'characterHud.builder.saved': 'Персонаж создан!',
  'characterHud.builder.previewPlaceholder': 'Начните заполнять персонажа',
  'characterHud.builder.previewSkills': 'Навыки',
  'characterHud.builder.previewProficiencies': 'Владения',
  'characterHud.builder.previewHp': 'ОЗ',
  'characterHud.builder.previewAc': 'КД',
  'characterHud.builder.previewSpeed': 'Скор',
  'characterHud.builder.errEmptyName': 'Имя персонажа обязательно',
  'characterHud.builder.errNoRace': 'Выберите расу',
  'characterHud.builder.errNoClass': 'Выберите класс',
  'characterHud.builder.errPointBuy': 'Распределите все 27 очков',
  'characterHud.builder.errStandardArray': 'Распределите все значения массива',
  'characterHud.builder.errManualRange': 'Значения характеристик: от 3 до 20',
  'characterHud.builder.errNoBackground': 'Выберите предысторию',
  'characterHud.builder.errSkillsUnder': 'Выберите ещё навыков',
  'characterHud.builder.errSkillsOver': 'Превышен лимит навыков класса',
  'characterHud.builder.confirmOverwrite': 'Создание нового персонажа заменит текущего. Данные отыгрыша, инвентарь и боевые настройки будут потеряны. Продолжить?',
  'characterHud.builder.confirmDiscard': 'У вас есть несохранённые изменения в мастере создания. Закрыть без сохранения?',
  'characterHud.builder.skillOverlap': 'Навык предыстории совпадает с навыком класса — вы получаете дополнительный выбор',

  // === Write Infrastructure (073) ===
  'characterHud.writeTimeout': 'Сервер не ответил, изменения могут быть потеряны',
  'characterHud.sheetDeleted': 'Лист персонажа был удалён',
  'characterHud.writeRejected': 'Изменение отклонено сервером',
  'characterHud.rollTimeout': 'Бросок не подтверждён сервером',
  'characterHud.restShort': 'Короткий отдых',
  'characterHud.restLong': 'Длинный отдых',
  'characterHud.deathSave': 'Спасбросок от смерти',
  'characterHud.deathDying': 'При смерти',
  'characterHud.deathStable': 'Стабилен',
  'characterHud.deathDead': 'Мёртв',
  'characterHud.deathSavesTally': 'Спасброски от смерти: успехи и провалы',
  'characterHud.hitDiceSpend': 'Использовать кость хитов',
  'characterHud.inspirationOn': 'Вдохновение получено',
  'characterHud.inspirationOff': 'Вдохновение потрачено',

  // === Character Mode (066 phase-2) ===
  'characterMode.navIdentity': 'Идентичность',
  'characterMode.navStats': 'Характеристики',
  'characterMode.navSkills': 'Навыки',
  'characterMode.navDefenses': 'Защиты',
  'characterMode.navAbilities': 'Умения',
  'characterMode.navSpells': 'Заклинания',
  'characterMode.navInventory': 'Снаряжение',
  'characterMode.navProficiencies': 'Владения',
  'characterMode.navProgression': 'Прогрессия',
  'characterMode.navResources': 'Ресурсы',
  'characterMode.levelUp': 'Получить {N} уровень',
  'characterMode.rest': 'Отдых',
  'characterMode.hitDie': 'Кость хитов',
  'characterMode.levelUpShort': '↑ {N} ур.',
  'characterMode.passivePerception': 'Пасс. внимательность',
  'characterMode.passiveShort': 'Пасс. вним.',
  'characterMode.passiveInvestigation': 'Пасс. анализ',
  'characterMode.passiveInsight': 'Пасс. проницательность',
  'characterMode.filterAll': 'Все',
  'characterMode.filterProficient': 'С владением',
  'characterMode.filterByAbility': 'По характеристике',
  'characterMode.breakdownTotal': 'Итого',
  'characterMode.breakdownStatMod': 'Модификатор {stat}',
  'characterMode.breakdownProficiency': 'Бонус мастерства',
  'characterMode.breakdownExpertise': 'Экспертиза (×2)',
  'characterMode.breakdownEffects': 'Эффекты',
  'characterMode.breakdownBase': 'База',
  'characterMode.spellDC': 'СЛ заклинаний',
  'characterMode.spellAttack': 'Бонус атаки',
  'characterMode.concentration': 'Концентрация',
  'characterMode.ritual': 'Ритуал',
  'characterMode.prepared': 'Подготовленные',
  'characterMode.known': 'Известные',
  'characterMode.cantrips': 'Заговоры',
  'characterMode.spellLevel': '{N} круг',
  'characterMode.noSpells': 'Заклинания недоступны',
  'characterMode.noFeatures': 'Нет умений',
  'characterMode.noItems': 'Нет предметов',
  'characterMode.weight': 'Вес',
  'characterMode.currency': 'Валюта',
  'characterMode.equipped': 'Надето',
  'characterMode.attunement': 'Привязка',
  'characterMode.armor': 'Броня',
  'characterMode.weapons': 'Оружие',
  'characterMode.tools': 'Инструменты',
  'characterMode.languages': 'Языки',
  'characterMode.currentLevel': 'Текущий уровень',
  'characterMode.levelManualHint': 'Ручная правка: ХП и умения не выдаются — для полного повышения жми «Повысить»',
  'characterMode.nextLevel': 'Следующий уровень',
  'characterMode.xpProgress': '{current} / {required} опыта',
  'characterMode.resistances': 'Сопротивления',
  'characterMode.immunities': 'Иммунитеты',
  'characterMode.vulnerabilities': 'Уязвимости',
  'characterMode.conditions': 'Состояния',
  'characterMode.speeds': 'Скорости',
  'characterMode.senses': 'Сенсы',
  'characterMode.classFeatures': 'Класс',
  'characterMode.raceFeatures': 'Раса',
  'characterMode.feats': 'Фиты',
  'characterMode.allFeatures': 'Все',
  'characterMode.inspiration': 'Вдохновение',
  'characterMode.hitDice': 'Кость хитов',
  'characterMode.mockLevelUp': 'Повышение уровня (демо)',
  'characterMode.search': 'Поиск...',
  'characterMode.proficiencyBonus': 'БМ',
  'characterMode.walkSpeed': 'Шаг',
  'characterMode.unitFt': 'фт.',
  'characterMode.unitLbs': 'фн.',
  'characterMode.unitGp': 'зм',
  'characterMode.armorClass': 'Класс доспеха',
  'characterMode.castingTime': 'Время каста',
  'characterMode.range': 'Дистанция',
  'characterMode.castSpell': 'Использовать {name}',
  'characterMode.slotAriaLabel': 'Ячейки {level} круга: {current} из {max} доступно',
  'characterMode.useAriaLabel': 'Использование {i} из {max}, {status}',
  'characterMode.available': 'доступно',
  'characterMode.spent': 'потрачено',
  'characterMode.shortRest': 'КО',
  'characterMode.longRest': 'ДО',
  'characterMode.asiOrFeat': 'Повышение характеристик / Фит',
  'characterMode.attunementSlot': 'Слот привязки',
  'characterMode.attunementFilled': 'занят',
  'characterMode.attunementEmpty': 'свободен',
  'characterMode.bdModifier': 'модификатор',
  'characterMode.bdValue': 'Значение',
  'characterMode.bdSave': 'спасбросок',
  'characterMode.bdMod': 'Мод.',
  'characterMode.bdProficiency': 'владение',
  'characterMode.bdExpertise': 'экспертиза',
  'characterMode.bdPassive': 'пассивное',
  'characterMode.bdSkillMod': 'модификатор навыка',
  'characterMode.bdBaseAC': 'Базовый КД',
  'characterMode.bdShield': 'щит',
  'characterMode.bdItems': 'предметы',
  'characterMode.bdUnarmored': 'Без доспехов',
  'characterMode.bdArmor': 'Бонус доспеха',
  'characterMode.bdMiscAc': 'Прочий бонус',
  'characterMode.bdEffects': 'Эффекты',
  'characterMode.bdAttack': 'атака',
  'characterMode.bdStatMod': 'Мод. характеристики',
  'characterMode.bdSpellAttack': 'Бонус атаки заклинаниями',

  // === Character Mode: Stat short labels (i18n refactor T101) ===
  'characterMode.stat.str': 'СИЛ',
  'characterMode.stat.dex': 'ЛОВ',
  'characterMode.stat.con': 'ТЕЛ',
  'characterMode.stat.int': 'ИНТ',
  'characterMode.stat.wis': 'МДР',
  'characterMode.stat.cha': 'ХАР',
  'characterMode.saveAbbr': 'спас',
  'characterMode.saveProficiencyHint': 'Владение спасбросками этой характеристики',

  // === Character Mode: Skill labels (i18n refactor T101) ===
  'characterMode.skill.acrobatics': 'Акробатика',
  'characterMode.skill.animalHandling': 'Уход за животными',
  'characterMode.skill.arcana': 'Магия',
  'characterMode.skill.athletics': 'Атлетика',
  'characterMode.skill.deception': 'Обман',
  'characterMode.skill.history': 'История',
  'characterMode.skill.insight': 'Проницательность',
  'characterMode.skill.intimidation': 'Запугивание',
  'characterMode.skill.investigation': 'Анализ',
  'characterMode.skill.medicine': 'Медицина',
  'characterMode.skill.nature': 'Природа',
  'characterMode.skill.perception': 'Внимательность',
  'characterMode.skill.performance': 'Выступление',
  'characterMode.skill.persuasion': 'Убеждение',
  'characterMode.skill.religion': 'Религия',
  'characterMode.skill.sleightOfHand': 'Ловкость рук',
  'characterMode.skill.stealth': 'Скрытность',
  'characterMode.skill.survival': 'Выживание',

  // === Roleplay Mode (066 phase-3) ===
  'roleplay.boardTitle': 'Отыгрыш',
  'roleplay.boardSubtitle': 'Личность и история персонажа',
  'roleplay.cardHero': 'Герой',
  'roleplay.cardTriada': 'Характер',
  'roleplay.cardManners': 'Манеры',
  'roleplay.cardBackstory': 'Предыстория',
  'roleplay.cardGoals': 'Цели',
  'roleplay.cardNpc': 'Знакомые',
  'roleplay.cardFactions': 'Фракции',
  'roleplay.cardSessionLog': 'Журнал сессий',
  'roleplay.cardMoments': 'Ключевые моменты',
  'roleplay.catAll': 'Всё',
  'roleplay.catPersonality': 'Личность',
  'roleplay.catConnections': 'Связи',
  'roleplay.catPast': 'Прошлое',
  'roleplay.catPresent': 'Настоящее',
  'roleplay.catFuture': 'Будущее',
  'roleplay.tagPersonality': 'ЛИЧНОСТЬ',
  'roleplay.tagConnections': 'СВЯЗИ',
  'roleplay.tagPast': 'ПРОШЛОЕ',
  'roleplay.tagPresent': 'НАСТОЯЩЕЕ',
  'roleplay.tagFuture': 'БУДУЩЕЕ',
  'roleplay.done': 'Готово',
  'roleplay.doneEsc': 'Готово · esc',
  'roleplay.spanQuarter': '¼',
  'roleplay.spanThird': '⅓',
  'roleplay.spanHalf': '½',
  'roleplay.spanTwoThirds': '⅔',
  'roleplay.spanFull': 'полная',
  'roleplay.stylePlain': 'обыч',
  'roleplay.styleParchment': 'перг',
  'roleplay.styleDark': 'тёмн',
  'roleplay.addRow': '+ элемент',
  'roleplay.addGoal': '+ цель',
  'roleplay.addNpc': '+ NPC',
  'roleplay.addFaction': '+ фракция',
  'roleplay.addMoment': '+ момент',
  'roleplay.addSession': '+ сессия',
  'roleplay.duplicate': 'Дублировать',
  'roleplay.pin': 'Закрепить',
  'roleplay.unpin': 'Открепить',
  'roleplay.changeType': 'Сменить тип…',
  'roleplay.deleteCard': 'Удалить…',
  'roleplay.deleteConfirmTitle': 'Удалить карточку',
  'roleplay.deleteConfirmDesc': 'Удалить карточку «{title}»? Действие нельзя отменить.',
  'roleplay.changeTypeConfirm': 'Контент текущей карточки будет утерян. Продолжить?',
  'roleplay.momentPrologue': 'пролог',
  'roleplay.momentMinor': 'мелочь',
  'roleplay.momentEncounter': 'столкновение',
  'roleplay.momentDilemma': 'сложный выбор',
  'roleplay.momentRevelation': 'откровение',
  'roleplay.momentTurning': 'поворот',
  'roleplay.momentFinale': 'финал арки',
  'roleplay.relAlly': 'союзник',
  'roleplay.relWarm': 'тепло',
  'roleplay.relNeutral': 'нейтрал',
  'roleplay.relEnemy': 'враг',
  'roleplay.searchPlaceholder': 'Поиск по карточкам…',
  'roleplay.autoLayout': '▭▭ авто',
  'roleplay.addCard': '+ карточка',
  'roleplay.addCardTitle': 'Новая карточка',
  'roleplay.addCardHeading': 'Заголовок',
  'roleplay.addCardType': 'Тип',
  'roleplay.addCardContent': 'Содержимое',
  'roleplay.addCardSize': 'Размер',
  'roleplay.addCardStyle': 'Стиль',
  'roleplay.addCardSubmit': 'Добавить',
  'roleplay.addCardCancel': 'Отмена',
  'roleplay.addCardTitlePlaceholder': 'Заголовок карточки…',
  'roleplay.addCardContentPlaceholder': 'Содержимое…',
  'roleplay.editPlaceholder': 'Нажмите ✎ для редактирования',
  'roleplay.noResults': 'Ничего не найдено',
  'roleplay.emptyBoard': 'Доска пока пуста — добавьте первую карточку кнопкой «+ карточка»: цель, связь, момент истории…',
  'roleplay.labelIdeal': 'Идеал',
  'roleplay.labelBond': 'Связь',
  'roleplay.labelFlaw': 'Изъян',
  'roleplay.priorityArc': 'арка',
  'roleplay.prioritySession': 'сессия',
  'roleplay.sessionNumber': '#{n}',
  'roleplay.sessionLabel': 'сессия',
  'roleplay.placeholderTitle': 'Название...',
  'roleplay.placeholderSummary': 'Описание...',
  'roleplay.placeholderDescription': 'Описание...',
  'roleplay.placeholderName': 'Имя...',
  'roleplay.placeholderNotes': 'Заметки...',
  'roleplay.placeholderFaction': 'Фракция...',
  'roleplay.placeholderGoal': '...',
  'roleplay.dragToReorder': 'Перетащить для перемещения',
  'roleplay.editOptions': 'Опции редактирования карточки',
  'roleplay.removeGoal': 'Удалить цель',
  'roleplay.loyaltyLevel': 'Лояльность {n}',
  'roleplay.footerCount': '{n} записей',

  // === Studio (T008) ===
  // Breadcrumbs
  'studio.breadcrumb.prep': 'Подготовка',
  'studio.topbar.renameCampaign': 'Переименовать кампанию',
  'studio.topbar.unnamed': 'Без названия',
  'studio.topbar.renameFailed': 'Не удалось переименовать кампанию',
  'studio.enter': 'Подготовка',
  'studio.beat.add': 'добавить бит',
  'studio.beat.cycleStatus': 'Сменить статус',
  'studio.rail.search': 'Найти везде, включая вложенное…',
  'studio.sheet.features': 'Черты',
  'studio.sheet.inventory': 'Инвентарь',
  'studio.sheet.gold': 'Золото',
  'studio.workingSet.empty': 'У бита пока нет связанных сущностей — открой из Библиотеки',
  'studio.workspace.placeholder': 'Выбери бит или сущность из Библиотеки',
  'studio.entity.openFull': 'Развернуть целиком',
  'studio.breadcrumb.sessionLabel': 'Сессия {n}',
  // Table button
  'studio.toTable': 'Игра',
  // === Studio AI Assistant (T019) ===
  'studio.ai.title': 'Тиа',
  'studio.ai.groupApplied': 'Применено',
  'studio.ai.accept': 'Принять',
  'studio.ai.reject': 'Отклонить',
  'studio.ai.revert': '⟲ Откатить',
  'studio.ai.badgeConflict': 'конфликт',
  'studio.ai.badgeReview': 'ревью',
  'studio.ai.badgeDraft': 'черновик',
  'tia.status.idle': 'ждёт',
  'tia.status.thinking': 'думает…',
  'tia.status.done': 'готово',
  'tia.status.error': 'не получилось',
  'tia.status.notes.one': 'нашла {n} замечание',
  'tia.status.notes.few': 'нашла {n} замечания',
  'tia.status.notes.many': 'нашла {n} замечаний',
  'tia.say.thinking': 'Смотрю план и квесты…',
  'tia.say.doneN': 'Готово — изменений: {n}.',
  'tia.say.done': 'Готово.',
  'tia.say.error': 'Не получилось. Попробуй ещё раз.',
  'tia.say.noKey': 'Нет ключа модели — Тиа пока не отвечает.',
  'tia.say.notes': 'Замечаний: {n}. Показать?',
  'tia.collapse': 'Свернуть в полосу',
  'tia.expand': 'Развернуть',
  'ai.allowEdits': 'Разрешить изменения',
  'ai.allowEditsHint': 'Сама меняет подготовку и показывает, что изменила. Показ игрокам и удаление всё равно спросит. На кнопки в «Замечаниях» не влияет — нажатие и есть просьба.',
  'ai.placeholderAdvise': 'Спроси Тиа… Тиа только советует — сама ничего не меняет',
  'ai.focus.prefix': 'Тиа смотрит:',
  'ai.focus.beat': 'бит «{name}»',
  'ai.focus.quest': 'квест «{name}»',
  'ai.focus.record': 'запись «{name}»',
  'ai.focus.map': 'карта «{name}»',
  'ai.focus.sheet': 'лист «{name}»',
  'ai.focus.library': 'Библиотека',
  'ai.focus.remarks': 'Замечания',
  'ai.focus.playingNow': '(идёт сейчас)',
  'ai.focus.playing': 'идёт «{name}»',
  'ai.focus.table': 'стол',
  'ai.focus.myMap': 'у тебя карта «{name}»',
  'ai.focus.playersMap': 'у игроков «{name}»',
  'ai.focus.selected': 'выделен {names}',
  'ai.emptyStudio': 'Открой что-нибудь слева — бит, квест, NPC — или переключись в «Игру»: примеры под полем меняются по тому, на что ты смотришь.',
  'ai.chip.beat1': 'Сделай запасной бит на случай, если игроки сбегут',
  'ai.chip.beat2': 'Добавь деталь в подготовку',
  'ai.chip.beat3': 'Что недоделано в этом бите?',
  'ai.chip.quest1': 'Добавь цель',
  'ai.chip.quest2': 'Что открыто по этому квесту?',
  'ai.chip.npc1': 'Набросай описание из подготовки битов',
  'ai.chip.npc2': 'Кто это — коротко',
  'ai.chip.lib1': 'Что недоделано в подготовке?',
  'ai.chip.lib2': 'Что сейчас открыто по квестам?',
  'ai.chip.table1': 'Что сейчас открыто по квестам?',
  'ai.chip.table2': 'Отметь выполненную цель',
  'ai.chip.table3': 'Игроки проиграли — переключи бит',
  'ai.plan.title': 'План:',
  'ai.plan.do': 'Сделать',
  'ai.plan.done': 'Сделано — сводка ниже.',
  'ai.plan.stale.beat': 'Устарело: бит уже сменён',
  'ai.plan.stale.objective': 'Устарело: цель уже отмечена',
  'ai.plan.stale.missing': 'Устарело: чего-то уже нет',
  'ai.plan.stale.gone': 'Устарело — спроси заново',
  'ai.outward.stale': 'Кнопка устарела — спроси Тиа заново',
  'ai.focus.beatN': 'Бит {n}',
  'ai.plan.step.reserve': 'Создам запасной бит «{name}»',
  'ai.plan.step.outcome': 'Развилка «{label}» у «{name}»',
  'ai.plan.step.outcomeBare': 'Развилка у «{name}»',
  'ai.plan.step.note': 'Заметка «{name}»',
  'ai.plan.step.objective': 'Отмечу «{name}» в «{quest}»',
  'ai.plan.step.objectiveBare': 'Отмечу «{name}»',
  'ai.plan.step.current': 'Сделаю текущим «{name}»',
  'ai.plan.step.chronicle': 'Черновик летописи «{name}»',
  'ai.plan.step.edit': 'Изменю «{name}»',
  'ai.plan.step.sheet': 'Изменю лист «{name}»',
  'ai.plan.step.other': '{tool}: «{name}»',
  'ai.plan.step.linkQuest': 'Свяжу квест «{name}»',
  'ai.outward.show': 'Показать игрокам «{name}»',
  'ai.outward.showCaption': 'это увидят игроки',
  'ai.outward.delete': 'Удалить «{name}»',
  'ai.outward.deleteCaption': 'это не отменить',
  'ai.outward.confirmShow': 'Показать игрокам «{name}»?',
  'ai.outward.confirmShowBody': 'Это увидят игроки. Показ не отменить.',
  'ai.outward.confirmDelete': 'Удалить «{name}»?',
  'ai.outward.confirmDeleteBody': 'Это не отменить.',
  'ai.outward.confirmShowButton': 'Показать',
  'ai.outward.confirmDeleteButton': 'Удалить',
  'ai.outward.doneShow': 'Игроки уже видят «{name}» — это не отменить',
  'ai.outward.doneDelete': 'Удалено: «{name}»',
  'ai.outward.running': 'Выполняю…',
  'ai.outward.partial': 'Сделано частично: «{name}» — проверь, чего не хватает',
  'ai.outward.unknown': 'Не знаю, выполнилось ли «{name}» — проверь сам. Повторно не запускаю.',
  'ai.outward.failed': 'Не выполнено: «{name}»',
  'ai.outward.changed': 'С тех пор изменилось — ниже новая кнопка',
  'ai.outward.gone': 'Не выполнено: этого больше нет',
  'ai.outward.already': 'Уже так — делать нечего',
  'ai.outward.saveFailed': 'Не удалось сохранить — ничего не сделано, нажми ещё раз',
  'ai.outward.fromSource': 'Перед этим Тиа читала записи или материалы, которые мог написать кто-то другой — проверь, что именно показываешь',
  'ai.outward.sourceUnknown': 'Не известно, какие материалы видела Тиа перед этим — проверь, что именно показываешь',
  'ai.plan.unknown.all': 'Шаг не удался: записанные изменения откачены, но исход неизвестен — проверь',
  'ai.plan.unknown.partial': 'Шаг не удался: откачено не всё — проверь карточку изменений',
  'ai.plan.unknown.none': 'Шаг не удался: изменения не откачены — проверь карточку изменений',
  'ai.topic.line': 'Тема: {title}',
  'ai.topic.close': 'закрыть тему',
  'ai.topic.discuss': 'Обсудим это замечание',
  'ai.topic.ended': 'Замечание закрыто: {option}.',
  'ai.topic.endedDone': 'Замечание закрыто — сделано, сводка ниже.',
  'ai.topic.closed': 'Тема закрыта. Замечание осталось в списке.',
  'ai.remark.fixLine': 'Исправь: {title}',
  'ai.remark.hintLine': 'Отметить: {title}',
  'aiChange.sheetValue': 'Лист «{name}»: {field}',
  // AI drafts
  'studio.aiDrafts.stub': 'Черновики Тиа',
  'aiDrafts.title': 'Черновики Тиа',
  'aiDrafts.pendingCount': 'Ждут ревью: {count}',
  'aiDrafts.badgeReview': 'ревью',
  'aiDrafts.badgeDraft': 'черновик',
  'studio.aiDrafts.count': 'Ждут ревью',
  // Rail sections
  'studio.rail.plan': 'План',
  'studio.rail.library': 'Библиотека',
  // Beat statuses
  'studio.beat.status.draft': 'Не готов',
  'studio.beat.status.ready': 'Готов',
  'studio.beat.status.played': 'Сыграно',
  'studio.beat.status.carried': 'Отложен',
  'studio.beat.chooseStatus': 'Выбрать статус бита',
  'plan.title': 'План',
  'plan.empty.title': 'Подготовленных битов пока нет',
  'plan.empty.body': 'План показывает биты, подготовленные в Подготовке: читайте подготовку, открывайте NPC и улики, отмечайте, что идёт и что сыграно, — не выходя из игры. Биты создаются в Подготовке.',
  'plan.openStudio': 'Открыть Подготовку',
  'plan.openInStudio': 'Открыть в Подготовке',
  'plan.current.label': 'Идёт',
  'plan.current.none': 'Текущего бита нет',
  'plan.makeCurrent': 'Сделать текущим',
  'plan.endCurrent': 'Закончить бит',
  'plan.pending': 'Ждём подтверждения сервера…',
  'plan.refused': 'Не применено: {reason}',
  'plan.lostAnswer': 'Связь прервалась до ответа сервера. Показано то, что сервер подтвердил.',
  'plan.prep': 'Подготовка',
  'plan.prep.none': 'Подготовки нет',
  'plan.unavailable': 'Удалено — недоступно',
  'plan.map.deleted': 'Карта удалена',
  'plan.map.openHere': 'Открыть у себя',
  'plan.map.show': 'Показать карту игрокам',
  'plan.map.showing': 'Показываем…',
  'plan.maps': 'Карты',
  'mapView.editsSaved': 'правки сохраняются',
  'mapView.viewedDeleted': 'Карту, которую ты смотрел, удалили — ты снова на карте игроков.',
  'plan.next.button': 'Следующий: {beat}',
  'plan.next.last': 'Это последний бит плана',
  'plan.next.markPlayed': 'Отметить сыгранным',
  'plan.next.back': '← Вернуться к «{beat}»',
  'plan.next.another': 'Другой бит…',
  'plan.next.hint': 'Переключает текущий бит только у мастеров. Игрокам ничего не показывается.',
  'plan.list.label': 'План',
  'plan.list.view': 'Посмотреть',
  'plan.list.now': 'идёт',
  'plan.viewing': 'Смотришь: {beat} — не текущий',
  'plan.viewing.back': 'Вернуться к текущему',
  'plan.pick.hint': 'Выбери, с чего продолжить.',
  'plan.sec.quest': 'Квест',
  'plan.sec.maps': 'Карты бита',
  'plan.sec.noMaps': 'Карт нет',
  'plan.sec.notes': 'Заметки бита',
  'plan.sec.npcs': 'NPC бита',
  'plan.sec.quick': 'Быстрая заметка в бит',
  'plan.npc.hint': 'перетащить на карту — токен',
  'plan.quick.add': 'Добавить',
  'plan.quick.into': 'В бит: {beat}',
  'plan.quick.pick': 'Выбери текущий бит',
  'plan.quick.placeholder': 'Игроки подружились с гоблином Йимиком',
  'plan.hint.showMap': 'Показать игрокам основную карту бита, «{map}»?',
  'plan.hint.dismiss': 'Закрыть',
  'map.row.playersHere': 'игроки здесь',
  'map.row.viewing': 'смотришь',
  'map.row.openForMe': 'Открыть у себя',
  'map.row.more': 'Ещё',
  'map.row.playersAlreadyHere': 'Игроки уже здесь',
  'map.row.studioNote': 'Переименовать, порядок, вложение, удалить — в Подготовке',
  'maps.beat.title': 'Карты бита «{beat}»',
  'maps.beat.none': 'Карты бита — нет текущего бита',
  'maps.shared.title': 'Общие карты',
  'maps.others.show': 'Из других битов ({count})',
  'maps.others.hide': 'Скрыть',
  'maps.on.title': 'На карте «{map}»',
  'maps.studioHint': 'Переименование, порядок, вложение и удаление — в Подготовке.',
  'studio.mapMenu.rename': 'Переименовать…',
  'studio.mapMenu.moveUp': 'Выше',
  'studio.mapMenu.moveDown': 'Ниже',
  'studio.mapMenu.nest': 'Вложить в…',
  'studio.mapMenu.delete': 'Удалить…',
  'studio.mapMenu.aiMap': 'Карта от Тиа…',
  'studio.mapMenu.clearDrawings': 'Очистить рисунки',
  'studio.mapMenu.imagePosition': 'Положение картинки…',
  'studio.mapDialog.renameTitle': 'Переименовать карту',
  'studio.mapDialog.nestTitle': 'Вложить карту',
  'studio.mapDialog.parent': 'Родительская карта',
  'studio.mapDialog.topLevel': '— верхний уровень —',
  'studio.mapDialog.positionTitle': 'Положение картинки',
  'studio.mapDialog.moveImage': 'Двигать картинку',
  'studio.mapDialog.moveImageHint': 'Тяни картинку мышью по карте. Esc — выйти.',
  'studio.mapDialog.moveImageActive': 'Двигаем картинку: тяни мышью по карте. Esc — выйти.',
  'studio.mapDialog.save': 'Сохранить',
  'studio.mapDialog.cancel': 'Отмена',
  'studio.mapDialog.nameLabel': 'Название',
  'studio.mapCrumbs.label': 'Путь карты',
  'studio.mapDrawer.open': 'Содержимое карты',
  'studio.mapDialog.px': 'пикс.',
  'beat.next.title': 'Куда дальше',
  'beat.next.outcome': 'Если {label} → {beat}',
  'beat.next.addFork': '＋ Развилка',
  'beat.next.formLabel': 'Новая развилка',
  'beat.next.if': 'Если',
  'beat.next.ifPlaceholder': 'проиграли',
  'beat.next.leadsTo': 'Ведёт в',
  'beat.next.newReserve': '＋ Новый запасной бит',
  'beat.next.reserveName': 'Название запасного бита',
  'beat.next.reservePlaceholder': 'Плен в логове',
  'beat.next.optionMain': 'Бит {n}: {name}',
  'beat.next.optionReserve': 'Запасной: {name}',
  'beat.next.noForks': 'Нет развилок — дальше по порядку плана',
  'beat.next.removeFork': 'Убрать развилку',
  'beat.next.add': 'Добавить',
  'beat.next.cancel': 'Отмена',
  'beat.reserve.pill': 'запасной',
  'beat.reserve.title': 'Запасной бит',
  'beat.reserve.from': 'Развилка из бита «{beat}» — в основной линии плана не стоит',
  'beat.reserve.railCaption': 'Если {label}',
  'mapView.label': 'Карты: ваша и игроков',
  'mapView.youSee': 'У тебя: {name}',
  'mapView.playersSee': 'У игроков: {name}',
  'mapView.together': 'У тебя и у игроков: {name}',
  'mapView.playerSees': 'Игрок видит: {name}',
  'mapView.togetherHint': 'Это карта игроков: правки на ней видны им сразу.',
  'mapView.ownViewHint': 'Личный просмотр: игроки остаются на «{name}». Правки этой карты сохраняются в ней самой — другие мастера видят их сразу, игроки — когда карту им покажут.',
  'mapView.returnToPlayers': 'Вернуться к карте игроков',
  'mapView.show': 'Показать игрокам…',
  'mapView.showing': 'Показываем…',
  'mapView.confirmTitle': 'Показать игрокам «{name}»?',
  'mapView.confirmBody': 'Сейчас игроки на «{current}». В летописи появится черновик «Переход» — игроки его не увидят, пока не опубликуешь.',
  'mapView.confirm': 'Показать',
  'mapView.showWithParty': 'Показать с персонажами ({n})',
  'mapView.showMapOnly': 'Только карту',
  'mapView.shownCarried': 'Перенесено персонажей: {n}',
  'mapView.shownWithoutParty': 'Карта показана без персонажей',
  'mapView.carried': 'перенесено персонажей игроков: {n}',
  'mapView.openPlayersMap': 'Открыть карту игроков',
  'mapView.shown': 'У игроков — «{name}»',
  'mapView.shownDraft': 'Переход — черновиком в летописи: игроки его не видят, пока не опубликуешь.',
  'mapView.backTo': 'Вернуть на «{name}»',
  // Working-set chip labels
  'studio.workingSet.pin': 'Закрепить',
  'studio.workingSet.unpin': 'Открепить',
  // Tabs
  'studio.tabs.noTabs': 'Нет открытых вкладок',
  'studio.tabs.close': 'Закрыть вкладку',
  'studio.tabs.preview': 'Предпросмотр',
  'studio.tabs.suggestedFromBeat': 'Предложено из бита',
  'studio.tabs.kindEntry': 'Запись: {type}',
  'studio.tabs.selected': 'основной просмотр',
  'studio.tabs.beside': 'открыто рядом',
  'studio.tabs.temporary': 'временная вкладка',
  'studio.tabs.playersMap': 'у игроков',
  'studio.ref.named': '{type} «{name}»',
  'studio.side.region': 'Вторая панель: {name}',
  'studio.side.temporary': 'Временный просмотр',
  'studio.side.temporaryHint': 'Следующий объект, открытый с карты, заменит этот. Закрепите, чтобы оставить.',
  'studio.side.pinned': 'Закреплено',
  'studio.side.close': 'Закрыть',
  'studio.full.restore': 'Вернуть две панели',
  'studio.full.restoreLabel': 'Вернуть две панели — рядом: {name}',
  'studio.full.exit': 'Выйти из развёрнутого вида',
  'studio.full.openBeside': 'Открыть рядом',
  'studio.full.openBesideLabel': 'Открыть рядом — выбрать объект для второй панели',
  'studio.full.besidePalette': 'Что открыть во второй панели…',
  'studio.replace.title': 'Заменить закреплённую панель?',
  'studio.replace.body': 'Во второй панели закреплено: {current}. Открыть там {next}? {current} останется во вкладках.',
  'studio.mapMenu.label': 'Действия с картой',
  'studio.mapMenu.noSnapshots': 'Других снимков пока нет',
  // Create from Studio
  'studio.create.entryPrefix': 'Создать запись: ',
  'studio.create.sheetPc': 'Создать лист: персонаж',
  'studio.create.sheetNpc': 'Создать лист: NPC',
  'studio.create.map': 'Создать карту',
  'studio.create.namePrompt': 'Название',
  'studio.create.failed': 'Не удалось создать «{name}»',
  'studio.create.retry': 'Повторить',
  'studio.create.unresolved': 'сервер не смог подтвердить, выполнен ли запрос',
  'studio.create.unresolvedTitle': 'Не удалось выяснить, создан ли «{name}» — проверьте, прежде чем создавать заново',
  'studio.create.goneSince': 'он был создан и уже удалён',
  'studio.rail.create': 'Создать',
  'studio.library.createAny': '＋ Создать…',
  'studio.beat.delete': 'Удалить бит',
  'studio.beat.deleteConfirm': 'Удалить бит? Его заметка в журнале останется.',
  // EntityView
  'studio.entity.cardPreview': 'Превью карты',
  'studio.entity.tokenCount': 'Токенов: {count}',
  'studio.entity.openWorkshop': 'Открыть у себя',
  'studio.entity.openWorkshopHint': 'Выйти из Подготовки и открыть эту карту в игре только у себя. Игроки остаются на своей карте.',
  'studio.entity.snapshots': 'Снимки этой локации',
  'studio.entity.snapshotCreate': '＋ Создать снимок',
  'studio.entity.snapshotCreateHint': 'Сохранить текущее состояние этой карты отдельной картой — снимком этой локации',
  'studio.entity.snapshotPrompt': 'Название снимка',
  // === Studio Map (T003) ===
  'studio.map.empty': 'У этой карты ещё нет изображения',
  'studio.map.legend': 'Легенда',
  // Peek captions
  'studio.peek.ac': 'КД',
  'studio.peek.hp': 'ХП',
  'studio.peek.hpMax': 'Макс. ХП',
  'studio.entry.delete': 'Удалить запись',
  'studio.entry.deleteTitle': 'Удалить «{name}»?',
  'studio.entry.deleteBody': 'Запись исчезнет из журнала, в том числе у игроков. Маркер на карте, если есть, останется без записи. Вернуть нельзя.',
  'studio.peek.speed': 'Скорость',
  'studio.palette.hint': 'Найти · перейти · создать…',
  'studio.palette.placeholder': 'Куда перейти или что создать?',
  'studio.palette.empty': 'Ничего не найдено',
  'studio.palette.createBeat': 'Новый бит',
  'studio.palette.kind.beat': 'бит',
  'studio.palette.kind.sheet': 'лист',
  'studio.palette.kind.journal': 'запись',
  'studio.palette.kind.page': 'карта',
  'studio.palette.kind.action': 'действие',
  'studio.sheet.mentionedIn': 'Упоминается в',
  'studio.beat.one': 'Бит',
  'studio.beat.overview': 'Обзор бита',
  'studio.map.targetMissing': 'Объект недоступен — возможно, он удалён',
  'studio.beat.rename': 'Двойной клик — переименовать',
  'studio.beatPanel.note': 'Источник текста подготовки',
  'studio.beatPanel.none': '— нет —',
  'studio.beatPanel.hint': 'Привяжи заметку — рабочий набор соберётся из её связей',
  'studio.beat.prepEntryName': '{beat} — подготовка',
  'studio.beatPanel.prep': 'Текст подготовки',
  'studio.beatPanel.prepPlaceholder': 'Что происходит в бите: сцена, NPC, зацепки…',
  'studio.beatPanel.prepAdd': '＋ Добавить текст подготовки',
  'studio.beatPanel.prepPending': 'Готовим поле для текста…',
  'studio.beatPanel.prepLoading': 'Загрузка…',
  'studio.beatPanel.prepFailedEntry': 'Не удалось создать запись для текста',
  'studio.beatPanel.prepFailedLink': 'Запись создана, но не привязана к биту',
  'studio.beatPanel.prepFailedToast': 'Текст подготовки «{beat}»: {step}',
  'studio.beatPanel.prepRetry': 'Повторить',
  'studio.beatPanel.prepMissing': 'Запись с текстом этого бита удалена.',
  'studio.beatPanel.prepSource': 'Источник',
  'studio.beatPanel.prepOpen': 'Открыть материал',
  'studio.beatPanel.prepShared': 'Общая запись — тот же текст у: {beats}',
  'studio.beatPanel.prepOtherType': 'Запись типа «{type}»: показана как есть, правится в материале.',
  'studio.materials.title': 'Материалы',
  'studio.materials.empty': 'Здесь собираются материалы бита: NPC, листы, улики. Открытие документа не добавляет его сюда.',
  'studio.materials.add': '＋ Добавить материал',
  'studio.materials.groupUnfold': 'Показать каждого',
  'studio.materials.groupFold': 'Свернуть',
  'studio.bestiary.count': 'Штук',
  'studio.materials.addTo': 'Добавить в «{beat}»',
  'studio.materials.search': 'Поиск по записям и листам…',
  'studio.materials.inBeat': 'в бите',
  'studio.materials.isPrepSource': 'источник подготовки',
  'studio.materials.nothingFound': 'Ничего не найдено',
  'studio.materials.open': 'Открыть',
  'studio.materials.remove': 'Убрать из бита',
  'studio.materials.adding': 'добавляется…',
  'studio.materials.removing': 'убирается…',
  'studio.materials.offline': 'нет связи — отправится, когда она вернётся',
  'studio.materials.addFailed': 'Материал не добавлен',
  'studio.materials.removeFailed': 'Материал не убран',
  'studio.materials.retry': 'Повторить',
  'studio.materials.dismiss': 'Скрыть',
  'studio.materials.unavailable': 'Удалён — его больше нет в кампании',
  'studio.materials.create': '＋ Создать материал',
  'studio.materials.chooseType': 'Тип нового материала:',
  'studio.materials.creating': 'создаётся «{name}»…',
  'studio.materials.createUnknown': 'связь прервалась — исход выясним, когда она вернётся',
  'studio.materials.createUnresolved': 'Сервер не смог подтвердить, создан ли «{name}» — проверьте библиотеку и добавьте его через поиск',
  'studio.materials.close': 'Закрыть',
  'studio.materials.sheetPc': 'Лист игрока',
  'studio.materials.sheetNpc': 'Лист NPC',
  'studio.materials.noOwner': 'без владельца',
  'studio.materials.map': 'Карта',
  'studio.maps.title': 'Карты бита',
  'studio.maps.empty': 'Карт нет. Добавьте карты кампании, нужные биту: вкладки и снимки локации сюда сами не попадают.',
  'studio.maps.primary': 'Основная',
  'studio.maps.playersSee': 'У игроков',
  'studio.maps.deleted': 'Карта удалена',
  'studio.maps.openPrimary': 'Открыть основную карту',
  'studio.maps.primaryDeleted': 'Основная карта удалена',
  'studio.maps.noPrimary': 'Основная не выбрана',
  'studio.maps.open': 'Открыть',
  'studio.maps.beside': 'Рядом',
  'studio.maps.show': 'Показать игрокам…',
  'studio.maps.showing': 'Показываем…',
  'studio.maps.makePrimary': 'Сделать основной',
  'studio.maps.unsetPrimary': 'Снять отметку основной',
  'studio.maps.up': 'Выше',
  'studio.maps.down': 'Ниже',
  'studio.maps.remove': 'Убрать из бита',
  'studio.maps.addPlaceholder': 'Карта кампании…',
  'studio.maps.add': 'Добавить',
  'studio.maps.addAsPrimary': 'Добавить — станет основной',
  'studio.maps.allIn': 'Все карты кампании уже в бите',
  'studio.maps.create': '＋ Новая карта',
  'studio.maps.createPrompt': 'Название новой карты',
  'studio.maps.createPick': 'Выбрать картинку…',
  'studio.maps.createChange': 'Другая картинка…',
  'studio.maps.createNoImage': 'Картинку можно добавить позже',
  'studio.maps.createSubmit': 'Создать карту',
  'studio.maps.creating': 'Создаём карту «{name}»…',
  'studio.maps.createFailed': 'Не удалось создать карту',
  'studio.maps.createUnknown': 'Связь прервалась — после переподключения спросим у сервера, создана ли карта «{name}»',
  'studio.maps.createUnresolved': 'Не удалось выяснить, создана ли карта «{name}». Проверьте карты кампании, прежде чем создавать её снова.',
  'studio.mapImage.upload': 'Загрузить изображение',
  'studio.mapImage.replace': 'Заменить изображение',
  'studio.mapImage.uploading': 'Загружаем «{name}»…',
  'studio.mapImage.saving': 'Сохраняем…',
  'studio.mapImage.offline': 'Связь прервалась — изображение отправим снова после переподключения',
  'studio.mapImage.failed': 'Не удалось поставить «{name}»',
  'studio.mapImage.uploadFailed': 'загрузка не удалась',
  'studio.maps.adding': 'добавляется…',
  'studio.maps.removing': 'убирается…',
  'studio.maps.primaryChanging': 'основная меняется…',
  'studio.maps.moving': 'порядок меняется…',
  'studio.maps.offline': 'нет связи — отправится, когда она вернётся',
  'studio.maps.lost': 'ответ потерян — показано состояние сервера',
  'studio.maps.addFailed': 'Карта не добавлена',
  'studio.maps.removeFailed': 'Карта не убрана',
  'studio.maps.primaryFailed': 'Основная не изменена',
  'studio.maps.moveFailed': 'Порядок не изменён',
  'studio.maps.retry': 'Повторить',
  'studio.maps.dismiss': 'Скрыть',
  'studio.maps.removePrimaryTitle': 'Убрать основную карту «{name}» из бита?',
  'studio.maps.removePrimaryBody': 'Карта останется в кампании. Выберите новую основную или оставьте бит без основной — другая сама не выбирается.',
  'studio.maps.keepNoPrimary': 'Оставить без основной',
  'studio.maps.makeNextPrimary': 'Сделать основной «{name}»',
  'studio.maps.removeConfirm': 'Убрать',
  'studio.maps.cancel': 'Отмена',
  'studio.beatPanel.prepUnknown': 'Связь прервалась до ответа сервера — выясним исход, когда связь вернётся',
  'studio.beatPanel.prepUnresolved': 'Сервер не смог подтвердить, создана ли запись. Если она есть в «Источник текста подготовки» — выберите её там; если нет — создайте новую (созданная раньше, если есть, останется в библиотеке).',
  'studio.beatPanel.prepCreateNew': '＋ Создать новую запись',
  'studio.beatPanel.prepSaveFailed': 'Правка не сохранена',
  'studio.beatPanel.prepResave': 'Сохранить снова',
  'studio.beatPanel.prepOffline': 'Нет связи — текст сохранится, когда она вернётся',
  'studio.library.empty': 'В кампании пока ничего нет — создай через «＋ Создать…» или импортом',
  'studio.library.noteLead': 'Общих записей: {shared}. Спрятано в битах и целях: {nested} (заметки, карты, тексты подготовки)',
  'studio.library.noteFine': 'Создал внутри бита или цели — там и живёт. «В общий список» переносит сюда.',
  'studio.rail.kindPc': 'Персонаж',
  'studio.rail.kindNpcSheet': 'Лист NPC',
  'studio.rail.createSheetPc': '＋ Персонаж',
  'studio.rail.createSheetNpc': '＋ Лист NPC',
  'studio.rail.mapsOnlyInBeats': 'ещё {count} — только в битах',
  'studio.palette.askAssistant': 'Спросить ассистента',
  'studio.workingSet.add': 'Добавить в набор',
  'studio.rail.draftBadge': 'черновик',
  'studio.sheet.pendingDrafts': 'Черновики Тиа · ждут проверки',
  'studio.rail.sheetsPc': 'Листы · персонажи',
  'studio.rail.sheetsNpc': 'Листы · NPC',
  'studio.rail.maps': 'Карты кампании',
  'studio.rail.nested': 'Ещё в битах и квестах ({count})',
  'studio.rail.nestedBeat': 'Бит «{name}»',
  'studio.rail.nestedQuest': 'Квест «{name}»',
  'studio.owner.inBeat': 'в бите «{name}»',
  'studio.owner.inObjective': 'в цели «{name}»',
  'studio.owner.inQuest': 'в квесте «{name}»',
  'studio.owner.toShared': 'В общий список',
  'studio.owner.mapToBeat': 'Только для этого бита',
  'studio.owner.move': 'Убрать в бит / цель',
  'studio.owner.movePick': 'Куда убрать',
  'studio.owner.moveBeatGroup': 'Биты',
  'studio.owner.moveObjectiveGroup': 'Цели квестов',
  'studio.owner.objectiveOption': '{quest} · цель «{objective}»',
  'studio.owner.noteInBeat': '＋ заметка в бит',
  'studio.owner.noteToObjective': '＋ заметка к цели',
  'studio.owner.beatNotes': 'Заметки бита',
  'studio.owner.newNoteName': 'Новая заметка',
  'studio.noteForm.name': 'Название заметки',
  'studio.noteForm.players': 'Видят игроки',
  'studio.noteForm.gm': 'Для мастера',
  'studio.noteForm.done': 'Готово',
  'studio.noteForm.cancel': 'Отмена',
  'studio.owner.failed': 'Не удалось изменить, где лежит запись',
  'studio.owner.secondUseTitle': '«{name}» лежит {place}',
  'studio.owner.secondUseBody': 'Запись лежит только там. «В общий список и добавить» — она станет общей и будет в Библиотеке. «Добавить, оставить где есть» — она останется там и будет использована и здесь. Сама по себе запись не переносится.',
  'studio.owner.secondUseShare': 'В общий список и добавить',
  'studio.owner.secondUseKeep': 'Добавить, оставить где есть',
  'studio.owner.secondUseCancel': 'Отмена',
  'studio.note.playersSee': 'Видят игроки',
  'studio.note.forGm': 'Для мастера',
  'studio.note.typeWord': 'Заметка',
  'studio.note.placeOnMap': 'Поставить на карту',
  'studio.note.placeHint': 'Кликни место, где игроки могут это найти. Маркер сначала виден только тебе.',
  'studio.note.onMapGm': 'на карте · только мастер',
  'studio.note.onMapShown': 'на карте · видна игрокам',
  'studio.note.pinOn': 'Маркер на «{map}»',
  'studio.note.pinOffscreen': 'Маркер на «{map}». Нажми «Карта рядом», чтобы увидеть его.',
  'studio.note.pinPlaced': 'Маркер «{name}» на «{map}» · виден только тебе',
  'studio.note.makeShared': 'В общий список',
  'studio.note.pinTitle': 'Показать маркер на карте',
  'studio.note.dragTitle': 'Перетащи на карту — встанет маркером',
  'studio.note.noMapForPlace': 'У этой заметки нет карты бита, куда её поставить',
  'studio.beat.mapBeside': 'Карта рядом',
  'studio.beat.mapHide': 'Скрыть карту',
  'studio.mapbar.map': 'Карта',
  'studio.mapbar.thisBeat': 'карта этого бита',
  'studio.mapbar.otherBeat': 'не карта этого бита',
  'studio.mapbar.dropHint': 'Перетащи сюда заметку или NPC из бита. Клик по маркеру — бит прокрутится к его заметке.',
  'studio.noteDrop.inBeat': '«{note}» живёт в бите «{beat}»',
  'studio.noteDrop.inObjective': '«{note}» живёт в цели «{objective}»',
  'studio.noteDrop.body': 'Ты ставишь её на карту другого бита — заметка станет нужна в двух местах.',
  'studio.noteDrop.share': 'В общий список и поставить',
  'studio.noteDrop.keep': 'Поставить, оставить в бите',
  'studio.noteDrop.cancel': 'Отмена',
  'pinPopup.show': 'Показать игрокам',
  'pinPopup.shown': 'Видна игрокам',
  'pinPopup.tick': 'Отметить цель «{objective}»',
  'pinPopup.objectiveDone': 'Цель отмечена',
  'pinPopup.hint': 'Две отдельные кнопки: показ игрокам не отмечает цель, и наоборот.',
  'pinPopup.confirmTitle': 'Показать «{name}» игрокам?',
  'pinPopup.confirmBody': 'Игроки увидят маркер и часть «Видят игроки».',
  'pinPopup.confirm': 'Показать',

  // === Studio Start Screen (T001) ===
  // Doors
  'studio.start.tell.title': 'Рассказать историю',
  'studio.start.tell.desc': 'Опиши сцену или замысел — ассистент соберёт черновики сущностей',
  'studio.start.load.title': 'Загрузить кампанию',
  'studio.start.load.desc': 'Импортируй текст, заметки или файл — извлечём NPC, локации и квесты',
  'studio.start.first.title': 'Создать первый бит',
  'studio.start.first.desc': 'Начать вручную: назвать бит и писать текст подготовки прямо в обзоре',
  // Bulk review — group labels
  'studio.start.bulk.group.npc': 'NPC',
  'studio.start.bulk.group.location': 'Локации',
  'studio.start.bulk.group.note': 'Заметки',
  'studio.start.bulk.group.journal': 'Записи журнала',
  'studio.start.bulk.group.encounter': 'Столкновения',
  // Bulk review — selected/total counter
  'studio.start.bulk.selected': 'Выбрано {selected} из {total}',
  // Bulk review — confidence buckets
  'studio.start.bulk.conf.high': 'Высокая уверенность (≥80%)',
  'studio.start.bulk.conf.mid': 'Средняя уверенность (50–79%)',
  'studio.start.bulk.conf.low': 'Низкая уверенность (<50%)',
  // Bulk review — action buttons
  'studio.start.bulk.apply': 'Применить {count}',
  'studio.start.bulk.reject': 'Отклонить {count}',
  // Maps banner (E5)
  'studio.start.maps.banner': '{count} локаций без карт — создать карты и сгенерировать изображения?',
  'studio.start.maps.action': 'Создать карты',

  // === Studio Digest (T004) ===
  'studio.digest.button': 'Дайджест',
  'studio.digest.loading': 'Собираю дайджест…',
  'studio.digest.success': 'Готово: {count} черновиков',
  'studio.digest.empty': 'Нет новых черновиков',
  'studio.digest.error': 'Не удалось собрать дайджест',
  'characters.nested': 'Ещё в битах ({count})',
  'characters.manageHint': 'Владелец, папка, публичные поля и удаление — в Подготовке',
  'studio.sheet.manage': 'Управление листом',
  'studio.sheet.owner': 'Владелец',
  'studio.sheet.noOwner': 'Без владельца',
  'studio.sheet.group': 'Папка',
  'studio.sheet.publicFields': 'Публичные поля…',
  'studio.sheet.delete': 'Удалить лист…',
  'sidebar.map.heading': 'Карта',
  'journal.form.quest.followsFrom': 'Вытекает из',
  'journal.form.quest.followsObjective': 'после цели',
  'journal.form.quest.followsAnyObjective': 'любой цели',
  'journal.chain.followsFrom': 'Вытекает из',
  'journal.chain.afterObjective': 'после цели «{name}»',
  'journal.chain.next': 'Дальше:',
  'journal.quest.from': 'от {name}',
  'studio.quest.wherePlan': 'Где в плане',
  'studio.quest.notInPlan': 'Пока ни в одном бите',
  'studio.rail.bestiary': 'Бестиарий',
  'studio.rail.bestiarySearch': 'Найти в бестиарии',
  'studio.mode.label': 'Режим',
  'studio.mode.prep': 'Подготовка',
  'studio.mode.play': 'Игра',
  'timeline.form.atWorldTime': 'на текущее время мира',
  'timeline.form.autoLinked': 'Авто-событие — связано само: {what}',
  'timeline.form.autoLinkedTime': 'смена времени',
  'timeline.cursor.worldHeading': 'В мире',
  'timeline.cursor.nextDayPart': 'Следующий день · {part}',
  'sidebar.map.playerHint': 'Игрок видит только карту, которую ему показали.',
  'timeline.form.changedMeanwhile': 'Событие изменилось, пока вы его правили, — форма закрыта, ничего не отправлено',
  'studio.rail.groupMenu': 'Папка: действия',
  'studio.rail.groupRename': 'Переименовать…',
  'studio.rail.groupDelete': 'Удалить папку (листы останутся без папки)',
  'journal.editor.group': 'Раздел',
  'studio.sheet.renameGroup': 'Переименовать папку',
  'studio.sheet.deleteGroup': 'Удалить папку',
  'studio.sheet.renameGroupPrompt': 'Новое имя папки',
  'studio.sheet.deleteGroupConfirm': 'Удалить папку «{name}»? Листы останутся без папки.',
  'journal.panel.sharedHint': 'Только общее: квесты (с прогрессом целей), NPC, сведения о мире.',
  'journal.panel.playerHint': 'Квесты, NPC и сведения о мире, которые открыл мастер.',
  'journal.panel.nestedHint': 'Заметки битов, целей и карт не лежат в общем списке — по клику, как в Подготовке.',
  'characters.description': 'Персонажи игроков и общие NPC. Монстры столкновения — в бите.',
  'journal.chain.change': 'Изменить',
  'studio.materials.quests': 'Квесты бита',
  'studio.bestiary.more': 'Показано {shown} из {total} — уточните поиск',
  'studio.bestiary.add': '＋ на карту',
  'studio.bestiary.addTo': 'Добавить на карту «{map}»',
  'studio.bestiary.noMap': 'Сначала откройте карту — вкладкой или «Карта рядом»',
  'studio.bestiary.ruHint': 'Названия монстров английские — ищите по-английски (например, goblin).',
  'studio.sheet.ownerConfirmTitle': 'Отдать «{name}» игроку {player}?',
  'studio.sheet.ownerConfirmDesc': 'Он увидит лист целиком.',
  'studio.sheet.ownerConfirm': 'Отдать',
  'remarks.rail': 'Замечания',
  'remarks.none': 'нет',
  'remarks.heading': 'Замечания',
  'remarks.configure': 'Настроить',
  'remarks.hint': 'Всё, что выглядит недоделанным или противоречивым. С пометкой «мнение Тиа» может оказаться ошибкой — такое удобнее обсудить. Пока не нажмёшь, ничего не меняется.',
  'remarks.pill.game': 'по игре',
  'remarks.pill.gameStale': 'по игре · устарело',
  'remarks.pill.opinion': 'мнение Тиа',
  'remarks.mark': 'Отметить',
  'remarks.no': 'Не надо',
  'remarks.discuss': 'Обсудить',
  'remarks.leave': 'Оставить как есть',
  'remarks.asIntended': 'Так задумано',
  'remarks.empty': 'Замечаний нет.',
  'remarks.leftAsIs': 'Оставлено как есть: {n}. Не напомню, пока эти записи не изменятся.',
  'remarks.footer': 'Исправления отсюда тоже приходят сводкой в чат — отменять в одном месте.',
  'remarks.checkPrep': 'Проверить подготовку',
  'remarks.checkPrepBusy': 'Проверяю…',
  'remarks.checkPrepFailed': 'Проверка не удалась. Попробуй ещё раз.',
  'remarks.badge.one': '{n} замечание — открыть',
  'remarks.badge.few': '{n} замечания — открыть',
  'remarks.badge.many': '{n} замечаний — открыть',
  'remarks.settings.title': 'Для этой кампании',
  'remarks.sw.game': 'Подсказки по игре',
  'remarks.sw.gameHint': '«кажется, цель уже выполнена» — по чату и летописи',
  'remarks.sw.prep': 'Подсказки по подготовке',
  'remarks.sw.prepHint': 'противоречия и забытое',
  'remarks.sw.fixes': 'Предлагать исправление',
  'remarks.sw.fixesHint': 'кнопка у замечания',
  'remarks.sw.simple': 'Простые проверки',
  'remarks.sw.simpleHint': 'дубли, пустые поля, битые ссылки — без Тии',
  'remarks.sw.off': ' · выключено: Тиа этим не занимается',
  'remarks.fix.duplicate': 'Удалить запись',
  'remarks.fix.fieldMisuse': 'Перенести в описание',
  'remarks.fix.emptyPrep': 'Набросать подготовку',
  'remarks.fix.emptyNpc': 'Собрать описание',
  'remarks.fix.brokenLink': 'Убрать ссылку',
  'remarks.fix.model': 'Исправить',
  'remarks.kind.quest': 'квест',
  'remarks.kind.record': 'запись',
  'remarks.t.duplicate': '«{a}» повторяет {kind} «{b}»',
  'remarks.t.emptyPrep': 'Подготовка бита «{beat}» пустая',
  'remarks.t.emptyNpc': 'У «{npc}» нет описания',
  'remarks.t.fieldMisuse': 'В наградах «{quest}» записано условие',
  'remarks.t.brokenLink': '«{owner}»: ссылка на удалённое',
  'remarks.b.duplicate': 'Текст совпадает слово в слово.',
  'remarks.b.emptyPrep': 'Играть по этому биту пока не по чему.',
  'remarks.b.emptyNpc': 'Игроки спросят, кто это.',
  'remarks.b.fieldMisuse': 'Условие место в описании, а не в наградах.',
  'remarks.b.brokenLink': 'Ссылка ведёт в никуда.',
  'remarks.game.body': 'Отметить цель «{obj}» в квесте «{quest}»?',
  'remarks.confirm.delete': 'Удалить запись «{a}»? Её текст остаётся в «{b}».',
  'remarks.confirm.deleteBtn': 'Удалить',
  'remarks.ask.prep': 'Набросай подготовку бита «{beat}»',
  'remarks.ask.npc': 'Собери описание «{npc}» из подготовки битов',
  'remarks.discussMsg': 'Обсудим это замечание',
  'remarks.hint.line': 'Тиа: {reason} — отметить?',
  'remarks.hint.marked': 'Цель отмечена — отменить можно в чате',
  'remarks.summary.line': 'Подсказки по игре: {n} — открыть «Замечания»',
  'remarks.lk.beat': 'бит «{name}»',
  'remarks.lk.quest': 'квест «{name}»',
  'remarks.lk.record': 'запись «{name}»',
  'remarks.lk.sheet': 'лист «{name}»',
  'remarks.lk.npc': 'NPC «{name}»',
  'remarks.lk.page': 'карта «{name}»',
  'search.open': 'Поиск',
  'search.placeholder.gm': 'Найти запись, карту, бит, лист, монстра, правило или действие…',
  'search.placeholder.player': 'Найти запись, карту, свой лист, событие летописи или правило…',
  'search.empty': 'Ничего не найдено по «{q}»',
  'search.emptyScope.gm': 'Ищу в записях (и вложенных в биты и цели), картах, битах, листах, летописи, бестиарии и справочнике правил; опечатки прощаю.',
  'search.emptyScope.player': 'Ищу в том, что вам открыто: записи, карта игроков, ваши листы, летопись и справочник правил; опечатки прощаю.',
  'search.loadingSrd': 'Загружаю бестиарий и правила…',
  'search.keys': '↑↓ выбрать · Enter открыть · → действия · Esc закрыть',
  'search.group.recent': 'Недавнее и открытое',
  'search.group.action': 'Действия',
  'search.group.beat': 'Биты',
  'search.group.journal': 'Записи',
  'search.group.page': 'Карты',
  'search.group.sheet': 'Листы',
  'search.group.token': 'Токены',
  'search.group.timeline': 'Летопись',
  'search.group.monster': 'Бестиарий',
  'search.group.spell': 'Заклинания',
  'search.group.condition': 'Состояния',
  'search.group.item': 'Снаряжение и предметы',
  'search.act.toMap': 'На карту',
  'search.act.toBeat': 'В бит',
  'search.act.beside': 'Открыть рядом',
  'search.act.openHere': 'Открыть у себя',
  'search.act.show': 'Показать игрокам…',
  'search.act.reveal': 'Показать игрокам…',
  'search.hint.current': 'идёт',
  'search.hint.open': 'открыта',
  'search.hint.players': 'у игроков',
  'search.hint.cantrip': 'заговор',
  'search.hint.level': '{n} ур.',
  'search.cmd.toPrep': 'Подготовка',
  'search.cmd.toPlay': 'Игра',
  'search.cmd.openJournal': 'Открыть журнал',
  'search.cmd.openMaps': 'Открыть карты',
  'search.cmd.openChronicle': 'Открыть летопись',
  'search.cmd.openRules': 'Открыть справочник правил',
  'search.cmd.openPlan': 'Открыть план',
  'search.srd.noMap': 'Нет открытой карты — откройте карту, чтобы поставить монстра',
  'search.srd.close': 'Закрыть',
  'search.srd.loading': 'Загружаю…',
  'search.srd.failed': 'Не удалось загрузить статью',
  'search.maps.find': 'Найти карту…',
  'search.hint.npc': 'NPC',
  'images.title': 'Изображения',
  'images.titleBusy': 'Изображения · генерируется: {n}',
  'images.filter.all': 'Все',
  'images.filter.map': 'Карты',
  'images.filter.portrait': 'Портреты',
  'images.filter.chat': 'Чат',
  'images.filter.other': 'Другое',
  'images.what.map': 'карта',
  'images.what.portrait': 'портрет',
  'images.what.chat': 'картинка в чате',
  'images.what.token': 'токен',
  'images.what.other': 'изображение',
  'images.empty': 'Сгенерированных изображений пока нет.',
  'images.emptyFilter': 'Здесь пока ничего нет.',
  'images.generating': 'Генерируется…',
  'images.failed': 'Не получилось',
  'images.failedShort': 'Не получилось',
  'images.offline': 'Сеть недоступна',
  'images.retry': 'Повторить',
  'images.open': 'Открыть',
  'images.copyPrompt': 'Скопировать промпт',
  'images.copied': 'Промпт скопирован',
  'images.variant': 'Ещё вариант',
  'images.more': 'Ещё действия',
  'images.delete': 'Удалить…',
  'images.deleteTitle': 'Удалить изображение?',
  'images.deleteBody': 'Файл будет стёрт, вернуть его нельзя.',
  'images.deleteChatBody': 'Файл будет стёрт, вернуть его нельзя. В чате вместо картинки останется «Изображение удалено».',
  'images.deleteConfirm': 'Удалить',
  'images.inUse': 'Нельзя удалить — используется: {places}. Сначала уберите его оттуда.',
  'images.back': '← Все изображения',
  'images.field.kind': 'Вид',
  'images.field.prompt': 'Промпт',
  'images.field.userPrompt': 'Дополнительно',
  'images.field.described': 'Описание',
  'images.describedByAi': 'составлено ИИ',
  'images.field.style': 'Стиль',
  'images.field.model': 'Модель',
  'images.field.size': 'Размер',
  'images.field.author': 'Автор',
  'images.field.time': 'Время',
  'images.field.usedIn': 'Где используется',
  'images.field.error': 'Ошибка',
  'images.usedIn.page': 'карта «{name}»',
  'images.usedIn.sheet': 'портрет листа «{name}»',
  'images.usedIn.token': 'токен «{name}»',
  'images.usedIn.journal': 'запись «{name}»',
  'images.usedIn.chat-message': 'сообщение в чате',
  'images.notUsed': 'нигде',
  'images.toast.ready': 'Готово: {what}',
  'images.toast.failed': 'Не получилось: {what}',
  'images.toast.portraitNotSet': 'Портрет для «{name}» готов, но на листе уже другой',
  'images.setPortrait': 'Поставить',
  'images.use': 'Использовать как…',
  'images.use.portrait': 'Портрет листа',
  'images.use.token': 'Картинка токена',
  'images.use.map': 'Изображение карты',
  'images.use.hint.noMap': 'без карты',
  'images.use.kind.sheet': 'лист',
  'images.use.kind.token': 'токен',
  'images.use.kind.page': 'карта',
  'images.use.hint.players': 'у игроков',
  'images.use.hint.current': 'эта карта',
  'images.use.hint.noImage': 'без картинки',
  'images.use.hint.noPortrait': 'без портрета',
  'images.use.hint.npc': 'NPC',
  'images.use.hint.pc': 'персонаж игрока',
  'images.use.scope': 'Ищутся листы и токены этой карты.',
  'images.use.placeholder': 'Куда поставить картинку…',
  'images.use.suggested': 'Подходит',
  'images.use.done': 'Поставлено: {what}',
  'images.use.mapTitle': 'Заменить карту «{name}»?',
  'images.use.mapBody': 'Картинка станет изображением карты. Рисунки на этой карте будут стёрты.',
  'images.use.mapConfirm': 'Заменить',
  'images.chatDeleted': 'Изображение удалено',
  'portraitGen.open': 'Сгенерировать портрет',
  'portraitGen.fromSheet': 'Из листа',
  'portraitGen.extra': 'Дополнительно',
  'portraitGen.extraPlaceholder': 'Например: шрам над левым глазом, плащ с капюшоном',
  'portraitGen.style': 'Стиль',
  'portraitGen.style.fantasy painting': 'Фэнтези-живопись',
  'portraitGen.style.ink sketch': 'Набросок тушью',
  'portraitGen.style.watercolor': 'Акварель',
  'portraitGen.style.anime': 'Аниме',
  'portraitGen.style.photorealistic': 'Фотореализм',
  'portraitGen.create': 'Создать',
  'portraitGen.hint': 'Портрет встанет на лист сам, когда будет готов. Прогресс — на иконке «Изображения».',
  'portraitGen.describe': 'Составить описание с ИИ',
  'portraitGen.describeAgain': 'Составить заново',
  'portraitGen.describing': 'Составляю описание…',
  'portraitGen.description': 'Описание',
  'portraitGen.resetToSheet': 'Вернуть из листа',
  'portraitGen.describedHint': 'Составлено ИИ по листу и «Дополнительно», на английском — так модель картинок понимает точнее. Можно править: в генерацию уйдёт этот текст.',
  'aiMap.background': 'Окно закроется сразу: изображение встанет на эту карту само, когда будет готово. Прогресс — на иконке «Изображения».',
  'images.before': 'Было',
  'images.after': 'Стало',
  'images.reject': 'Отклонить',
  'images.accept': 'Принять',
  'images.compare': 'Сравнить',
  'images.toast.compare': 'Готово — сравнить: {what}',
  'images.toast.notPlaced': 'Готово: {what} — не поставлено, карта изменилась',
  'images.placeMapWarn': '«Поставить» заменит изображение карты.',
  'images.placeMapWarnDrawings': '«Поставить» заменит изображение карты и сотрёт рисунки на ней ({n}).',
  'images.placePortraitWarn': '«Поставить» заменит портрет листа.',
  'images.inUseHidden': 'Нельзя удалить — изображение используется.',
  'images.sketchLost': 'Эскиз не сохраняется — «Ещё вариант» делается по тексту.',
  'images.usedIn.note': 'заметка «{name}»',
  'images.usedIn.alert': 'эффект «{name}»',
  'images.usedIn.beat': 'бит «{name}»',
  'images.usedIn.timeline': 'летопись «{name}»',
  'images.edit.inpaint': 'Кисть',
  'images.edit.outpaint': 'Расширение карты',
  'images.edit.detail': 'Детализация «{name}»',
  'images.edit.acceptDetail': 'Принять — новая карта',
  'images.edit.replaceLinked': 'Обновить «{name}»',
  'images.edit.started': 'Генерируется — окно сравнения откроется по готовности',
  'sb.more': 'Ещё',
  'sb.cancel': 'Отмена',
  'sb.expand': 'Развернуть',
  'sb.collapse': 'Свернуть',
  'sb.collapseAll': 'Свернуть все',
  'sb.showMore': 'Показать ещё {n}',
  'sb.showLess': 'Свернуть до {n}',
  'sb.nothingFound': 'Ничего не нашлось',
  'sb.filter': 'Фильтр',
  'sb.chip.all': 'Все',
  'sb.gmOnly': 'Только мастер — игроки не видят',
  'sb.playersSee': 'Видят игроки',
  'sb.hidden': 'Скрытые уровни пути',
  'sb.plan.openBeatInPrep': 'Открыть бит в Подготовке',
  'sb.plan.openQuestInPrep': 'Открыть квест в Подготовке',
  'sb.plan.current': 'Идёт:',
  'sb.note.open': 'Открыть',
  'sb.note.reveal': 'Показать игрокам',
  'sb.note.hide': 'Скрыть от игроков',
  'sb.removeFromBeat': 'Убрать из бита',
  'sb.removedFromBeat': '«{name}» убрано из бита',
  'sb.undo': 'Отменить',
  'sb.delete': 'Удалить…',
  'sb.deleteYes': 'Удалить',
  'sb.note.deleteTitle': 'Удалить заметку «{name}»?',
  'sb.note.deleteBody': 'Заметка живёт только в этом бите и пропадёт совсем.',
  'sb.sheet.open': 'Открыть лист',
  'sb.sheet.npcKind': 'лист NPC',
  'sb.plan.list': 'Биты',
  'sb.map.youHere': 'у тебя',
  'sb.maps.others': 'Из других битов',
  'sb.pins': 'Маркеры',
  'sb.objects': 'Объекты',
  'sb.map.openTip': '{name} — открыть у себя',
  'sb.map.find': 'Найти карту',
  'sb.map.addToken': 'Добавить токен',
  'sb.map.addPin': 'Поставить маркер',
  'sb.map.addObject': 'Создать объект',
  'sb.map.noObjects': 'На этой карте объектов нет.',
  'sb.map.noTokens': 'Токенов нет.',
  'sb.map.youAre': 'ты здесь',
  'sb.map.playerHint': 'Видна только карта, которую показал мастер.',
  'sb.map.playerTitle': 'Карта',
  'sb.tok.find': 'Найти на карте',
  'sb.tok.hide': 'Скрыть от игроков',
  'sb.tok.show': 'Показать игрокам',
  'sb.tok.deleteTitle': 'Удалить токен «{name}»?',
  'sb.tok.deleteBody': 'Токен пропадёт с карты у всех. Лист персонажа останется.',
  'sb.tok.mine': 'твой',
  'sb.tok.presets': 'Быстрый токен',
  'sb.pin.open': 'Открыть заметку',
  'sb.pin.edit': 'Править маркер',
  'sb.pin.deleteTitle': 'Удалить маркер?',
  'sb.pin.deleteBody': 'Маркер пропадёт с карты. Заметка останется.',
  'sb.obj.edit': 'Править объект',
  'sb.rail.title': 'Подготовка',
  'sb.rail.create': 'Создать… (бит, запись, карту, лист)',
  'sb.rail.createBeat': 'Бит',
  'sb.rail.createEntry': 'Запись Библиотеки…',
  'sb.rail.createMap': 'Карту',
  'sb.rail.createPc': 'Персонажа',
  'sb.rail.createNpc': 'Лист NPC',
  'sb.rail.collapseAll': 'Свернуть все секции',
  'sb.rail.addBeat': 'Добавить бит',
  'sb.rail.rename': 'Переименовать',
  'sb.rail.up': 'Выше',
  'sb.rail.down': 'Ниже',
  'sb.rail.pin': 'Открыть закреплённой вкладкой',
  'sb.rail.sheets': 'Листы персонажей',
  'sb.rail.newMap': 'Новая карта',
  'sb.rail.onlyInBeats': 'Только в битах',
  'sb.rail.beatN': 'бит {n}',
  'sb.rail.openRemarks': 'Открыть замечания',
  'sb.tl.world': 'В мире',
  'sb.tl.whatWas': 'Что было',
  'sb.tl.session': 'Сессия {number}',
  'sb.tl.noSession': 'Без сессии',
  'sb.tl.now': 'сейчас в мире',
  'sb.tl.stuckSession': 'сессия {number}',
  'sb.tl.showSession': 'Показать сессию {label} ({count})',
  'sb.tl.earlier': 'раньше — ещё сессий: {count}',
  'sb.tl.onlyCurrent': 'Оставить только текущую сессию',
  'sb.tl.desc': 'описание',
  'sb.tl.gmOnly': 'только мастер',
  'sb.tl.onlyPlayers': 'только: {names}',
  'sb.tl.edit': 'Править',
  'sb.tl.showAll': 'Показать всем игрокам…',
  'sb.tl.toGm': 'Только мастер',
  'sb.tl.toPlayers': 'Выбранным игрокам…',
  'sb.tl.link': 'Связать с записью…',
  'sb.tl.deleteTitle': 'Удалить событие «{title}»?',
  'sb.tl.deleteBody': 'Событие пропадёт из летописи у всех.',
  'sb.tl.publish': 'Опубликовать — игроки увидят',
  'sb.tl.accept': 'Принять — игроки увидят',
  'sb.tl.reject': 'Отклонить…',
  'sb.tl.remove': 'Убрать',
  'sb.tl.draft': 'черновик',
  'sb.tl.gmAuthor': 'мастер',
  'sb.tl.findGm': 'Найти событие или черновик',
  'sb.tl.find': 'Найти событие',
  'sb.tl.filters': 'Фильтры (тип, тег, сессия)…',
  'sb.tl.addToDay': 'Добавить событие в этот день',
  'sb.tl.waitingGm': 'ждёт мастера',
  'sb.fx.own': 'Свои эффекты',
  'sb.fx.runAll': 'Запустить у всех',
  'sb.fx.edit': 'Править эффект',
  'sb.fx.auto': 'Срабатывает сам',
  'sb.fx.dragHint': '{name} — править; перетащи, чтобы поменять порядок',
  'sb.stickers': 'Стикеры',
  'sb.stickers.create': 'Создать пак стикеров',
  'sb.stickers.connect': 'Подключить пак',
  'sb.srd.find': 'Найти в справочнике',
  'sb.srd.open': 'Открыть статблок',
  'sb.srd.place': 'Поставить на карту',
  'sb.srd.placeWithSheet': 'Поставить с листом NPC',
  'sb.hb.import': 'Импортировать homebrew',
  'sb.char.create': 'Создать персонажа — мастер создания',
  'sb.char.createBlank': 'Пустой лист — заполнить вручную',
  'sb.char.pcs': 'Персонажи игроков',
  'sb.char.npcs': 'NPC',
  'sb.char.mine': 'Мои персонажи',
  'sb.char.inBeats': 'Внутри битов',
  'sb.char.inBeatsInfo': 'Монстры и NPC, которые живут в бите (столкновения). Открываются по клику, как в Подготовке.',
  'sb.char.inFolder': 'Создать в папке «{name}»',
  'sb.char.owner': 'игрок {name}',
  'sb.char.myOwn': 'твой лист',
  'sb.char.show': 'Показать лист игрокам',
  'sb.char.hide': 'Скрыть лист от игроков',
  'sb.char.playersSee': 'Лист видят игроки',
  'sb.char.hidden': 'Лист скрыт от игроков',
  'sb.char.card': 'Карточка на сцене: {state}',
  'sb.char.manageNote': 'Владелец, папка, публичные поля и удаление — в Подготовке',
  'sb.char.dragHint': '{name} — открыть лист; перетащи на карту — токен',
  'sb.journal.find': 'Найти в журнале',
  'sb.journal.create': 'Создать запись',
  'sb.journal.open': 'Открыть',
  'sb.journal.edit': 'Править',
  'sb.journal.reveal': 'Показать игрокам…',
  'sb.journal.hide': 'Скрыть от игроков',
  'sb.journal.shownToggle': 'Видят игроки. Нажать — скрыть от игроков',
  'sb.journal.hiddenToggle': 'Скрыто от игроков. Нажать — показать игрокам…',
  'sb.journal.pin': 'Закрепить сверху',
  'sb.journal.unpin': 'Открепить',
  'sb.journal.pinned': 'Закреплено сверху',
  'sb.journal.setSection': 'Раздел…',
  'sb.journal.sectionTitle': 'Раздел записи «{name}»',
  'sb.journal.sectionLabel': 'Раздел',
  'sb.journal.sectionHint': 'Пусто — запись без раздела.',
  'sb.journal.deleteTitle': 'Удалить запись «{name}»?',
  'sb.journal.deleteBody': 'Запись пропадёт из кампании у всех. Ссылки на неё в битах и маркерах станут пустыми.',
  'sb.journal.playersSee': 'Видят игроки',
  'sb.journal.personal': 'Личная заметка игрока',
  'sb.journal.playerEmpty': 'Мастер пока ничего не показал. Записи появятся здесь, когда мастер их откроет.',
  'sb.section.rename': 'Переименовать раздел…',
  'sb.section.renameTitle': 'Переименовать раздел «{name}»',
  'sb.section.remove': 'Убрать раздел (записи останутся)',
  'sb.section.menu': 'Раздел: действия',
  'sb.nested': 'Внутри битов и целей',
  'sb.type.quest': 'Квесты',
  'sb.type.npc': 'NPC',
  'sb.type.location': 'Локации',
  'sb.type.faction': 'Фракции',
  'sb.type.handout': 'Документы',
  'sb.type.lore': 'Мир',
  'sb.quests.active': 'Активные',
  'sb.quests.completed': 'Завершённые',
  'sb.quests.failed': 'Проваленные',
  'sb.quests.hidden': 'Скрытые',
};
